// src/translations/en.json
var en_default = {
  close: "Close",
  switch: "Switch",
  previous: "Previous",
  next: "Next",
  back: "Back",
  refresh: "Refresh",
  newVersionAvailable: "A new version is available",
  loading: "Loading",
  email: "Email",
  password: "Password",
  or: "Or",
  send: "Send",
  sending: "Sending",
  resetting: "Resetting",
  cancel: "Cancel",
  copyFailed: "Failed to copy to clipboard",
  confirm: "Confirm",
  done: "Done",
  add: "Add",
  edit: "Edit",
  filter: "Filter",
  dragToDismiss: "Drag down to dismiss",
  sort: {
    title: "Sort",
    sortBy: "Sort by",
    order: "Order",
    ascending: "Ascending",
    descending: "Descending"
  },
  save: "Save",
  delete: "Delete",
  disable: "Disable",
  select: "Select",
  noResults: "No results found",
  selectTrim: "Select trim",
  yes: "Yes",
  no: "No",
  ago: "ago",
  on: "on",
  unknown: "Unknown",
  never: "Never",
  poweredBy: "Powered by",
  selectAll: "Select All",
  deselectAll: "Deselect All",
  openToSeeOptions: "Open to see options",
  selectedItems: "{{count}} selected",
  changeLanguage: "Change language",
  uploadImage: "Upload image",
  switchToLightMode: "Switch to light mode",
  switchToDarkMode: "Switch to dark mode",
  clickToCopy: "Click to copy",
  copyLink: {
    linkToCopy: "Link to copy",
    copyToClipboard: "Copy to clipboard"
  },
  error: {
    unexpected: "An unexpected error occurred"
  },
  timeUnits: {
    year_other: "years",
    year_one: "year",
    month_other: "months",
    month_one: "month",
    day_other: "days",
    day_one: "day",
    hour_one: "hour",
    hour_other: "hours",
    minute_one: "minute",
    minute_other: "minutes",
    hour_abv_one: "hr",
    hour_abv_other: "hrs",
    minute_abv_one: "min",
    minute_abv_other: "mins"
  },
  distanceUnits: {
    mi_one: "mile",
    mi_other: "miles",
    mile_one: "mile",
    mile_other: "miles",
    km_one: "kilometer",
    km_other: "kilometers",
    kilometer_one: "kilometer",
    kilometer_other: "kilometers"
  },
  ev_attributes: {
    title: "EV Information",
    description: "Information about the vehicle capabilities and charging options.",
    tooltipDefaultName: "dealership",
    battery_range: {
      title: "Battery and Range",
      battery: "Battery",
      range: "Range (EPA est.)",
      electric_range: "Electric Range (EPA est.)",
      total_range: "Total Range",
      efficiency: "Efficiency",
      max_power: "Max Power",
      warranty: "Battery Warranty",
      warranty_remaining: "est. remaining",
      years: "years",
      up_to: "Up to",
      vehicle_to_home: "Vehicle to Home",
      vehicle_to_load: "Vehicle to Load",
      vehicle_to_grid: "Vehicle to Grid",
      unlimited_mi: "Unlimited Miles",
      unlimited_km: "Unlimited KMs",
      capacity_kwh: "Battery",
      battery_option: 'For "{{name}}": {{options}}.'
    },
    charging: {
      title: "Charging",
      charge_time: "Charge Time (Lv 2)",
      fast_charge: "Fast Charge (Lv 3)",
      percentage: "{{start}}-{{end}}%",
      charge_port: "Charge Port",
      charge_power: "Max Charge Speed",
      tesla_support: "Tesla Supercharger Access",
      tesla_support_mobile: "Tesla Super-charger Access",
      tesla_support_tooltip: "Requires adapter, check with {{name}}",
      connector_type: "Connector Type",
      oem_incentives: "OEM charger incentives",
      nacs_tooltip: "Adapter may be provided to charge with NACS, check with {{name}}",
      ccs_tooltip: "Adapter may be provided to charge with CCS, check with {{name}}",
      vehicle_to_home: "Vehicle to Home",
      vehicle_to_load: "Vehicle to Load",
      vehicle_to_grid: "Vehicle to Grid",
      bidirection_charge: "Bi-Directional Charge",
      bidirection_charge_tooltip: "Bidirectional charging enables the EV to supply electricity to external appliances, the grid, or your home, depending on the vehicle. Check with {{name}} for more details.",
      battery_option: 'For "{{name}}": {{options}}.',
      est: "est."
    },
    disclaimer: {
      title: "Disclaimer",
      header: "Legal things we have to disclose",
      description: "Vehicle attributes are based on public and third-party data and estimates. Therefore, vehicle data may contain inaccuracies from time to time. Please verify all information with {{name}}."
    }
  },
  report: {
    title: "Battery Certificate",
    shopperVisibleSections: {
      title: "Shown to shoppers",
      description: "Choose which sections shoppers can see. The dealer's own view always shows every section."
    },
    cellHealthStatus: {
      healthyCells: "Healthy Cells",
      cellIssue: "Cell Issue",
      allCellsHealthy: "No cell issues detected",
      cellIssueDetected: "Cell Issue Detected"
    },
    score: {
      excellent: "Excellent",
      great: "Great",
      good: "Good",
      poor: "Poor",
      cellIssueDetected: "Cell Issue Detected",
      cellIssue: "Cell Issue"
    },
    checks: {
      stateOfHealth: "Battery state of health",
      packVoltage: "Pack voltage diagnostic",
      energyMeasurement: "Energy Measurement"
    },
    certInfo: {
      testCompleted: "Test completed {{date}}",
      certification: "Certification #{{number}}"
    },
    sections: {
      reportState: {
        batteryScore: {
          title: "Estimated Battery Score",
          certification: "Lyteflo Certified",
          badgeSubText: "Battery condition",
          tooltip: "Battery score indicates how much charge it can hold compared to when it was new. A higher percentage signifies better health.",
          batteryChecks: {
            expectedRange: "{{scoreText}} Expected Range",
            batteryCapacity: "{{scoreText}} Battery Capacity",
            cellHealthGood: "Cells are healthy",
            cellHealthIssue: "Cell Issue Detected"
          }
        },
        vehicle: {
          uploadPicture: "Upload picture",
          odometer: "Odometer",
          vin: "VIN"
        },
        dealership: {
          contact: "Contact",
          actions: {
            email: {
              subject: "Question about battery certificate",
              body: "Reference ID (Certificate ID): {{reportId}}\r\n\r\n<Ask your question...>"
            }
          }
        },
        qrCode: {
          label: "View certificate online"
        }
      },
      cellChart: {
        cellIndex: "Cell {{index}}",
        cellIssueCard: {
          title: "Cell Issue Detected"
        },
        imbalanceLabel: "Cell voltage imbalance",
        cellIssueCauseImbalance: "Detected a high cell imbalance.",
        cellIssueCauseOutOfRange: "Detected one or more cells outside the acceptable voltage range.",
        cellIssueAdvice: "This could indicate an issue with the battery pack or the battery management system. We recommend charging to 100% and testing again. If the issue persists, consult a technician.",
        cellIssueSeeBelow: "See the Battery Cells section below.",
        cellVarianceCard: {
          title: "Excellent Cell Variance",
          descriptionLowImbalance: "This vehicle's cell imbalance is {{formatedCellDeviationMillivolt}}, which is excellent. The cells are well matched, indicating a healthy pack.",
          cellBatteryDescription: "An EV battery is made up of many individual cells. It is important that they are charged and discharged together so they experience similar stress and aging. If a cell drifts too far from the others, the whole battery may be limited to protect it, which limits range and power. A large drift can also lead to premature failure of the battery pack."
        },
        title: "Battery Cells",
        cellHealthy: {
          title: "Cell within limits"
        },
        cellIssue: {
          title: "Cell issue",
          description_one: "This cell has voltage deviations out of the acceptable limits. This indicates a possible failure of this cell or the battery management system which can cause premature battery degradation or more severe problems.",
          description_other: "These cells have voltage deviations out of the acceptable limits. This indicates a possible failure of these cells or the battery management system which can cause premature battery degradation or more severe problems."
        }
      },
      range: {
        expected: {
          title: "Expected Range",
          description: "Battery retention is within expected range based on its age and mileage.",
          originalRange: "Original range",
          electricTitle: "Expected Electric Range",
          originalElectricRange: "Original electric range"
        },
        forecast: {
          title: "Range Forecast",
          description: "Impact of hot & cold weather on vehicle range.",
          seasonalForecast: {
            title: "Seasonal Forecast",
            in: "in",
            season: {
              summer: "Summer",
              winter: "Winter"
            },
            zipTooltip: {
              title: "Enter your zip code",
              error: "Invalid zip code"
            }
          },
          projected: {
            title: "Projected Over Time"
          }
        }
      },
      batteryScore: {
        title: "Battery",
        description: "Cell health, warranty details, and comprehensive specifications.",
        cellHealth: {
          title: "Battery Cell Health",
          tooltip: "Battery cell health is a measure of the overall health of the battery. It is calculated based on the voltage of the battery cells.",
          cellsWithIssue: "Cells with issue",
          cellDeviation: "Cell deviation",
          dtcCleared: "Last DTC Cleared"
        },
        capacity: {
          originalCapacity: "Original Battery Capacity",
          currentCapacity: "Current Battery Capacity"
        },
        warranty: {
          title: "Battery Warranty",
          tooltip: "Warranty end date is an estimate. Warranties dates are based on when vehicle was first sold. Check with dealer for confirmation.",
          originalRatio: "{{years}} {{yearUnit}} / {{distance}} {{unit}}",
          warrantyExpiryEstimate: "Warranty estimated to expire in {{expiryYear}} or {{distance}} more {{unit}}, whichever comes first.",
          expiredMileage: "Battery warranty expired \xB7 exceeded mileage limit",
          expiredTerm: "Battery warranty may be expired based on term and mileage."
        },
        about: {
          chemistry: "Chemistry",
          manufacturer: "Manufacturer",
          batteryInstalled: "Battery Installed",
          batteryReplaced: "Battery Replaced"
        }
      },
      benchmark: {
        title: "Battery benchmark",
        label: "Compared to similar EVs",
        tooltip: "How this battery's health compares with similar EVs: same battery platform, model year within one year, similar mileage. Health normally declines with mileage, so each battery is compared with vehicles that have driven about as far. As of {{date}}.",
        tierPrefix: "TOP",
        tier: {
          top50: "50%",
          top25: "25%",
          top10: "10%",
          top5: "5%"
        }
      },
      charge: {
        title: "Charge Sessions",
        description: "Battery charging statistics",
        statistics: {
          fastCharges: "Fast Charges",
          regularCharges: "Regular Charges",
          sessions_one: "{{count}} session",
          sessions_other: "{{count}} sessions",
          note: "These values reflect how the battery has been charged over its lifetime. Charging habits, including how often fast charging is used, can affect long-term battery health and projected range."
        }
      },
      disclaimer: {
        data: "Lyteflo has prepared this certificate using data (including information made public by manufacturers) and analytical tools that we believe are reliable and accurate. However, variations in operating conditions, inaccuracies in third-party data, usage patterns, maintenance practices, and environmental factors can affect electric vehicle battery performance and longevity, as well as the validity of our underlying assumptions.",
        warranty: "This certificate is provided for informational purposes only and does not constitute a warranty, guarantee, or representation of specific outcomes or battery performance. Lyteflo and {{dealerName}} will not be responsible for any losses that may result from reliance on this certificate, or from any inaccuracies in this certificate. You are encouraged to do your own research before making any decisions about the purchase, sale, or repair of a vehicle.",
        readMore: "Read disclaimer",
        readLess: "Read less",
        defaultDealer: "the dealership"
      }
    },
    actions: {
      share: {
        label: "Share",
        title: "Share certificate",
        copyUrl: "Copy URL",
        orEmail: "Or send by email",
        copySuccess: "Public link copied to clipboard",
        copySuccessButton: "Link copied!",
        copyError: "Failed to copy public link",
        unavailable: "This certificate isn't publicly available yet."
      },
      emailCustomer: {
        name: "Name",
        email: "Email",
        namePlaceholder: "e.g. Thomas Edison",
        emailPlaceholder: "e.g. edison@company.com",
        emailTitle: "Open Battery Certificate",
        success: "Email sent successfully",
        error: "Failed to send email"
      },
      download: {
        label: "Download",
        pdfCertificate: "PDF certificate",
        pngShortCertificate: "PNG short certificate",
        error: "Failed to download certificate",
        unavailable: "Certificate is still being generated"
      },
      emailIssue: {
        label: "Report issue",
        subject: "Report issue on battery certificate",
        body: "Reference ID (Certificate ID): {{reportId}}\r\n\r\n<Describe your issue...>"
      }
    },
    error: {
      fetchFailed: "Failed to fetch battery certificate"
    },
    status: {
      reportResult: {
        success: "Success",
        failed: "Failed",
        in_review: "In review",
        beta: "Beta",
        dev: "Dev"
      },
      tooltips: {
        in_review: "We detected something unusual on this certificate. Our team is reviewing the certificate and will contact you shortly!",
        beta: "We support this vehicle, but certificate inconsistencies may still occur.",
        dev: "The generation of a certificate for this vehicle is still in development.",
        failed: "This certificate failed to generate."
      }
    }
  },
  vehicle: {
    supportStatus: {
      supported: "Supported",
      not_supported: "Not supported",
      beta: "Beta",
      dev: "Dev",
      tooltips: {
        beta: "Support for this vehicle is in beta; certificate results may still contain inaccuracies.",
        dev: "Support for this vehicle is in development and subject to change.",
        not_supported: "This vehicle is not currently supported for detailed battery certificates."
      }
    },
    title: {
      BEV: "EV",
      BEV_long: "Electric Vehicle",
      HEV: "Hybrid",
      PHEV: "Plug-in Hybrid",
      PHEV_long: "Plug-in Hybrid",
      ICE: "Gas"
    },
    title_with_vehicle: {
      BEV: "Electric Vehicle",
      HEV: "Hybrid Vehicle",
      PHEV: "Plug-in Hybrid Vehicle",
      ICE: "Gas Vehicle"
    }
  },
  tesla: {
    values: {
      "18_aero_wheels": "18\u2033 Aero Wheels",
      "18_aperture_wheels": "18\u2033 Aperture Wheels",
      "18_molten_wheels": "18\u2033 Molten Wheels",
      "18_photon_wheels": "18\u2033 Photon Wheels",
      "19_crossflow_wheels": "19\u2033 Crossflow Wheels",
      "19_gemini_dark_wheels": "19\u2033 Gemini Dark Wheels",
      "19_gemini_light_wheels": "19\u2033 Gemini Light Wheels",
      "19_nova_wheels": "19\u2033 Nova Wheels",
      "19_silver_cyclone_wheels": "19\u2033 Silver Cyclone Wheels",
      "19_silver_slipstream_wheels": "19\u2033 Silver Slipstream Wheels",
      "19_silver_wheels": "19\u2033 Silver Wheels",
      "19_sonic_carbon_slipstream_wheels": "19\u2033 Sonic Carbon Slipstream Wheels",
      "19_sport_wheels": "19\u2033 Sport Wheels",
      "19_tempest_wheels": "19\u2033 Tempest Wheels",
      "19_wheels": "19\u2033 Wheels",
      "20_core_wheels_with_35_tires": "20\u2033 Core Wheels with 35\u2033 Tires",
      "20_cyberstream_wheels": "20\u2033 Cyberstream Wheels",
      "20_gray_performance_wheels": "20\u2033 Gray Performance Wheels",
      "20_helix_2_0_wheels": "20\u2033 Helix 2.0 Wheels",
      "20_induction_wheels": "20\u2033 Induction Wheels",
      "20_mantle_wheels_with_35_tires": "20\u2033 Mantle Wheels with 35\u2033 Tires",
      "20_performance_wheels": "20\u2033 Performance Wheels",
      "20_silver_helix_wheels": "20\u2033 Silver Helix Wheels",
      "20_silver_slipstream_wheels": "20\u2033 Silver Slipstream Wheels",
      "20_silver_wheels": "20\u2033 Silver Wheels",
      "20_sonic_carbon_wheels": "20\u2033 Sonic Carbon Wheels",
      "20_two_tone_slipstream_wheels": "20\u2033 Two-Tone Slipstream Wheels",
      "20_uberturbine_wheels": "20\u2033 \xDCberturbine Wheels",
      "20_warp_wheels": "20\u2033 Warp Wheels",
      "21_arachnid_wheels": "21\u2033 Arachnid Wheels",
      "21_black_arachnid_wheels": "21\u2033 Black Arachnid Wheels",
      "21_grey_turbine_wheels": "21\u2033 Grey Turbine Wheels",
      "21_silver_turbine_wheels": "21\u2033 Silver Turbine Wheels",
      "21_sonic_carbon_twin_turbine_wheels": "21\u2033 Sonic Carbon Twin Turbine Wheels",
      "21_uberturbine_wheels": "21\u2033 \xDCberturbine Wheels",
      "22_machina_wheels": "22\u2033 Machina Wheels",
      "22_onyx_black_wheels": "22\u2033 Onyx Black Wheels",
      "22_silver_turbine_wheels": "22\u2033 Silver Turbine Wheels",
      "22_turbine_wheels": "22\u2033 Turbine Wheels",
      acceleration_boost: "Acceleration Boost",
      amd_ryzen_with_grok_ai_support: "AMD Ryzen (Grok capable)",
      anza_brown_metallic: "Anza Brown Metallic",
      base_autopilot: "Base Autopilot",
      black_and_white_partial_premium: "Black and White Partial Premium",
      black_and_white_premium: "Black and White Premium",
      black_partial_premium: "All Black Partial Premium",
      black_premium: "All Black Premium",
      black_premium_light_headliner: "All Black Premium with Light Headliner",
      black_textile: "Black Textile",
      carbon_fiber: "Carbon Fiber",
      carbon_fiber_spoiler: "Carbon Fiber Spoiler",
      cold_weather_feature: "Cold Weather Package",
      cream: "Cream",
      cream_premium: "Cream Premium",
      dark_ash_wood: "Dark Ash Wood",
      deep_blue_metallic: "Deep Blue Metallic",
      diamond_black: "Diamond Black",
      dolphin_grey_metallic: "Dolphin Grey Metallic",
      ebony: "Ebony",
      enhanced_autopilot: "Enhanced Autopilot",
      extended_nappa_leather: "Extended Nappa Leather",
      faster_acceleration: "Faster Acceleration",
      figured_ash_wood: "Figured Ash Wood",
      five_seat: "Five-Seat Interior",
      four_seat: "Four-Seat Interior",
      free_unlimited_supercharging: "Free Unlimited Supercharging",
      free_unlimited_supercharging_non_transferable: "Free Unlimited Supercharging (not transferable)",
      full_self_driving: "Full Self-Driving (Lifetime)",
      glossy_obeche_wood: "Glossy Obeche Wood",
      green_metallic: "Green Metallic",
      hardware_1: "Hardware 1.0",
      hardware_2: "Hardware 2.0",
      hardware_2_5: "Hardware 2.5",
      hardware_3: "Hardware 3.0",
      hardware_4: "Hardware 4.0",
      heated_rear_seats: "Heated Rear Seats",
      intel_atom: "Intel Atom",
      lifetime_premium_connectivity: "Lifetime Premium Connectivity",
      ludicrous_mode: "Ludicrous Mode",
      lunar_silver: "Lunar Silver",
      matte_obeche_wood: "Matte Obeche Wood",
      midnight_cherry_red: "Midnight Cherry Red",
      midnight_silver_metallic: "Midnight Silver Metallic",
      monterey_blue_metallic: "Monterey Blue Metallic",
      no_access_to_supercharger_network: "No Supercharger Access",
      no_autopilot: "No Autopilot",
      no_tow_package: "No Tow Package",
      nvidia_tegra_3: "NVIDIA Tegra 3",
      oak: "Oak",
      obsidian_black_metallic: "Obsidian Black Metallic",
      pay_per_use_supercharging: "Pay-Per-Use Supercharging",
      pearl_white_multi_coat: "Pearl White Multi-Coat",
      performance_brakes_and_pedals: "Performance Brakes and Pedals",
      piano_black: "Piano Black",
      premium_autopilot_firmware: "Premium Autopilot Firmware",
      premium_connectivity: "Premium Connectivity",
      quicksilver: "Quicksilver",
      red_brake_calipers: "Red Brake Calipers",
      red_multi_coat: "Red Multi-Coat",
      round_steering_wheel: "Round Steering Wheel",
      san_simeon_silver_metallic: "San Simeon Silver Metallic",
      seven_seat: "Seven-Seat Interior",
      signature_red: "Signature Red",
      six_seat: "Six-Seat Interior",
      solid_black: "Solid Black",
      solid_white: "Solid White",
      standard_connectivity: "Standard Connectivity",
      stealth_grey: "Stealth Grey",
      subzero_weather_package: "Subzero Weather Package",
      tactical_grey: "Tactical Grey",
      tan_premium: "Tan Premium",
      textile_seats: "Textile Seats",
      three_seat: "Three-Seat Interior",
      time_bound_supercharging: "Time-Limited Supercharging",
      titanium_metallic: "Titanium Metallic",
      tow_hitch: "Tow Hitch",
      traffic_aware_cruise_control: "Traffic-Aware Cruise Control",
      two_seat: "Two-Seat Interior",
      ultra_red: "Ultra Red",
      walnut: "Walnut",
      white: "White",
      yoke_steering: "Yoke Steering"
    }
  },
  providers: {
    website: {
      dealer_inspire: "Dealer Inspire",
      dealer_on: "DealerOn",
      independent: "Independent",
      sincro: "Sincro",
      dealer_com: "Dealer.com",
      team_velocity: "Team Velocity",
      jazel: "Jazel",
      fox_dealer: "Fox Dealer",
      remora: "Remora",
      edealer: "eDealer",
      d2c_media: "D2C Media",
      performance_auto_group: "Performance Auto Group",
      motive: "Motive",
      sm_360: "SM 360",
      magnetis: "Magnetis",
      leadbox: "Leadbox",
      t_advantage: "TAdvantage",
      dealer_eprocess: "Dealer Eprocess",
      overfuel: "Overfuel",
      dealer_center: "DealerCenter",
      dealer_car_search: "Dealer Car Search",
      get_my_auto: "Get My Auto",
      marketing: "Marketing Site",
      outpost_ev: "Outpost EV",
      space_auto: "Space Auto",
      cars_for_sale: "Cars For Sale",
      ebiz_autos: "eBizAutos"
    },
    crm: {
      elead: "Elead",
      vinsolutions: "VinSolutions",
      dealersocket: "DealerSocket",
      reynolds: "Reynolds",
      drive_centric: "Drive Centric",
      dealer_mine: "DealerMine",
      tekion: "Tekion",
      activix: "Activix",
      affinitiv: "Affinitiv",
      crm_360: "CRM 360",
      pbs_systems: "PBS Systems",
      tms: "TMS",
      dealer_center: "DealerCenter",
      asn_software: "ASN Software",
      tecobi: "Tecobi",
      salesforce: "Salesforce"
    },
    inventory: {
      dealer_on: "DealerOn",
      dealer_inspire: "Dealer Inspire",
      dealer_com: "Dealer.com",
      homenet: "HomeNet",
      vauto: "VAuto",
      maxdigital: "MaxDigital",
      sincro: "Sincro",
      space_auto: "Space Auto",
      cars_for_sale: "Cars For Sale",
      independent: "Independent",
      dealer_eprocess: "Dealer Eprocess",
      autovision: "Autovision",
      autotrader: "Autotrader",
      edealer: "eDealer",
      vincue: "Vincue",
      d2c_media: "D2C Media",
      xms_360: "XMS 360",
      magnetis: "Magnetis",
      deskit: "DeskIt",
      dealer_car_search: "Dealer Car Search",
      dealer_center: "DealerCenter"
    }
  }
};

// src/translations/fr.json
var fr_default = {
  close: "Fermer",
  switch: "Basculer",
  previous: "Pr\xE9c\xE9dent",
  next: "Suivant",
  back: "Retour",
  refresh: "Actualiser",
  newVersionAvailable: "Une nouvelle version est disponible",
  loading: "Chargement",
  email: "Email",
  password: "Mot de passe",
  or: "Ou",
  send: "Envoyer",
  sending: "Envoi en cours",
  resetting: "R\xE9initialisation",
  cancel: "Annuler",
  copyFailed: "\xC9chec de la copie dans le presse-papiers",
  confirm: "Confirmer",
  done: "Valider",
  add: "Ajouter",
  edit: "Modifier",
  filter: "Filtrer",
  dragToDismiss: "Glisser vers le bas pour fermer",
  sort: {
    title: "Trier",
    sortBy: "Trier par",
    order: "Ordre",
    ascending: "Croissant",
    descending: "D\xE9croissant"
  },
  save: "Enregistrer",
  delete: "Supprimer",
  disable: "D\xE9sactiver",
  select: "S\xE9lectionner",
  noResults: "Aucun r\xE9sultat trouv\xE9",
  selectTrim: "S\xE9lectionner la finition",
  yes: "Oui",
  no: "Non",
  ago: "il y a",
  on: "le",
  unknown: "Inconnu",
  never: "Jamais",
  poweredBy: "Propuls\xE9 par",
  selectAll: "Tout s\xE9lectionner",
  deselectAll: "Tout d\xE9s\xE9lectionner",
  openToSeeOptions: "Ouvrir pour voir les options",
  selectedItems: "{{count}} s\xE9lectionn\xE9s",
  changeLanguage: "Changer la langue",
  uploadImage: "T\xE9l\xE9charger une image",
  switchToLightMode: "Passer en mode clair",
  switchToDarkMode: "Passer en mode sombre",
  clickToCopy: "Cliquer pour copier",
  copyLink: {
    linkToCopy: "Lien \xE0 copier",
    copyToClipboard: "Copier dans le presse-papiers"
  },
  error: {
    unexpected: "Une erreur inattendue s'est produite"
  },
  timeUnits: {
    year_other: "ans",
    year_one: "an",
    month_other: "mois",
    month_one: "mois",
    day_other: "jours",
    day_one: "jour",
    hour_one: "heure",
    hour_other: "heures",
    minute_one: "minute",
    minute_other: "minutes",
    hour_abv_one: "h",
    hour_abv_other: "h",
    minute_abv_one: "min",
    minute_abv_other: "min"
  },
  distanceUnits: {
    mi_one: "mile",
    mi_other: "miles",
    mile_one: "mile",
    mile_other: "miles",
    km_one: "kilom\xE8tre",
    km_other: "kilom\xE8tres",
    kilometer_one: "kilom\xE8tre",
    kilometer_other: "kilom\xE8tres"
  },
  ev_attributes: {
    title: "Information VE",
    description: "Information sur les capacit\xE9s et les options de recharge du v\xE9hicule.",
    tooltipDefaultName: "concessionnaire",
    battery_range: {
      title: "Batterie et autonomie",
      battery: "Batterie",
      range: "Autonomie (est. EPA)",
      electric_range: "Autonomie \xE9lectrique (est. EPA)",
      total_range: "Autonomie totale",
      efficiency: "Efficacit\xE9",
      max_power: "Puissance max",
      warranty: "Garantie de la batterie",
      warranty_remaining: "est. restant",
      years: "ans",
      up_to: "jusqu'\xE0",
      vehicle_to_home: "V\xE9hicule vers maison",
      vehicle_to_load: "V\xE9hicule vers charge",
      vehicle_to_grid: "V\xE9hicule vers r\xE9seau",
      unlimited_mi: "Illimit\xE9 miles",
      unlimited_km: "Illimit\xE9 km",
      battery_option: 'Pour "{{name}}": {{options}}.',
      capacity_kwh: "Batterie"
    },
    charging: {
      title: "Recharge",
      charge_time: "Temps de recharge (Niv 2)",
      fast_charge: "Recharge rapide (Niv 3)",
      percentage: "{{start}}-{{end}}%",
      charge_port: "Port de recharge",
      charge_power: "Vitesse max de recharge",
      tesla_support: "Acc\xE8s aux Superchargeurs Tesla",
      tesla_support_mobile: "Acc\xE8s Superchargeurs Tesla",
      connector_type: "Type de connecteur",
      oem_incentives: "Incitations du fabricant pour chargeurs",
      nacs_tooltip: "Un adaptateur peut \xEAtre fourni pour charger avec NACS, v\xE9rifiez aupr\xE8s de {{name}}",
      ccs_tooltip: "Un adaptateur peut \xEAtre fourni pour charger avec CCS, v\xE9rifiez aupr\xE8s de {{name}}",
      est: "est.",
      tesla_support_tooltip: "Adaptateur requis, v\xE9rifiez aupr\xE8s de {{name}}",
      bidirection_charge: "Charge bidirectionnelle",
      bidirection_charge_tooltip: "La charge bidirectionnelle permet au v\xE9hicule \xE9lectrique de fournir de l'\xE9lectricit\xE9 \xE0 des appareils externes, le r\xE9seau ou votre maison, en fonction du v\xE9hicule. V\xE9rifiez aupr\xE8s de {{name}} pour plus de d\xE9tails.",
      vehicle_to_home: "V\xE9hicule vers maison",
      vehicle_to_load: "V\xE9hicule vers charge",
      vehicle_to_grid: "V\xE9hicule vers r\xE9seau",
      battery_option: 'Pour "{{name}}": {{options}}.'
    },
    disclaimer: {
      title: "Avertissement",
      header: "Mentions l\xE9gales que nous devons divulguer",
      description: "Les caract\xE9ristiques du v\xE9hicule sont bas\xE9es sur des donn\xE9es publiques, des donn\xE9es de tiers et des estimations. Par cons\xE9quent, les donn\xE9es du v\xE9hicule peuvent contenir des inexactitudes. Veuillez v\xE9rifier toutes les informations aupr\xE8s de {{name}}."
    }
  },
  report: {
    title: "Certificat de batterie",
    shopperVisibleSections: {
      title: "Visible par les acheteurs",
      description: "Choisissez les sections visibles par les acheteurs. La vue du concessionnaire affiche toujours toutes les sections."
    },
    cellHealthStatus: {
      healthyCells: "Cellules saines",
      cellIssue: "Probl\xE8me de cellule",
      allCellsHealthy: "Aucun probl\xE8me de cellule d\xE9tect\xE9",
      cellIssueDetected: "Probl\xE8me de cellule d\xE9tect\xE9"
    },
    score: {
      excellent: "Excellente",
      great: "Tr\xE8s bonne",
      good: "Bonne",
      poor: "Mauvaise",
      cellIssueDetected: "Probl\xE8me de cellule d\xE9tect\xE9",
      cellIssue: "Probl\xE8me de cellule"
    },
    checks: {
      stateOfHealth: "\xC9tat de sant\xE9 de la batterie",
      packVoltage: "Diagnostic de tension du pack",
      energyMeasurement: "Mesure d'\xE9nergie"
    },
    certInfo: {
      testCompleted: "Test effectu\xE9 le {{date}}",
      certification: "Certification #{{number}}"
    },
    sections: {
      reportState: {
        batteryScore: {
          title: "Sant\xE9 de la batterie estim\xE9e",
          certification: "Certifi\xE9 Lyteflo",
          badgeSubText: "Condition de la batterie",
          tooltip: "Le score de la batterie repr\xE9sente sa capacit\xE9 \xE0 retenir la charge, comparativement \xE0 sa capacit\xE9 initiale. Plus le pourcentage est \xE9lev\xE9, meilleure est sa sant\xE9.",
          batteryChecks: {
            expectedRange: "{{scoreText}} distance attendue",
            batteryCapacity: "{{scoreText}} capacit\xE9 de la batterie",
            cellHealthGood: "Bonne sant\xE9 des cellules",
            cellHealthIssue: "Probl\xE8me de cellule d\xE9tect\xE9"
          }
        },
        vehicle: {
          uploadPicture: "T\xE9l\xE9charger une image",
          odometer: "Odom\xE8tre",
          vin: "NIV"
        },
        dealership: {
          contact: "Contact",
          actions: {
            email: {
              subject: "Question sur le certificat de batterie",
              body: "ID de r\xE9f\xE9rence (ID du certificat): {{reportId}}\r\n\r\n<Posez votre question...>"
            }
          }
        },
        qrCode: {
          label: "Voir le certificat en ligne"
        }
      },
      cellChart: {
        cellIndex: "Cellule {{index}}",
        cellIssueCard: {
          title: "Probl\xE8me de cellule d\xE9tect\xE9"
        },
        imbalanceLabel: "D\xE9s\xE9quilibre de tension des cellules",
        cellIssueCauseImbalance: "Un d\xE9s\xE9quilibre important des cellules a \xE9t\xE9 d\xE9tect\xE9.",
        cellIssueCauseOutOfRange: "Une ou plusieurs cellules pr\xE9sentant une tension en dehors de la plage acceptable ont \xE9t\xE9 d\xE9tect\xE9es.",
        cellIssueAdvice: "Cela pourrait indiquer un probl\xE8me avec le pack de batterie ou le syst\xE8me de gestion de la batterie. Nous recommandons de charger \xE0 100 % et de tester \xE0 nouveau. Si le probl\xE8me persiste, consultez un technicien.",
        cellIssueSeeBelow: "Consultez la section Cellules de la batterie ci-dessous.",
        cellVarianceCard: {
          title: "Excellente variation des cellules",
          descriptionLowImbalance: "Le d\xE9s\xE9quilibre des cellules de ce v\xE9hicule est de {{formatedCellDeviationMillivolt}}, ce qui est excellent. Les cellules sont bien appari\xE9es, ce qui indique un pack sain.",
          cellBatteryDescription: "Une batterie \xE9lectrique est compos\xE9e de nombreuses cellules individuelles. Il est important qu'elles soient charg\xE9es et d\xE9charg\xE9es ensemble pour subir des stress et de l'usure similaires. Si une cellule s'\xE9loigne trop des autres, la batterie peut \xEAtre limit\xE9e pour la prot\xE9ger, ce qui limite l'autonomie et la puissance. Un grand \xE9cart peut \xE9galement conduire \xE0 une d\xE9faillance pr\xE9matur\xE9e du pack de batterie."
        },
        title: "Cellules de la batterie",
        cellHealthy: {
          title: "Cellule dans les limites"
        },
        cellIssue: {
          title: "Probl\xE8me de cellule",
          description_one: "Cette cellule pr\xE9sente des \xE9carts de tension en dehors des limites acceptables. Cela indique une d\xE9faillance possible de cette cellule ou du syst\xE8me de gestion de la batterie, ce qui peut entra\xEEner une d\xE9gradation pr\xE9matur\xE9e de la batterie ou des probl\xE8mes plus graves.",
          description_other: "Ces cellules pr\xE9sentent des \xE9carts de tension en dehors des limites acceptables. Cela indique une d\xE9faillance possible de ces cellules ou du syst\xE8me de gestion de la batterie, ce qui peut entra\xEEner une d\xE9gradation pr\xE9matur\xE9e de la batterie ou des probl\xE8mes plus graves."
        }
      },
      range: {
        expected: {
          title: "Autonomie estim\xE9e",
          description: "L'autonomie se situe dans la plage attendue compte tenu de l'\xE2ge et du kilom\xE9trage du v\xE9hicule.",
          originalRange: "Autonomie d'origine",
          electricTitle: "Autonomie \xE9lectrique estim\xE9e",
          originalElectricRange: "Autonomie \xE9lectrique d'origine"
        },
        forecast: {
          title: "Pr\xE9vision de distance",
          description: "Impact des conditions m\xE9t\xE9orologiques chaudes et froides sur la distance du v\xE9hicule.",
          seasonalForecast: {
            title: "Pr\xE9vision saisonni\xE8re",
            in: "\xE0",
            season: {
              summer: "\xC9t\xE9",
              winter: "Hiver"
            },
            zipTooltip: {
              title: "Entrez votre code postal",
              error: "Code postal invalide"
            }
          },
          projected: {
            title: "Pr\xE9vision sur le long terme"
          }
        }
      },
      batteryScore: {
        title: "Batterie",
        description: "Sant\xE9 des cellules, d\xE9tails de la garantie et sp\xE9cifications compl\xE8tes.",
        cellHealth: {
          title: "Sant\xE9 des cellules de la batterie",
          tooltip: "La sant\xE9 des cellules de la batterie est un indicateur de la sant\xE9 globale de la batterie. Elle est calcul\xE9e en fonction de la tension des cellules de la batterie.",
          cellsWithIssue: "Cellules avec probl\xE8me",
          cellDeviation: "D\xE9viation de cellule",
          dtcCleared: "Dernier DTC corrig\xE9"
        },
        capacity: {
          originalCapacity: "Capacit\xE9 originale de la batterie",
          currentCapacity: "Capacit\xE9 actuelle de la batterie"
        },
        warranty: {
          title: "Garantie de la batterie",
          tooltip: "La date de fin de garantie est une estimation. Les dates de garantie sont bas\xE9es sur la date de premi\xE8re vente du v\xE9hicule. V\xE9rifiez aupr\xE8s du concessionnaire pour confirmation.",
          originalRatio: "{{years}} {{yearUnit}} / {{distance}} {{unit}}",
          warrantyExpiryEstimate: "Expiration de la garantie estim\xE9e en {{expiryYear}} ou dans {{distance}} {{unit}}, selon la premi\xE8re \xE9ventualit\xE9.",
          expiredMileage: "Garantie de la batterie expir\xE9e \xB7 limite de kilom\xE9trage d\xE9pass\xE9e",
          expiredTerm: "La garantie de la batterie est peut-\xEAtre expir\xE9e selon la dur\xE9e et le kilom\xE9trage."
        },
        about: {
          chemistry: "Chimie",
          manufacturer: "Fabricant",
          batteryInstalled: "Batterie install\xE9e",
          batteryReplaced: "Batterie remplac\xE9e"
        }
      },
      benchmark: {
        title: "Comparaison de la batterie",
        label: "Compar\xE9 aux V\xC9 similaires",
        tooltip: "Comparaison de l'\xE9tat de cette batterie avec celui de V\xC9 similaires : m\xEAme plateforme de batterie, ann\xE9e-mod\xE8le \xE0 un an pr\xE8s, kilom\xE9trage semblable. L'\xE9tat de sant\xE9 diminue normalement avec le kilom\xE9trage; chaque batterie est donc compar\xE9e \xE0 des v\xE9hicules ayant parcouru \xE0 peu pr\xE8s la m\xEAme distance. En date du {{date}}.",
        tierPrefix: "TOP",
        tier: {
          top50: "50\u202F%",
          top25: "25\u202F%",
          top10: "10\u202F%",
          top5: "5\u202F%"
        }
      },
      charge: {
        title: "Sessions de charge",
        description: "Statistiques de charge de la batterie",
        statistics: {
          fastCharges: "Charges rapides",
          regularCharges: "Charges r\xE9guli\xE8res",
          sessions_one: "{{count}} session",
          sessions_other: "{{count}} sessions",
          note: "Ces valeurs refl\xE8tent la fa\xE7on dont la batterie a \xE9t\xE9 charg\xE9e au cours de sa dur\xE9e de vie. Les habitudes de recharge, notamment la fr\xE9quence des charges rapides, peuvent influencer la sant\xE9 \xE0 long terme de la batterie et l'autonomie projet\xE9e."
        }
      },
      disclaimer: {
        data: "Lyteflo a pr\xE9par\xE9 ce certificat en utilisant des donn\xE9es (y compris les informations rendues publiques par les fabricants) et des outils d'analyse que nous croyons fiables et pr\xE9cis. Cependant, les variations dans les conditions d'exploitation, les inexactitudes dans les donn\xE9es de tiers, les mod\xE8les d'utilisation, les pratiques de maintenance et les facteurs environnementaux peuvent affecter les performances et la long\xE9vit\xE9 de la batterie des v\xE9hicules \xE9lectriques, ainsi que la validit\xE9 de nos hypoth\xE8ses sous-jacentes.",
        warranty: "Ce certificat est fourni \xE0 titre informatif uniquement et ne constitue pas une garantie, une assurance ou une repr\xE9sentation de r\xE9sultats sp\xE9cifiques ou de performances de la batterie. Lyteflo et {{dealerName}} ne seront pas responsables de toute perte qui pourrait r\xE9sulter de la confiance accord\xE9e \xE0 ce certificat, ou de toute inexactitude dans ce certificat. Vous \xEAtes encourag\xE9 \xE0 faire vos propres recherches avant de prendre toute d\xE9cision concernant l'achat, la vente ou la r\xE9paration d'un v\xE9hicule.",
        readMore: "Lire la mention l\xE9gale",
        readLess: "Lire moins",
        defaultDealer: "le concessionnaire"
      }
    },
    actions: {
      share: {
        label: "Partager",
        title: "Partager le certificat",
        copyUrl: "Copier l\u2019URL",
        orEmail: "Ou envoyer par email",
        copySuccess: "Lien public copi\xE9 dans le presse-papiers",
        copySuccessButton: "Lien copi\xE9!",
        copyError: "\xC9chec de la copie du lien public",
        unavailable: "Ce certificat n'est pas encore accessible au public."
      },
      emailCustomer: {
        name: "Nom",
        email: "Email",
        namePlaceholder: "ex. Thomas Edison",
        emailPlaceholder: "ex. edison@company.com",
        emailTitle: "Ouvrir le certificat de batterie",
        success: "Email envoy\xE9 avec succ\xE8s",
        error: "\xC9chec de l'envoi de l'email"
      },
      download: {
        label: "T\xE9l\xE9charger",
        pdfCertificate: "Certificat PDF",
        pngShortCertificate: "Certificat court PNG",
        error: "\xC9chec du t\xE9l\xE9chargement du certificat",
        unavailable: "Le certificat est encore en cours de g\xE9n\xE9ration"
      },
      emailIssue: {
        label: "Probl\xE8me de certificat",
        subject: "Probl\xE8me sur le certificat de batterie",
        body: "ID de r\xE9f\xE9rence (ID du certificat): {{reportId}}\r\n\r\n<D\xE9crivez votre probl\xE8me...>"
      }
    },
    error: {
      fetchFailed: "\xC9chec de la r\xE9cup\xE9ration du certificat de batterie"
    },
    status: {
      reportResult: {
        success: "Succ\xE8s",
        failed: "\xC9chou\xE9",
        in_review: "En r\xE9vision",
        beta: "B\xEAta",
        dev: "Dev"
      },
      tooltips: {
        in_review: "Nous avons d\xE9tect\xE9 quelque chose d'anormal sur ce certificat. Notre \xE9quipe examine le certificat et vous contactera sous peu !",
        beta: "Nous supportons ce v\xE9hicule, mais des incoh\xE9rences dans le certificat peuvent encore survenir.",
        dev: "La g\xE9neration de certificat pour ce v\xE9hicule est encore en cours de d\xE9veloppement.",
        failed: "Ce certificat n'a pas pu \xEAtre g\xE9n\xE9r\xE9 correctement."
      }
    }
  },
  vehicle: {
    supportStatus: {
      supported: "Support\xE9",
      not_supported: "Non support\xE9",
      beta: "B\xEAta",
      dev: "Dev",
      tooltips: {
        beta: "Le support de ce v\xE9hicule est en b\xEAta ; les r\xE9sultats du certificat peuvent encore contenir des incoh\xE9rences.",
        not_supported: "Ce v\xE9hicule n'est actuellement pas pris en charge pour les certificats de batterie d\xE9taill\xE9s.",
        dev: "Le support de ce v\xE9hicule est en cours de d\xE9veloppement et susceptible d'\xE9voluer."
      }
    },
    title: {
      BEV: "VE",
      BEV_long: "V\xE9hicule \xC9lectrique",
      HEV: "Hybride",
      PHEV: "Hybride rechargeable",
      PHEV_long: "Hybride Branchable",
      ICE: "Essence"
    },
    title_with_vehicle: {
      BEV: "V\xE9hicule \xC9lectrique",
      HEV: "V\xE9hicule Hybride",
      PHEV: "V\xE9hicule Hybride Rechargeable",
      ICE: "V\xE9hicule \xE0 Essence"
    }
  },
  tesla: {
    values: {
      "18_aero_wheels": "Jantes Aero 18\u2033",
      "18_aperture_wheels": "Jantes Aperture 18\u2033",
      "18_molten_wheels": "Jantes Molten 18\u2033",
      "18_photon_wheels": "Jantes Photon 18\u2033",
      "19_crossflow_wheels": "Jantes Crossflow 19\u2033",
      "19_gemini_dark_wheels": "Jantes Gemini fonc\xE9es 19\u2033",
      "19_gemini_light_wheels": "Jantes Gemini claires 19\u2033",
      "19_nova_wheels": "Jantes Nova 19\u2033",
      "19_silver_cyclone_wheels": "Jantes Cyclone argent\xE9es 19\u2033",
      "19_silver_slipstream_wheels": "Jantes Slipstream argent\xE9es 19\u2033",
      "19_silver_wheels": "Jantes argent\xE9es 19\u2033",
      "19_sonic_carbon_slipstream_wheels": "Jantes Slipstream Sonic Carbon 19\u2033",
      "19_sport_wheels": "Jantes Sport 19\u2033",
      "19_tempest_wheels": "Jantes Tempest 19\u2033",
      "19_wheels": "Jantes 19\u2033",
      "20_core_wheels_with_35_tires": "Jantes Core 20\u2033 avec pneus 35\u2033",
      "20_cyberstream_wheels": "Jantes Cyberstream 20\u2033",
      "20_gray_performance_wheels": "Jantes Performance grises 20\u2033",
      "20_helix_2_0_wheels": "Jantes Helix 2.0 20\u2033",
      "20_induction_wheels": "Jantes Induction 20\u2033",
      "20_mantle_wheels_with_35_tires": "Jantes Mantle 20\u2033 avec pneus 35\u2033",
      "20_performance_wheels": "Jantes Performance 20\u2033",
      "20_silver_helix_wheels": "Jantes Helix argent\xE9es 20\u2033",
      "20_silver_slipstream_wheels": "Jantes Slipstream argent\xE9es 20\u2033",
      "20_silver_wheels": "Jantes argent\xE9es 20\u2033",
      "20_sonic_carbon_wheels": "Jantes Sonic Carbon 20\u2033",
      "20_two_tone_slipstream_wheels": "Jantes Slipstream bicolores 20\u2033",
      "20_uberturbine_wheels": "Jantes \xDCberturbine 20\u2033",
      "20_warp_wheels": "Jantes Warp 20\u2033",
      "21_arachnid_wheels": "Jantes Arachnid 21\u2033",
      "21_black_arachnid_wheels": "Jantes Arachnid noires 21\u2033",
      "21_grey_turbine_wheels": "Jantes Turbine grises 21\u2033",
      "21_silver_turbine_wheels": "Jantes Turbine argent\xE9es 21\u2033",
      "21_sonic_carbon_twin_turbine_wheels": "Jantes Twin Turbine Sonic Carbon 21\u2033",
      "21_uberturbine_wheels": "Jantes \xDCberturbine 21\u2033",
      "22_machina_wheels": "Jantes Machina 22\u2033",
      "22_onyx_black_wheels": "Jantes Onyx Black 22\u2033",
      "22_silver_turbine_wheels": "Jantes Turbine argent\xE9es 22\u2033",
      "22_turbine_wheels": "Jantes Turbine 22\u2033",
      acceleration_boost: "Acc\xE9l\xE9ration augment\xE9e",
      amd_ryzen_with_grok_ai_support: "AMD Ryzen (compatible Grok)",
      anza_brown_metallic: "Anza Brown Metallic",
      base_autopilot: "Conduite automatique de base",
      black_and_white_partial_premium: "Noir et blanc Premium partiel",
      black_and_white_premium: "Noir et blanc Premium",
      black_partial_premium: "Noir Premium partiel",
      black_premium: "Noir Premium int\xE9gral",
      black_premium_light_headliner: "Noir Premium avec ciel de toit clair",
      black_textile: "Textile noir",
      carbon_fiber: "Fibre de carbone",
      carbon_fiber_spoiler: "Aileron en fibre de carbone",
      cold_weather_feature: "Pack temps froid",
      cream: "Cr\xE8me",
      cream_premium: "Cr\xE8me Premium",
      dark_ash_wood: "Fr\xEAne fonc\xE9",
      deep_blue_metallic: "Deep Blue Metallic",
      diamond_black: "Diamond Black",
      dolphin_grey_metallic: "Dolphin Grey Metallic",
      ebony: "\xC9b\xE8ne",
      enhanced_autopilot: "Conduite automatique am\xE9lior\xE9e",
      extended_nappa_leather: "Finition cuir Nappa \xE9tendu",
      faster_acceleration: "Acc\xE9l\xE9ration am\xE9lior\xE9e",
      figured_ash_wood: "Fr\xEAne moir\xE9",
      five_seat: "Int\xE9rieur cinq places",
      four_seat: "Int\xE9rieur quatre places",
      free_unlimited_supercharging: "Superchargement gratuit et illimit\xE9",
      free_unlimited_supercharging_non_transferable: "Superchargement gratuit et illimit\xE9 (non transf\xE9rable)",
      full_self_driving: "Conduite enti\xE8rement automatique (\xE0 vie)",
      glossy_obeche_wood: "Samba brillant",
      green_metallic: "Green Metallic",
      hardware_1: "Mat\xE9riel 1.0",
      hardware_2: "Mat\xE9riel 2.0",
      hardware_2_5: "Mat\xE9riel 2.5",
      hardware_3: "Mat\xE9riel 3.0",
      hardware_4: "Mat\xE9riel 4.0",
      heated_rear_seats: "Si\xE8ges arri\xE8re chauffants",
      intel_atom: "Intel Atom",
      lifetime_premium_connectivity: "Connectivit\xE9 haut de gamme \xE0 vie",
      ludicrous_mode: "Mode Ludicrous",
      lunar_silver: "Lunar Silver",
      matte_obeche_wood: "Samba mat",
      midnight_cherry_red: "Midnight Cherry Red",
      midnight_silver_metallic: "Midnight Silver Metallic",
      monterey_blue_metallic: "Monterey Blue Metallic",
      no_access_to_supercharger_network: "Aucun acc\xE8s au r\xE9seau de Superchargement",
      no_autopilot: "Aucune Conduite automatique",
      no_tow_package: "Sans pack remorquage",
      nvidia_tegra_3: "NVIDIA Tegra 3",
      oak: "Ch\xEAne",
      obsidian_black_metallic: "Obsidian Black Metallic",
      pay_per_use_supercharging: "Superchargement payant",
      pearl_white_multi_coat: "Pearl White Multi-Coat",
      performance_brakes_and_pedals: "Freins et p\xE9dales Performance",
      piano_black: "Noir piano",
      premium_autopilot_firmware: "Micrologiciel de Conduite automatique Premium",
      premium_connectivity: "Connectivit\xE9 haut de gamme",
      quicksilver: "Quicksilver",
      red_brake_calipers: "\xC9triers de frein rouges",
      red_multi_coat: "Red Multi-Coat",
      round_steering_wheel: "Volant rond",
      san_simeon_silver_metallic: "San Simeon Silver Metallic",
      seven_seat: "Int\xE9rieur sept places",
      signature_red: "Signature Red",
      six_seat: "Int\xE9rieur six places",
      solid_black: "Solid Black",
      solid_white: "Solid White",
      standard_connectivity: "Connectivit\xE9 standard",
      stealth_grey: "Stealth Grey",
      subzero_weather_package: "Pack grand froid",
      tactical_grey: "Tactical Grey",
      tan_premium: "Beige Premium",
      textile_seats: "Si\xE8ges en textile",
      three_seat: "Int\xE9rieur trois places",
      time_bound_supercharging: "Superchargement \xE0 dur\xE9e limit\xE9e",
      titanium_metallic: "Titanium Metallic",
      tow_hitch: "Attelage de remorque",
      traffic_aware_cruise_control: "R\xE9gulateur de vitesse dynamique",
      two_seat: "Int\xE9rieur deux places",
      ultra_red: "Ultra Red",
      walnut: "Noyer",
      white: "Blanc",
      yoke_steering: "Volant Yoke"
    }
  },
  providers: {
    website: {
      dealer_inspire: "Dealer Inspire",
      dealer_on: "DealerOn",
      independent: "Ind\xE9pendant",
      sincro: "Sincro",
      dealer_com: "Dealer.com",
      team_velocity: "Team Velocity",
      jazel: "Jazel",
      fox_dealer: "Fox Dealer",
      remora: "Remora",
      edealer: "eDealer",
      d2c_media: "D2C Media",
      performance_auto_group: "Performance Auto Group",
      motive: "Motive",
      sm_360: "SM 360",
      magnetis: "Magnetis",
      leadbox: "Leadbox",
      t_advantage: "TAdvantage",
      dealer_eprocess: "Dealer Eprocess",
      overfuel: "Overfuel",
      dealer_center: "DealerCenter",
      dealer_car_search: "Dealer Car Search",
      get_my_auto: "Get My Auto",
      marketing: "Site marketing",
      outpost_ev: "Outpost EV",
      space_auto: "Space Auto",
      cars_for_sale: "Cars For Sale",
      ebiz_autos: "eBizAutos"
    },
    crm: {
      elead: "Elead",
      vinsolutions: "VinSolutions",
      dealersocket: "DealerSocket",
      reynolds: "Reynolds",
      drive_centric: "Drive Centric",
      dealer_mine: "DealerMine",
      tekion: "Tekion",
      activix: "Activix",
      affinitiv: "Affinitiv",
      crm_360: "CRM 360",
      pbs_systems: "PBS Systems",
      tms: "TMS",
      dealer_center: "DealerCenter",
      asn_software: "ASN Software",
      tecobi: "Tecobi",
      salesforce: "Salesforce"
    },
    inventory: {
      dealer_on: "DealerOn",
      dealer_inspire: "Dealer Inspire",
      dealer_com: "Dealer.com",
      homenet: "HomeNet",
      vauto: "VAuto",
      maxdigital: "MaxDigital",
      sincro: "Sincro",
      space_auto: "Space Auto",
      cars_for_sale: "Cars For Sale",
      independent: "Ind\xE9pendant",
      dealer_eprocess: "Dealer Eprocess",
      autovision: "Autovision",
      autotrader: "Autotrader",
      edealer: "eDealer",
      vincue: "Vincue",
      d2c_media: "D2C Media",
      xms_360: "XMS 360",
      magnetis: "Magnetis",
      deskit: "DeskIt",
      dealer_car_search: "Dealer Car Search",
      dealer_center: "DealerCenter"
    }
  }
};

// src/translations/portal/en.json
var en_default2 = {
  common: {
    comingSoon: "Coming soon..."
  },
  formDemo: {
    fields: {
      name: "Name",
      phone: "Phone",
      mode: "Mode",
      plan: "Plan",
      domains: "Domains",
      terms: "Terms"
    },
    accepted: "Accepted",
    addedDomains: "Added domains",
    add: "Add",
    remove: "Remove {{item}}",
    leaveViaLink: "Leave via link"
  },
  form: {
    breadcrumbs: "Breadcrumb",
    errorSummary: {
      item: "{{label}}: {{message}}",
      title_one: "Fix {{count}} field before saving:",
      title_other: "Fix {{count}} fields before saving:"
    },
    stepSummary: "Step {{current}} of {{total}}: {{name}}",
    steps: "Form steps",
    stepsCompleteSummary_one: "{{count}} of {{total}} step complete",
    stepsCompleteSummary_other: "{{count}} of {{total}} steps complete"
  },
  table: {
    refresh: "Refresh",
    filterSort: "Filter & Sort",
    moreDetails: "More details",
    sortBy: "Sort by",
    openRowMenu: "Open row menu",
    missingTrimTooltip: "A trim is required for an accurate certificate.",
    publishDisabledTooltip: "Publishing is disabled because this certificate is invalid.",
    publicLinkUnavailableTooltip: "This certificate isn't publicly available yet.",
    publishDisabledCellIssueTooltip: "Publishing is disabled because this certificate has a cell issue.",
    success: {
      refreshed: "Data refreshed successfully"
    },
    error: {
      refreshFailed: "Failed to refresh data"
    }
  },
  dataListWithPanel: {
    panelLabel: "Details",
    loading: "Loading...",
    loadFailed: "Couldn't load the details.",
    retry: "Try again",
    sectionLoadFailed: "Couldn't load this section."
  },
  dealerConfig: {
    confirm: {
      title: "Confirm changes",
      intro: "These changes affect what the dealer can use. Check them before saving.",
      changedAria: "Changed from {{from}} to {{to}}",
      keepEditing: "Keep editing",
      save: "Save changes",
      row: {
        status: "Status",
        batteryCertificate: "Battery Certificate Subscription",
        teslaAttributes: "Tesla Attributes",
        teslaLookupPlan: "Tesla Lookup Plan",
        domains: "Website Domains",
        provider: "Website Provider"
      }
    },
    leave: {
      title: "Leave without saving?",
      bodyEdit: "Your changes to {{dealerName}} will be lost.",
      bodyCreate: "Your entries will be lost.",
      keep: "Keep editing",
      discard: "Discard changes"
    },
    searchPlaceholder: "Search dealers by name",
    table: {
      name: "Dealer Name",
      status: "Status",
      provider: "Website Provider",
      oem: "OEM",
      dealerGroup: "Dealer Group"
    },
    resultCount_one: "{{count}} dealer",
    resultCount_other: "{{count}} dealers",
    loadingMore: "Loading more...",
    allLoaded_one: "All {{count}} dealer loaded",
    allLoaded_other: "All {{count}} dealers loaded",
    error: {
      fetchFailed: "Couldn't load dealers",
      loadFailedInline: "Couldn't load dealers.",
      loadMoreFailed: "Couldn't load more dealers.",
      createServer: "Couldn't create the configuration because of a server error. Your entries are kept. Try again.",
      forbidden: "Not allowed to change an entitlement",
      saveServer: "Couldn't save the changes because of a server error. Your entries are kept. Try again.",
      styleGeneration: "Couldn't generate the styling from the colors entered, so nothing was saved. Check the colors and try again."
    },
    status: {
      customer: "Customer",
      trial: "Trial",
      partner: "Partner",
      demo: "Demo",
      test: "Test",
      cancelled: "Cancelled"
    },
    panel: {
      sections: {
        identity: "Identity",
        website: "Website",
        location: "Location",
        contacts: "Phones and emails",
        integrations: "Integrations",
        entitlements: "Entitlements",
        widgets: "Widgets"
      },
      fields: {
        dealerId: "Dealer ID",
        crmProvider: "CRM Provider",
        inventoryProvider: "Inventory Provider",
        domains: "Domains",
        ipAddress: "IP Address",
        gaId: "Google Analytics ID",
        address: "Address",
        measurement: "Measurement System",
        currency: "Currency",
        salesPhone: "Sales phone",
        emails: "Emails",
        batteryCertificates: "Battery certificates",
        teslaAttributes: "Tesla attributes",
        teslaLookup: "Tesla lookup",
        teslaLookupLimitMonthly: "Tesla lookup monthly limit",
        teslaLookupLimitLifetime: "Tesla lookup lifetime limit",
        widgetCount: "Number of widgets"
      },
      teslaLookupPlan: {
        paid: "Paid",
        free: "Free"
      },
      shopperVisibleSectionsNone: "None",
      lastUpdated: "Last updated: {{date}}",
      noIdHint: "Can't look up this dealer's details, so some values may be blank.",
      viewOnly: "View only. Ask a Lyteflo Admin to make changes.",
      loading: "Loading phones and emails...",
      integrationsError: "Couldn't load integrations.",
      partialToast: "Couldn't load all of this dealer's settings"
    },
    measurement: {
      imperial: "Imperial",
      metric: "Metric"
    },
    providers: {
      dealer_inspire: "Dealer Inspire",
      dealer_on: "DealerOn",
      independent: "Independent",
      sincro: "Sincro",
      dealer_com: "Dealer.com",
      team_velocity: "Team Velocity",
      jazel: "Jazel",
      fox_dealer: "Fox Dealer",
      remora: "Remora",
      edealer: "eDealer",
      d2c_media: "D2C Media",
      performance_auto_group: "Performance Auto Group",
      motive: "Motive",
      sm_360: "SM 360",
      magnetis: "Magnetis",
      leadbox: "Leadbox",
      t_advantage: "TAdvantage",
      dealer_eprocess: "Dealer Eprocess",
      overfuel: "Overfuel",
      dealer_center: "DealerCenter",
      dealer_car_search: "Dealer Car Search",
      get_my_auto: "Get My Auto",
      marketing: "Marketing Site",
      outpost_ev: "Outpost EV",
      space_auto: "Space Auto",
      cars_for_sale: "Cars For Sale",
      ebiz_autos: "eBizAutos",
      homenet: "HomeNet",
      vauto: "VAuto",
      maxdigital: "MaxDigital",
      autovision: "Autovision",
      autotrader: "Autotrader",
      vincue: "Vincue",
      xms_360: "XMS 360",
      deskit: "DeskIt",
      elead: "Elead",
      vinsolutions: "VinSolutions",
      dealersocket: "DealerSocket",
      reynolds: "Reynolds",
      drive_centric: "Drive Centric",
      dealer_mine: "DealerMine",
      tekion: "Tekion",
      activix: "Activix",
      affinitiv: "Affinitiv",
      crm_360: "CRM 360",
      pbs_systems: "PBS Systems",
      tms: "TMS",
      asn_software: "ASN Software",
      tecobi: "Tecobi",
      salesforce: "Salesforce",
      shift_digital: "Shift Digital"
    },
    create: {
      add: "Add dealer",
      title: "Add dealer",
      submit: "Create configuration",
      back: "Back to dealers",
      summary: "Summary",
      sections: {
        basic: "Basic information",
        address: "Address and regional settings",
        contact: "Contact and website",
        entitlements: "Entitlements",
        integrations: "Integrations",
        tracking: "Tracking and leads",
        defaults: "Savings and certificate defaults",
        widgets: "Widgets"
      },
      fields: {
        street: "Street Address",
        city: "City",
        state: "State",
        province: "Province",
        zipCode: "ZIP Code",
        postalCode: "Postal Code",
        country: "Country",
        salesPhone: "Sales Phone",
        domain: "Domain",
        batteryReportSubscription: "Battery Certificate Subscription",
        latitude: "Latitude",
        longitude: "Longitude",
        leadRouting: "Lead Routing",
        leadTracking: "Test Leads",
        defaultAnnualDistance: "Default Annual Distance",
        defaultTimelineYears: "Default Timeline (Years)",
        autoPublishBatteryReports: "Auto Publish Battery Certificates",
        teslaAttributes: "Tesla Attributes"
      },
      groupPlaceholder: "None",
      noWebsite: "This dealer has no website of its own",
      noWebsiteHelp: "Battery certificates, users and devices still work.",
      noWebsiteSummary: "No website",
      domainHelp: "Optional. Leave empty for a dealer with no website of its own.",
      regionalHelp: "Set from the country. Change it if this dealer differs.",
      batteryReportSubscriptionHelp: "Lets this dealer generate battery certificates.",
      teslaAttributesHelp: "Shows Tesla-specific attributes on this dealer's Tesla vehicle pages.",
      validation: {
        name: "Enter the dealer name",
        oem: "Choose an OEM",
        street: "Enter the street address",
        city: "Enter the city",
        state: "Choose a state or province",
        zipCode: "Enter a ZIP or postal code",
        salesPhone: "Enter a 10-digit phone number",
        domainProtocol: "Remove the protocol (like https://) and enter only the domain, like dealer.com",
        domainFormat: "Enter a domain like dealer.com",
        latitudeFormat: "Enter latitude as a number, like 45.5",
        latitudeRange: "Latitude must be between -90 and 90",
        latitudeMissing: "Enter a latitude, or clear the longitude too",
        longitudeFormat: "Enter longitude as a number, like -73.6",
        longitudeRange: "Longitude must be between -180 and 180",
        longitudeMissing: "Enter a longitude, or clear the latitude too",
        gaTrackingId: "Enter Google Analytics 4 IDs that start with G-, separated by a semicolon with no spaces",
        teslaLookupLimit: "Enter a whole number between 1 and {{max}}, or leave empty for the plan default"
      },
      success: {
        title: "{{name}} was created",
        testStatus: "It's in Test status. Finish setup so the dealer can generate battery certificates.",
        addUser: "Add a portal user",
        assignDevice: "Assign a device"
      },
      coordinates: {
        help: "Optional. Set the exact map position of the dealer. Leave both empty to keep the default."
      },
      addressSearch: {
        label: "Search for an address",
        placeholder: "Start typing the dealer's address",
        failed: "Couldn't load address suggestions. You can still enter the address and coordinates yourself."
      },
      gaTrackingIdHelp: "Separate several IDs with a semicolon and no spaces."
    },
    creating: "Creating...",
    country: {
      US: "United States",
      CA: "Canada"
    },
    currency: {
      USD: "USD",
      CAD: "CAD"
    },
    edit: {
      title: "Edit configuration",
      submit: "Save changes",
      saved: "{{name}} was saved",
      removeDomain: "Remove {{item}}",
      appearance: {
        title: "Appearance",
        accent: "Accent color",
        cta: "CTA color",
        radius: {
          title: "Corner radius",
          none: "None",
          medium: "Default",
          full: "Full"
        },
        mode: {
          title: "Light or dark mode",
          LIGHT: "Light",
          DARK: "Dark"
        },
        accentContrast: "Accent contrast color",
        accentContrastHelp: "Set automatically from the accent color.",
        cssStyling: "Generated CSS",
        cssStylingHelp: "Regenerated from the accent and CTA colors when you save.",
        extensionNote: "Open {{url}} in Chrome with the Lyteflo extension to preview colors and styles on the dealer's site.",
        extensionNoteNoUrl: "Open the dealer's website in Chrome with the Lyteflo extension to preview colors and styles."
      }
    },
    saving: "Saving...",
    load: {
      error: "Couldn't load this configuration. Check your connection and try again.",
      retry: "Try again",
      back: "Back to dealers"
    },
    value: {
      on: "On",
      off: "Off"
    },
    group: {
      newOption: "New group\u2026",
      newTitle: "New group",
      editTitle: "Edit group",
      editOption: "Edit group",
      name: "Group name",
      nameError: "Enter the group name",
      consentForwarding: "Consent forwarding",
      cancel: "Cancel",
      save: "Save group",
      forbidden: "Only an LF Admin can create or change a dealer group.",
      server: "Couldn't save the group because of a server error. Try again."
    },
    widgets: {
      title: "Widgets",
      description: "Which widgets show on the dealer's website, and where.",
      listLabel: "Dealer widgets",
      empty: "No widgets yet.",
      add: "Add a widget",
      choose: "Choose a widget...",
      enabled: "{{name}}: on",
      remove: "Remove {{name}}",
      removeLabel: "Remove",
      unsupported: "Not supported for this provider",
      type: "Type",
      types: {
        portrait: "Portrait",
        landscape: "Landscape"
      },
      desktopPosition: "Desktop position",
      mobilePosition: "Mobile position",
      positionPlaceholder: "Default position",
      mobilePositionPlaceholder: "Same as desktop",
      mobilePositionHelp: "Leave empty to use the desktop position.",
      defaultSlotPlaceholder: "Default: {{slot}}",
      positionHelp: "Enter a CSS selector, or on Dealer.com a slot name like primary-banner. Leave empty for the default position.",
      customPlacementDesktop: "Custom placement (desktop)",
      customPlacementMobile: "Custom placement (mobile)",
      dealerComPositionHelp: "On Dealer.com, a slot name such as primary-banner places the widget through Dealer.com. Anything else is treated as a CSS selector.",
      customPlacementHelp: "Dealer.com only. Kept for compatibility with the extension; it no longer changes how the widget is placed.",
      names: {
        vehicleSavings: "Potential EV Savings",
        vehicleSavingsV2: "EV Savings",
        incentivesV2: "Incentives",
        battery: "Battery and Range",
        charging: "Charging",
        chargeMap: "Charge Map",
        srpSavings: "SRP Savings",
        batteryReportBadge: "Battery Certificate",
        srpImageBatteryBadge: "SRP Image Battery Badge",
        srpIconStackBatteryBadge: "SRP Icon Stack Battery Badge",
        standaloneIncentives: "EV Incentives"
      },
      confirm: {
        disable: {
          title: "Turn off {{name}}?",
          body: "It stops showing on the dealer's website once you save.",
          confirm: "Turn off"
        },
        remove: {
          title: "Remove {{name}}?",
          body: "It is removed from the dealer's website once you save, along with its settings and styles.",
          confirm: "Remove"
        }
      }
    },
    extension: {
      note: "Type a position here. Picking the element on the page and dragging widgets into place are only possible in the Chrome extension.",
      elementTail: "Open {{url}} in Chrome with the Lyteflo extension to pick the element on the dealer's page.",
      elementTailNoUrl: "Open the dealer's website in Chrome with the Lyteflo extension to pick the element on the page.",
      placementTail: "Open {{url}} in Chrome with the Lyteflo extension to drag widgets into position.",
      placementTailNoUrl: "Open the dealer's website in Chrome with the Lyteflo extension to drag widgets into position."
    },
    requirements: {
      title: "Requirements",
      intro: "Still missing before this dealer can go live:",
      complete: "Nothing is missing.",
      fields: {
        language: "Language",
        crmEmail: "CRM Email",
        replyEmail: "Reply Email",
        batteryReportEmail: "Battery Report Email"
      }
    }
  },
  contextSelector: {
    all: "All dealerships",
    dealerships: "dealerships",
    grouped: "Groups",
    ungrouped: "Dealerships",
    searchPlaceholder: "Search dealerships\u2026",
    noResults: "No dealerships found"
  },
  pwa: {
    banner: {
      title: "Install Lyteflo Portal",
      ios: "Tap the share button, then <0>Add to Home Screen</0>",
      android: "Install Lyteflo app for a better experience",
      install: "Install",
      dismiss: "Not now"
    }
  },
  notFound: {
    title: "Page not found",
    subtitle: "All the juice is gone",
    description: "Looks like our battery's run flat and we've hit a 404. No worries, we're charging up to get you back on the road. In the meantime:",
    cta: "Return to the home page",
    contact: "Contact us:",
    reportNotAvailable: {
      title: "Certificate not available",
      description: "This certificate doesn't exist, or it isn't publicly available yet. Check that the link is correct."
    }
  },
  navigation: {
    settings: "Settings",
    lyteflo: "Lyteflo",
    home: "Home",
    liveScan: "Scan",
    reports: "Certificates",
    unscanned: "Inventory",
    vehicleProfileBrowser: "Vehicle Profile Browser",
    devices: "Devices",
    help: "Help",
    profile: "Profile",
    users: "Users",
    dealerConfig: "Dealership Configuration",
    wifiConfig: "Wi-Fi Configuration",
    vehicleSupport: "Vehicle Support",
    campaigns: "Campaigns",
    logout: "Logout",
    tesla: "Tesla",
    teslaAccount: "Tesla accounts"
  },
  auth: {
    signIn: "Sign in",
    requestOtp: "Continue",
    customerLogin: "Go to customer login",
    lytefloLogin: "Go to Lyteflo login",
    logout: "Logout",
    authenticationFailed: "Authentication failed",
    signInToAccount: "Sign in to your account",
    signInToAccountAdmin: "Let's make something great!",
    signInWith: "Sign in with",
    emailPlaceholder: "email@company.com",
    workEmail: "Work email",
    emailCaseHint: "Sign-in is case-sensitive. Type your email exactly as it was registered.",
    alreadyHaveCode: "Already have a code?",
    otp: {
      title: "We emailed you a one-time password",
      subtitleTop: "We sent an email to <email>{{email}}</email>.",
      subtitleBottom: "Enter the password below to login:",
      inputLabel: "One-time password digit {{index}}",
      spamHint: "If you don't see the email, check your spam or junk folder.",
      retryQuestion: "Can't find the email?",
      resendAction: "Click here to resend.",
      resent: "A new password has been sent to {{email}}.",
      backToLogin: "Back to login"
    },
    error: {
      authError: "Authentication Error",
      signOutError: "Error signing out",
      invalidPassword: "Invalid password",
      passwordsDoNotMatch: "Passwords do not match",
      userDoesNotExist: "This user does not exist",
      invalidOrExpiredOtp: "One-time password is invalid or has expired, please try again",
      invalidEmail: "Please enter a valid email address.",
      notFound: "No account was found for this email address.",
      generic: "Unable to request a sign-in code.",
      sessionLoadFailed: "Something went wrong. Please sign in again.",
      missingSession: "Missing OTP session. Request a new sign-in code.",
      invalidCode: "The verification code is invalid.",
      verifyFailed: "Unable to verify the code."
    }
  },
  profile: {
    sections: {
      details: {
        title: "Details",
        firstName: "First Name",
        lastName: "Last Name",
        role: "Role",
        preferredLanguage: "Preferred Language",
        preferredTheme: "Preferred Theme"
      },
      organization: {
        title: "Organization",
        group: "Dealer Group",
        dealership: "Dealership"
      },
      security: {
        title: "Security",
        email: "Email",
        password: "Password",
        changePassword: "Change Password",
        editPassword: "Edit Password",
        oldPassword: "Old Password"
      },
      notifications: {
        title: "Notifications",
        receiveBatteryReportEmail: "Receive battery report by email",
        receiveBatteryReportEmailHint: "Get the battery report PDF and image emailed to you when a scan completes."
      }
    },
    success: {
      updated: "Profile updated successfully",
      canceled: "Changes has been canceled"
    },
    error: {
      fetchError: "Failed to fetch profile",
      updateError: "Failed to update profile"
    }
  },
  users: {
    searchPlaceholder: "Search users",
    email: "Email",
    emailCaseHint: "This person will need to sign in with this exact capitalization. Lowercase is usually safest.",
    firstName: "First Name",
    lastName: "Last Name",
    preferredLanguage: "Preferred language",
    dealership: "Dealership",
    dealerGroup: "Dealer Group",
    roles: "Roles",
    role: "Role",
    status: "Status",
    create: "Create user",
    editUser: "Edit user",
    disableUser: "Disable user",
    disableHint: "Sign-in revoked, account preserved",
    disableConfirmation: "Are you sure you want to disable the user {{userName}} with email {{userEmail}}?",
    receiveBatteryReportEmailHint: "Emails the battery report PDF and image to this user when a scan completes.",
    sections: {
      identity: "Identity",
      dealerAssignment: "Dealer assignment",
      account: "Account"
    },
    mainFilters: {
      all: "All",
      active: "Active",
      disabled: "Disabled",
      invited: "Invited"
    },
    sort: {
      title: "Sort users",
      options: {
        email: "Email",
        name: "Name",
        role: "Role"
      }
    },
    rolesList: {
      lf_admin: "Lyteflo Admin",
      lfAdminDescription: "Full system access and management capabilities",
      lf_user: "Lyteflo User",
      lfUserDescription: "Manage groups and access all ready only features",
      group_admin: "Group Admin",
      groupAdminDescription: "Manage users and settings for a dealer group",
      group_user: "Group User",
      groupUserDescription: "Access to group-level features",
      dealer_admin: "Dealer Admin",
      dealerAdminDescription: "Manage users and settings for a dealership",
      dealer_user: "Dealer User",
      dealerUserDescription: "Basic access to dealership features"
    },
    statusValues: {
      active: "Active",
      forceChangePassword: "Invite sent",
      disabled: "Disabled"
    },
    table: {
      email: "Email",
      name: "Name",
      status: "Status",
      role: "Role",
      group: "Group",
      dealerships: "Dealership(s)",
      actions: {
        addUser: "Add member",
        edit: "Edit",
        disable: "Disable"
      }
    },
    error: {
      userAlreadyExists: "A user with this email already exists",
      createFailed: "Failed to create user",
      fetchFailed: "Failed to fetch users",
      editFailed: "Failed to edit user",
      disableFailed: "Failed to disable user"
    },
    success: {
      userCreated: "User created successfully. The user will receive an invitation email.",
      userEdited: "User edited successfully",
      userDisabled: "User disabled successfully"
    }
  },
  dashboard: {
    todayReports: "Today's certificates",
    currentMonthReports: "Current month's certificates",
    lastMonthReports: "Previous month's certificates",
    lastThreeMonthReports: "Last 3 months certificates",
    recentReports: "Recent certificates",
    awaitingScan: "Awaiting scan",
    viewAll: "View all",
    complete: "Complete",
    reporting: "Reporting",
    connected: "Connected",
    inactive: "Inactive",
    disconnected: "Disconnected",
    disconnectedDescription: "Last time connected",
    report: "Certificate",
    error: {
      fetchFailed: "Failed to fetch dashboard metrics"
    }
  },
  liveScan: {
    title: "Live Scans",
    unregisteredDevice: "Unregistered Device",
    detectedDevices: "Detected devices",
    noDeviceTitle: "No device detected",
    noDeviceDescription: "Plug a Lyteflo Device into a vehicle to get started.",
    viewDetails: "View scans",
    restartScan: "Restart Scan",
    restarting: "Restarting",
    viewReport: "View Certificate",
    firmwareUpdate: {
      checking: "Checking for device update",
      inProgress: "Updating firmware {{progress}}%",
      restarting: "Update done, device restarting"
    },
    error: {
      trimUpdateFailed: "Failed to update trim",
      restartScanFailed: "Failed to restart scan"
    },
    showRawView: "Show timeline",
    timelineEventCount_one: "{{count}} event",
    timelineEventCount_other: "{{count}} events",
    rawView: {
      deviceInfo: "Device info",
      deviceSerial: "Serial",
      sessionId: "Session ID",
      firmwareVersion: "Firmware version",
      lastConnectionStatus: "Device status",
      events: "Scan events",
      meta: {
        ssid: "SSID: {{value}}",
        vin: "VIN: {{value}}",
        report: "Certificate: {{value}}"
      }
    },
    toast: {
      newSession: "Device {{deviceName}} has started a new session.",
      disconnected: "Device {{deviceName}} has been disconnected.",
      disconnectedInactivity: "Device {{deviceName}} has been disconnected after two minutes of inactivity.",
      vinNotAcquired: "Enter VIN on scan #{{scanNumber}}: {{deviceName}} to proceed",
      awaitingTrimSelection: "Device {{deviceName}} needs the trim to generate a certificate",
      reportGenerated: "Device {{deviceName}} has generated a certificate"
    },
    status: {
      unknownStatus: "Unknown status",
      identifyingVehicle: "Identifying vehicle",
      pullingData: {
        pullingBatteryData: "Pulling battery data",
        countingElectrons: "Counting electrons",
        kickingTheTires: "Kicking the tires"
      },
      crunchingNumbers: {
        crunchingTheNumbers: "Crunching the numbers",
        doingBatteryScience: "Doing battery science"
      },
      logging: "Logging",
      loggingComplete: "Logging complete",
      finishingUp: "Finishing up",
      complete: "Certificate generated",
      inReview: "Certificate in review",
      dev: "Certificate in development",
      reportSavedWithoutTrim: "Certificate saved without trim",
      reportSavedWithoutTrimHelp: "Certificate has been saved but requires a trim. Generate the certificate by selecting a trim in <0>the certificate list</0>",
      userAction: {
        vinNotAcquired: "Enter VIN below",
        awaitingTrimSelection: "Missing trim"
      },
      error: {
        vehicleNotSupported: "Vehicle not supported",
        vehicleNotSupportedLink: "This vehicle is not yet supported for Battery Certificates. <0>Click here</0> to see the list of supported vehicles.",
        vinNotDecoded: "Failed to decode VIN",
        reportGenerationFailed: "Failed to generate certificate",
        reportGenerationFailedHelp: "Something went wrong. Please try to scan the vehicle again. Still having trouble - <0>click here</0> to send us a message.",
        loggingSessionFailed: "Logging session failed",
        vehicleUnresponsive: "Vehicle not responding",
        vehicleUnresponsiveHelp: "Vehicle is not responding. Please ensure the car is turned on, then start a new scan."
      }
    },
    vinInput: {
      label: "VIN",
      placeholder: "Enter 17-character VIN",
      submit: "Submit VIN",
      submitting: "Submitting...",
      success: "VIN submitted successfully",
      scanButton: "Scan VIN from image",
      scanSuccess: "VIN scanned successfully",
      error: {
        empty: "Please enter a VIN",
        invalidVin: "Invalid VIN. Please manually enter a valid VIN.",
        sendFailed: "Failed to send VIN. Please try again."
      },
      scanner: {
        title: "Scan VIN",
        aim: "Line up the VIN with the box",
        aimSub: "You can also point your camera at a barcode or QR code",
        uploadPrompt: "Upload a photo of the VIN, barcode, or QR code",
        uploadButton: "Choose a photo",
        uploadFailed: "Couldn't read a VIN from that photo. Try another.",
        permissionDenied: "Camera permission denied",
        noCamera: "Camera unavailable",
        cancel: "Cancel"
      }
    },
    trimInput: {
      submit: "Submit Trim",
      submitting: "Submitting...",
      success: "Trim submitted successfully",
      error: {
        sendFailed: "Failed to send trim. Please try again."
      }
    }
  },
  reports: {
    title: "Battery Certificates",
    searchPlaceholder: "Search certificate",
    mainFilters: {
      all: "All Certificates",
      allInventory: "In Inventory",
      notInventory: "Not In Inventory",
      archived: "Archived"
    },
    table: {
      date: "Date",
      cellHealth: "Cell Health",
      vehicle: "Vehicle / Certificate Status",
      trim: "Trim",
      vin: "VIN",
      stockNumber: "Stock #",
      country: "Country",
      reportResult: "Certificate status",
      vehicleSupport: "Vehicle support",
      configurationId: "Config. ID",
      dealership: "Dealership",
      odometer: "Odometer",
      score: "Score",
      published: "Published",
      tags: {
        new: "New"
      },
      actions: {
        report: "Certificate",
        debug: "Debug",
        copyJson: "Copy JSON",
        copiedJson: "Copied!",
        regenerate: "Regenerate",
        editStatus: "Edit Status",
        changeCountry: "Change country",
        archive: "Archive",
        copyPublicLink: "Copy Public Link",
        selectTrimToGenerate: "Select a trim to generate the certificate",
        download: {
          label: "Download",
          pdfCertificate: "PDF certificate",
          pngShortCertificate: "PNG short certificate",
          unavailable: "PDF has not been generated for this report yet"
        }
      },
      actionRequired: "Action required: Select Trim"
    },
    error: {
      fetchFailed: "Failed to fetch battery certificates",
      trimUpdateFailed: "Failed to update trim",
      statusUpdateFailed: "Failed to update certificate status",
      publishUpdateFailed: "Failed to update publish status",
      pictureUploadFailed: "Failed to upload picture",
      fileTooLarge: "File size must be less than 4MB",
      regenerateReportFailed: "Failed to regenerate certificate",
      archiveReportFailed: "Failed to archive certificate",
      copyPublicLinkFailed: "Failed to copy public link",
      downloadCertificateFailed: "Failed to download certificate",
      fetchTrimsFailed: "Failed to fetch trims",
      countryUpdateFailed: "Failed to update country"
    },
    success: {
      trimUpdated: "Trim updated successfully. Generating a new certificate...",
      statusUpdated: "Certificate status updated successfully",
      publishToggled: "Publish status toggled successfully",
      pictureUploaded: "Picture uploaded successfully",
      regenerateReport: "Certificate regenerated successfully",
      archiveReport: "Certificate archived successfully",
      publicLinkCopied: "Public link copied to clipboard",
      countryUpdated: "Country updated successfully. Generating a new certificate..."
    },
    changeTrim: {
      title: "Confirm trim change",
      description: "Adjusting the trim will generate a new certificate and void old certificates for this VIN. Are you sure you want to proceed?"
    },
    editStatus: {
      title: "Edit certificate status",
      statusLabel: "Status",
      statusPlaceholder: "Select status"
    },
    changeCountry: {
      title: "Change country to {{country}}",
      description: "Changing the country will void the current certificate and generate a new one for this VIN in {{country}}. Are you sure you want to proceed?",
      noTrimsFound: "This vehicle is not available in {{country}}",
      generate: "Generate"
    }
  },
  unscannedInventory: {
    title: "Inventory",
    searchPlaceholder: "Search by VIN, stock #, make, model or dealership",
    mainFilters: {
      supportedUnscanned: "Awaiting scan",
      unsupported: "Unsupported",
      all: "All EV/PHEV"
    },
    table: {
      vehicle: "Vehicle",
      year: "Year",
      make: "Make",
      model: "Model",
      trim: "Trim",
      stockNumber: "Stock #",
      vin: "VIN",
      supported: "Supported",
      scanStatus: "Scan status",
      country: "Country",
      dealership: "Dealership",
      actions: {
        certificate: "Certificate"
      }
    },
    status: {
      scanned: "Scanned",
      unscanned: "Unscanned"
    },
    supported: {
      yes: "Supported",
      no: "Not supported"
    },
    exportCsv: "Export CSV",
    empty: "No vehicles match these filters.",
    error: {
      fetchFailed: "Failed to load unscanned inventory.",
      exportFailed: "Failed to export unscanned inventory."
    }
  },
  help: {
    title: "Help",
    subtitle: "Need help?",
    description: "Visit our support center at <0>https://support.lyteflo.com/</0>"
  },
  devices: {
    searchPlaceholder: "Search device",
    deleteDevice: "Delete device",
    deleteConfirmation: "Are you sure you want to delete the device {{deviceName}} with serial number {{serialNumber}}?",
    editDevice: "Edit device",
    openWifiSettings: "Open Wi-Fi Settings",
    debugging: "Debugging",
    diagnostic: "Diagnostic",
    logging: "Logging",
    addNote: "Add note",
    notePlaceholder: "Write your note here...",
    trackingUrl: "Tracking URL",
    noTrackingUrl: "No tracking URL",
    tracking: "Tracking",
    chipId: "Unregistered device ID",
    emptyIccid: "No ICCID provided for this device",
    mainFilters: {
      allDevices: "All Devices",
      active: "Active",
      assignedDevices: "Assigned",
      unassignedDevices: "Unassigned",
      shipped: "Shipped",
      inactive: "Inactive"
    },
    status: {
      active: "Active",
      shipped: "Shipped",
      tracking: "Tracking",
      inactive: "Inactive"
    },
    table: {
      name: "Device Name",
      iccid: "ICCID",
      serialNumber: "Serial Number",
      configurationId: "Config. ID",
      dealership: "Dealership",
      secondaryDealerships: "Secondary Dealerships",
      assignedDate: "Assigned Date",
      status: "Status",
      country: "Country",
      showReports: "Certificates",
      actions: {
        addDevice: "Add device",
        addNote: "Add note",
        viewNote: "View device note",
        edit: "Edit",
        delete: "Delete",
        enableDebugMode: "Start debug",
        disableDebugMode: "Stop debug",
        enableDiagnosticMode: "Start diagnostic",
        disableDiagnosticMode: "Stop diagnostic",
        enableLoggingMode: "Start logging",
        disableLoggingMode: "Stop logging"
      }
    },
    error: {
      fetchFailed: "Failed to fetch devices",
      createFailed: "Failed to create device",
      deviceUpdateFailed: "Failed to update device",
      deviceDeleteFailed: "Failed to delete device",
      noteUpdateFailed: "Failed to update note",
      noteCreateFailed: "Failed to create note",
      debugModeToggleFailed: "Failed to update debug mode",
      diagnosticModeToggleFailed: "Failed to update diagnostic mode",
      loggingModeToggleFailed: "Failed to update logging mode",
      trackingUrlUpdateFailed: "Failed to update tracking URL",
      fetchUnregisteredDevicesFailed: "Failed to fetch unregistered devices"
    },
    success: {
      deviceCreated: "Device created successfully",
      noteCreated: "Note created successfully",
      noteUpdated: "Note updated successfully",
      deviceUpdated: "Device updated successfully",
      deviceDeleted: "Device deleted successfully",
      debugModeEnabled: "Debug mode enabled successfully",
      debugModeDisabled: "Debug mode disabled successfully",
      diagnosticModeEnabled: "Diagnostic mode enabled successfully",
      diagnosticModeDisabled: "Diagnostic mode disabled successfully",
      loggingModeEnabled: "Logging mode enabled successfully",
      loggingModeDisabled: "Logging mode disabled successfully",
      trackingUrlUpdated: "Tracking URL updated successfully"
    }
  },
  wifis: {
    searchPlaceholder: "Search Wi-Fi",
    deleteWifi: "Delete Wi-Fi",
    deleteConfirmation: "Are you sure you want to delete the Wi-Fi {{ssid}}?",
    editWifi: "Edit Wi-Fi",
    table: {
      ssid: "SSID",
      password: "Password",
      configurationId: "Config. ID",
      dealership: "Dealership",
      actions: {
        addWifi: "Add Wi-Fi",
        edit: "Edit password",
        delete: "Delete"
      }
    },
    error: {
      fetchFailed: "Failed to fetch Wi-Fi",
      createFailed: "Failed to create Wi-Fi",
      wifiUpdateFailed: "Failed to update Wi-Fi",
      wifiDeleteFailed: "Failed to delete Wi-Fi"
    },
    success: {
      wifiCreated: "Wi-Fi created successfully",
      wifiUpdated: "Wi-Fi updated successfully",
      wifiDeleted: "Wi-Fi deleted successfully"
    }
  },
  vehicleSupport: {
    title: "Vehicle Support",
    searchPlaceholder: "Search vehicle",
    table: {
      vehicle: "Vehicle",
      year: "Year",
      make: "Make",
      model: "Model",
      trim: "Trim",
      variant: "Variant",
      status: "Status",
      newVehicle: "New vehicle",
      createdAt: "Created at",
      updatedAt: "Updated at",
      actions: {
        addVehicle: "Add vehicle",
        edit: "Edit",
        delete: "Delete"
      }
    },
    filters: {
      yearFrom: "Year from",
      yearTo: "Year to",
      yearRangeInvalid: '"Year from" must be before or equal to "Year to".'
    },
    batch: {
      selectAll: "Select all",
      selectedCount_one: "{{count}} selected",
      selectedCount_other: "{{count}} selected",
      selectAllMatching: "Select all {{count}} matching this filter",
      allMatchingSelected_one: "All {{count}} matching vehicle selected",
      allMatchingSelected_other: "All {{count}} matching vehicles selected",
      clearSelection: "Clear selection",
      updateStatus: "Update status",
      setStatusTo: "Set status to",
      confirmTitle: "Update vehicle status",
      confirmIntro_one: "You're about to set the support status of <strong>{{count}} vehicle</strong> to:",
      confirmIntro_other: "You're about to set the support status of <strong>{{count}} vehicles</strong> to:",
      currentStatuses: "Current statuses in selection",
      allMatchingNote: "Includes all {{count}} vehicles matching the current filter, across every current status.",
      updateConfirm_one: "Update {{count}} vehicle",
      updateConfirm_other: "Update {{count}} vehicles",
      successToStatus_one: "{{count}} vehicle updated to {{status}}",
      successToStatus_other: "{{count}} vehicles updated to {{status}}",
      error: "Failed to update vehicle statuses"
    },
    deleteVehicle: "Delete vehicle",
    deleteConfirmation: "Are you sure you want to delete {{vehicle}}?",
    error: {
      fetchFailed: "Failed to fetch supported vehicles",
      createFailed: "Failed to create supported vehicle",
      updateFailed: "Failed to update supported vehicle",
      deleteFailed: "Failed to delete supported vehicle"
    },
    success: {
      vehicleCreated: "Supported vehicle created successfully",
      vehicleUpdated: "Supported vehicle updated successfully",
      vehicleDeleted: "Supported vehicle deleted successfully"
    },
    features: {
      title: "Battery diagnostics",
      labels: {
        featureSoh: "State of Health",
        featureCellHealth: "Cell Health",
        featureIndividualCells: "Individual Cells",
        featureDtcCleared: "DTC Cleared",
        featureRange: "Range",
        featureChargeRatio: "Charge Ratio",
        featureBenchmark: "Benchmark"
      },
      short: {
        featureSoh: "SoH",
        featureCellHealth: "Cell",
        featureIndividualCells: "Ind",
        featureDtcCleared: "DTC",
        featureRange: "Range",
        featureChargeRatio: "Ratio",
        featureBenchmark: "Bench"
      },
      status: {
        SUPPORTED: "Supported",
        OPTIONAL: "Optional",
        NOT_SUPPORTED: "Not supported",
        UNSET: "Not set"
      }
    }
  },
  ownershipReport: {
    title: "Ownership Report",
    subtitle: "If you own the {{vehicle}} for {{years}} years and drive {{distance}} {{distanceUnit}} / year",
    inLocation: "in {{location}}",
    totalSubtitle: "Total {{years}} year savings (or {{monthly}}/mo)",
    costPerMi: "Cost per mile",
    costPerKm: "Cost per km",
    overYears: "Over {{years}} years",
    fuelCost: "Fuel Cost",
    maintenanceCost: "Maintenance Cost",
    environmentalImpact: "Environmental Impact",
    howItsCalculated: "How it's calculated",
    fuelEfficiency: "Fuel Efficiency (per 100 {{distanceUnit}})",
    costToDrive: "Cost to drive {{distance}} {{distanceUnit}}",
    carbonSavings: "Equivalent to saving {{trees}} trees ({{totalCO2Savings}} {{burnUnit}} of CO2)",
    co2Emitted: "CO2 emitted / {{distanceUnit}}",
    co2EmittedTotal: "CO2 emitted after {{distance}} {{distanceUnit}}",
    treeConsumption: "1 tree consumes about {{consumption}} {{unit}} of CO2 / year. {{emissions}} {{unit}} / {{consumption}} {{unit}} = {{trees}} trees.",
    contactDealership: "Contact {{name}}",
    inGasSavings: "{{savings}} in gas savings",
    inMaintenanceSavings: "{{savings}} in maintenance savings",
    sales: "Sales",
    service: "Service",
    parts: "Parts",
    moreEfficient: "more efficient",
    lessExpensive: "less expensive to drive",
    poweredBy: "Powered by",
    disclaimer: {
      title: "Disclaimer",
      header: "Legal things we have to disclose",
      description: "Potential savings are estimated based on public data, information from dealers and manufacturers, user inputs, and historical trends. These estimates are not guarantees of actual savings. Actual savings may vary based on your circumstances, market conditions, and factors beyond our control."
    }
  },
  unsubscribe: {
    title: "Unsubscribe from Lyteflo Emails",
    subtitle: "We're sorry to see you go! Please confirm below to unsubscribe from our communications.",
    success: "You have been successfully unsubscribed from Lyteflo emails!",
    confirm: "Unsubscribe"
  },
  vehicleProfileBrowser: {
    pageTitle: "Vehicle Profile Browser",
    search: {
      title: "Search for a Vehicle Profile",
      description: "Type to search or use the filters below to select a vehicle profile",
      loadingProfiles: "Loading vehicle profiles...",
      placeholder: "Search by make or model (e.g., 'tesla model 3')",
      clear: "Clear",
      orUseFilters: "or use filters",
      make: "Make",
      model: "Model",
      year: "Year",
      trim: "Trim",
      selectMakeModelYearFirst: "select make, model, year first",
      selectMake: "Select Make",
      selectModel: "Select Model",
      selectYear: "Select Year",
      selectTrimOptional: "Select Trim (optional)",
      loadProfile: "Load Vehicle Profile",
      loadingProfile: "Loading Vehicle Profile...",
      topMatches: "Top Matches",
      availableProfiles: "Available Vehicle Profiles ({{count}})"
    },
    profileViewer: {
      backToSearch: "Back to Search",
      activeLayers: "Active Layers (click to edit)",
      tab: {
        inputs: "Inputs",
        strategies: "Strategies",
        limits: "Limits",
        index: "Index",
        json: "JSON"
      },
      viewInEditor: "View in editor",
      openInLayer: "Open in layer:"
    },
    inputs: {
      scalarsCount: "Scalars ({{filtered}} / {{total}})",
      arraysCount: "Arrays ({{filtered}} / {{total}})",
      searchPlaceholder: "Search inputs..."
    },
    strategies: {
      count: "Strategies ({{filtered}} / {{total}})",
      searchPlaceholder: "Search strategies...",
      directMappings: "Direct Mappings ({{count}})",
      mapsTo: "maps to",
      mapsToLabel: "Maps to",
      otherStrategies: "Other Strategies ({{count}})",
      priority: "Priority",
      formula: "Formula",
      strategy: "Strategy",
      array: "Array",
      statistic: "Statistic",
      bindingsCount: "Bindings ({{count}})",
      parametersCount: "Parameters ({{count}})"
    },
    limits: {
      count: "Limits ({{filtered}} / {{total}})",
      searchPlaceholder: "Search limits...",
      warnRangeLabel: "Warn",
      criticalRangeLabel: "Critical"
    },
    index: {
      noIndexData: "No index data available",
      compositionCriteria: "Composition Criteria",
      notSpecified: "Not specified",
      compositionLayers: "Composition Layers",
      required: "Required",
      active: "Active",
      when: "When",
      files: "Files",
      viewRawIndexJson: "View Raw Index JSON",
      year: "Year",
      trim: "Trim"
    },
    validation: {
      title: "Validation",
      autoValidate: "Auto-validate",
      validating: "Validating...",
      checkProfile: "Check Vehicle Profile",
      validationError: "Validation Error",
      passed: "Passed",
      failed: "Failed",
      metricsAnalyzed: "{{count}} metrics analyzed",
      errorCount: "{{count}} Error(s)",
      warningCount: "{{count}} Warning(s)",
      infoCount: "{{count}} Info",
      errors: "Errors",
      warnings: "Warnings",
      info: "Info",
      noIssuesFound: "No issues found",
      clickCheckProfileToValidate: 'Click "Check Vehicle Profile" to validate'
    },
    componentBrowser: {
      title: "Component Browser",
      description: "Browse and search vehicle profile components.",
      loadingComponentGraph: "Loading component graph...",
      totalComponents: "Total components",
      totalMakes: "Makes",
      totalModels: "Models",
      uniqueToVehicle: "Unique to vehicle",
      sharedByVehicles: "Shared by 10+ vehicles",
      searchPlaceholder: "Search components...",
      filterByMake: "Filter by make",
      allMakes: "All makes",
      filterByModel: "Filter by model",
      allModels: "All models",
      componentsCount: "{{count}} component(s)",
      noComponentsFound: "No components found",
      shared10Plus: "Shared by 10+ vehicles ({{count}})",
      shared6To10: "Shared by 6\u201310 vehicles ({{count}})",
      shared2To5: "Shared by 2\u20135 vehicles ({{count}})",
      uniqueCount: "Unique to 1 vehicle ({{count}})"
    },
    componentEditor: {
      title: "Component Editor",
      close: "Close",
      loadingComponent: "Loading component...",
      jsonContent: "JSON Content",
      validJson: "Valid JSON",
      invalidJson: "Invalid JSON",
      modified: "Modified",
      jumpToError: "Click to jump to error location",
      enableEditing: "Enable Editing",
      savedSuccessfully: "Saved successfully",
      backupCreated: "backup created",
      duplicating: "Duplicating...",
      duplicateComponent: "Duplicate Component",
      saveChanges: "Save Changes",
      saving: "Saving...",
      usedBy: "Used By ({{count}} vehicle configurations)",
      notUsedByAnyVehicles: "This component is not used by any vehicles.",
      years: "Years",
      trims: "Trims",
      duplicatedTo: "Duplicated to {{path}}. Edit and save to create the new file.",
      duplicateError: "Duplicate failed",
      invalidJsonFallback: "Invalid JSON",
      allYears: "All years",
      allTrims: "All trims"
    }
  },
  campaigns: {
    title: "Campaigns",
    createTitle: "Create New Campaign",
    editTitle: "Edit Campaign",
    searchPlaceholder: "Search campaigns",
    addCampaign: "Add Campaign",
    delete: {
      title: "Delete Campaign",
      message: 'Are you sure you want to delete the campaign "{{name}}"?'
    },
    mainFilters: {
      all: "All",
      draft: "Draft",
      live: "Live",
      complete: "Complete",
      archived: "Archived"
    },
    status: {
      draft: "Draft",
      live: "Live",
      complete: "Complete",
      archived: "Archived"
    },
    table: {
      name: "Name",
      status: "Status",
      enabled: "Enabled",
      source: "Source",
      association: "Association",
      templateKey: "Template",
      startAt: "Start Date",
      endAt: "End Date",
      priority: "Priority",
      actions: {
        edit: "Edit",
        delete: "Delete",
        preview: "Preview",
        copyParam: "Copy Param",
        copiedParam: "Copied!",
        sendToCustomer: "Send to a customer"
      }
    },
    form: {
      basicInfo: "Basic Info",
      templateContent: "Template & Content",
      scheduling: "Scheduling",
      targeting: "Targeting",
      headline: "Headline",
      subtitle: "Subtitle",
      body: "Body",
      ctaLabel: "CTA Label",
      ctaPiiType: "CTA Action",
      disclaimer: "Disclaimer",
      heroImage: "Hero Image",
      heroImageAlt: "Campaign hero image",
      heroImageInvalid: "Image must be a JPEG, PNG, or WebP under 4MB.",
      heroImageUploadFailed: "Could not upload the image. Please try again.",
      removeHeroImage: "Remove hero image",
      source: "Source",
      feedTheme: "Feed Theme",
      pageTargets: "Page Targets",
      openTriggers: "Open Triggers",
      frequencyCap: "Frequency Cap",
      allowedOrigins: "Allowed URLs",
      allowedOriginsPlaceholder: "e.g. *.dealer.com",
      allowedOriginsRequired: "Required when Page Targets is 'All Pages': add at least one URL, or narrow the page targets",
      addOrigin: "Add",
      priorityConflict: "This priority is already used by another campaign in this context",
      templateKeyV2SavingsModal: "v2 Savings Modal",
      templateKeyVehicleAd: "Vehicle Ad",
      datePlaceholder: "DD-MM-YYYY",
      variablesHint: "Type {{ to insert a variable into the text fields below.",
      preview: {
        label: "Preview",
        empty: "Add a headline, subtitle, body, disclaimer, or CTA to see the preview.",
        sampleHint: "Variables are rendered with sample vehicle data ({{vehicleMake}} = Kia, etc.).",
        realDataHint: "Variables are rendered using the campaign's selected vehicle.",
        imagePlaceholder: "Vehicle image",
        evLabel: "Electric Vehicle",
        gasLabel: "Gas Vehicle",
        savingsModalHint: "Customers see the EV Savings Modal with your message, sections, and button.",
        savingsModalSample: "2024 Kia EV6 Wind AWD",
        savingsModalComparison: "Comparing to a {{comparison}}",
        savingsModalComparisonSample: "2024 Toyota Camry",
        savingsModalSection: {
          fuel: "Fuel Savings",
          maintenance: "Maintenance Savings",
          incentives: "Incentives",
          battery: "Battery & Charging"
        }
      },
      schedulingHint: "If no start date is set, the campaign starts immediately. If no end date is set, it runs indefinitely.",
      removeOrigin: "Remove {{origin}}",
      scope: "Scope",
      scopeHint: "Select the group or dealership this campaign applies to.",
      scopePlaceholder: "Select a group or dealership",
      tooltip: {
        priority: "Lower number = shown first (1 before 2). Must be unique among all campaigns for this context.",
        enabled: "When unchecked, this campaign is suppressed and will not appear on the widget, even if status is Live.",
        templateKey: "Determines which widget template is used to display this campaign's content.",
        source: "Lyteflo: you control all content. Meta AIA Feed / Meta AMA Feed: content auto-populates from the feed, based on Feed Theme.",
        feedTheme: "Selects which data category from the feed populates this campaign's content.",
        pageTargets: "Which page types will show this campaign. 'All' covers both VDP and SRP.",
        openTriggers: "How the campaign widget opens. 'URL Parameter' means a query param triggers the widget; 'Auto' means it opens automatically on page load.",
        frequencyCap: "Controls how often the same visitor sees this campaign within a session or day.",
        allowedOrigins: "The campaign only shows on URLs matching these patterns (wildcards supported, e.g. *.dealer.com). Can be left empty when page targets are narrowed, but 'All Pages' needs at least one URL.",
        ctaPiiType: "Determines what the CTA button does. 'None' hides the button. Other options open the corresponding lead form.",
        disclaimer: "Optional legal or disclosure text shown below the main content.",
        heroImage: "Optional. Replaces the vehicle photo pulled from inventory with your own image. Leave empty to keep using the inventory photo."
      },
      variables: {
        hint: "Available variables:",
        invalidWarning: "Unknown variable(s): {{variables}}. These will not be replaced."
      },
      vehicles: {
        title: "Vehicles",
        primaryVehicle: "Primary Vehicle",
        comparisonVehicle: "Comparison Vehicle",
        addComparison: "Add comparison vehicle",
        removeComparison: "Remove",
        useVehicleOnPage: "Use vehicle on page",
        vin: "VIN",
        ymmt: "Year / Make / Model / Trim",
        year: "Year",
        make: "Make",
        model: "Model",
        trim: "Trim",
        vinPlaceholder: "Enter VIN",
        vinInvalid: "Invalid VIN",
        vinValid: "Valid VIN",
        selectYear: "Select year",
        selectMake: "Select make",
        selectModel: "Select model",
        selectTrim: "Select trim",
        noVehicleFound: "No vehicle found for this combination",
        unresolvedTrim: "This trim can't be matched to our vehicle catalog. Pick a different trim.",
        check: {
          checking: "Checking this vehicle's data...",
          failed: "We couldn't check this vehicle's data. Try again later.",
          trimNotFound: "We couldn't find the saved trim for this year, make and model. Re-select the vehicle.",
          noFuelEconomy: "No fuel economy on file for this vehicle. Choose a different vehicle.",
          bevComparison: "The comparison vehicle can't be fully electric (BEV). Choose a gas or hybrid vehicle.",
          noPowertrain: "No powertrain on file for this vehicle. Choose a different vehicle.",
          notElectrified: "The primary vehicle must be electrified (EV, plug-in hybrid or hybrid). Choose a different vehicle.",
          noConsumption: "No energy consumption on file for this vehicle. Choose a different vehicle."
        },
        inventoryOnly: "Only show vehicles in this dealer's inventory",
        powertrain: "Powertrain",
        selectPowertrain: "All powertrains",
        powertrain_BEV: "Battery Electric (BEV)",
        powertrain_PHEV: "Plug-in Hybrid (PHEV)",
        powertrain_HEV: "Hybrid (HEV)",
        powertrain_ICE: "Gas (ICE)",
        powertrain_MHEV: "Mild Hybrid (MHEV)"
      }
    },
    source: {
      manual: "Lyteflo",
      feed: "Feed",
      aia_feed: "Meta AIA Feed",
      ama_feed: "Meta AMA Feed"
    },
    feedTheme: {
      fuel_savings: "Fuel Savings",
      maintenance_savings: "Maintenance Savings",
      range: "Range"
    },
    ctaPiiType: {
      none: "None (no CTA)",
      eligibility: "Incentives Eligibility",
      report: "Savings Report",
      availability: "Check Availability"
    },
    ctaLabelDefault: {
      eligibility: "Check Eligibility",
      report: "Get EV Report",
      availability: "Check Availability"
    },
    frequencyCap: {
      once_per_session: "Once per session",
      once_per_day: "Once per day",
      once_per_week: "Once per week",
      once_ever: "Once ever",
      always: "Always"
    },
    pageTarget: {
      vdp: "VDP",
      srp: "SRP",
      all: "All Pages"
    },
    trigger: {
      link: "URL Parameter",
      auto: "Auto"
    },
    preview: {
      title: "Preview Campaign",
      trigger: "URL Preview",
      urlLabel: "Site URL",
      urlPlaceholder: "https://www.dealer.com/new-vehicles",
      open: "Open Preview",
      invalidUrl: "Invalid URL \u2014 please include https://"
    },
    success: {
      enableToggled: "Campaign updated successfully",
      deleted: "Campaign deleted successfully",
      created: "Campaign created successfully",
      saved: "Campaign saved successfully"
    },
    error: {
      fetchFailed: "Failed to fetch campaigns",
      enableToggleFailed: "Failed to update campaign",
      deleteFailed: "Failed to delete campaign",
      createFailed: "Failed to create campaign",
      saveFailed: "Failed to save campaign",
      loadFailed: "Failed to load campaign"
    },
    warning: {
      heroImageNotSaved: "Campaign saved, but the hero image could not be saved yet \u2014 support for this is coming soon."
    },
    wizard: {
      scopePlaceholder: "Select a group or dealership",
      scopeRequired: "Please select a group or dealership before continuing.",
      steps: "Campaign steps",
      back: "Back",
      skip: "Skip",
      continue: "Continue",
      stepLabels: {
        goal: "Goal",
        vehicle: "Vehicle",
        comparison: "Comparison",
        message: "Message",
        placement: "Placement",
        showWhere: "Where it shows",
        openMode: "How it opens",
        feedSource: "Feed source",
        feedTheme: "Theme",
        schedule: "Schedule",
        review: "Review"
      },
      review: {
        title: "Review your campaign",
        edit: "Edit",
        nameLabel: "Campaign name",
        create: "Create campaign"
      },
      next: {
        title: "Campaign created!",
        saved: "{{name}} has been saved.",
        viewCampaigns: "View campaigns",
        emailPlaceholder: "Your email campaign is ready. Use the compose screen to send it to prospects.",
        feed: "Your feed campaign is live and will power your Meta ad feed automatically.",
        auto: "Your campaign will open automatically on {{targets}} pages for visitors to your site.",
        link: "Share this link anywhere \u2014 anyone who opens it will see your campaign.",
        draftReminder: "This campaign is a draft. Activate it when you're ready to go live.",
        linkBase: "Base URL",
        linkBasePlaceholder: "https://yoursite.com/inventory",
        linkParamsHint: "The campaign parameters are added automatically.",
        linkInvalid: "Enter a valid URL to generate the preview link.",
        linkGuidance: "Add this link to your emails, ads, or any marketing material to open the campaign.",
        downloadQr: "Download QR code",
        openPreview: "Open preview",
        copyLink: "Copy link",
        copiedLink: "Copied!",
        qrFailed: "Couldn't generate the QR code. Please try again."
      },
      goal: {
        question: "What is your campaign goal?",
        promote: "Promote EV",
        promoteDescription: "Showcase an electric vehicle to interested buyers.",
        leads: "Generate Leads",
        leadsDescription: "Capture buyer contact information.",
        feed: "Meta Feed",
        feedDescription: "Power a Meta AIA or AMA ad feed automatically.",
        email: "Email Campaign",
        emailDescription: "Send a personalized email to a prospect.",
        describe: "\u2728 Describe your goal (coming soon)"
      },
      vehicle: {
        question: "Which vehicle do you want to feature?"
      },
      comparison: {
        question: "Add a comparison vehicle?",
        evLabel: "Electric Vehicle",
        gasLabel: "Gas Vehicle",
        bestMatch: "Best match",
        choosePrompt: "Select a comparison vehicle",
        changeVehicle: "Change vehicle"
      },
      message: {
        question: "Customize your message"
      },
      placement: {
        question: "Where should the campaign appear?",
        auto: "Auto",
        autoDescription: "Opens automatically when a visitor lands on the page.",
        link: "URL Parameter",
        linkDescription: "Opens only when triggered by a query parameter in the URL."
      },
      showWhere: {
        question: "Which pages should show this campaign?",
        vdp: "Vehicle Detail Page",
        vdpDescription: "Appears on individual vehicle listing pages.",
        srp: "Search Results Page",
        srpDescription: "Appears on your inventory search and results pages.",
        specific: "Specific Pages",
        specificDescription: "Restrict the campaign to specific URLs or domains you define.",
        specificHint: "Enter the URLs or domains where this campaign should appear. Wildcards are supported, e.g. *.dealer.com."
      },
      openMode: {
        question: "How often should the campaign open?",
        autoSession: "Once per session",
        autoSessionDescription: "Opens automatically \u2014 at most once per visit.",
        autoDay: "Once per day",
        autoDayDescription: "Opens automatically \u2014 at most once per day per visitor.",
        autoWeek: "Once per week",
        autoWeekDescription: "Opens automatically \u2014 at most once per week per visitor.",
        autoOnce: "Once ever",
        autoOnceDescription: "Opens automatically \u2014 only the first time a visitor sees it.",
        link: "On demand (URL parameter)",
        linkDescription: "Only opens when triggered by a link you share or place."
      },
      tuneMessage: {
        question: "Fine-tune your message"
      },
      feedSource: {
        question: "Which Meta feed type?",
        aia: "Meta AIA Feed",
        aiaDescription: "Inventory automatically pulled from your Meta Automotive Inventory Ads catalogue.",
        ama: "Meta AMA Feed",
        amaDescription: "Creative automatically generated from your Meta Automotive Marketing Ads campaign."
      },
      feedTheme: {
        question: "Which feed theme?",
        fuel_savingsDescription: "Highlights how much drivers save on fuel by switching to an EV.",
        maintenance_savingsDescription: "Highlights the lower long-term maintenance costs of electric vehicles.",
        rangeDescription: "Highlights the driving range and charging convenience of your EV models."
      },
      schedule: {
        question: "Set a schedule (optional)",
        now: "Start immediately",
        nowDescription: "The campaign goes live as soon as you save.",
        window: "Set a date range",
        windowDescription: "Choose a start and end date for the campaign.",
        windowHint: "Both dates are optional. Start only \u2192 campaign begins on that date and runs until you stop it. End only \u2192 campaign is live immediately and stops on that date. Both \u2192 campaign runs during that window.",
        endBeforeStart: "The end date must be on or after the start date."
      },
      emailMessage: {
        question: "Compose your email",
        subject: "Subject line",
        subjectDefault: "Exclusive EV savings for you"
      },
      emailCompose: {
        title: "Send to a customer",
        channelEmail: "Email",
        vehicleLabel: "Vehicle",
        firstName: "Customer first name",
        firstNamePlaceholder: "e.g. Alex",
        greeting: "Hi {{name}},",
        greetingGeneric: "Hi there,",
        tab: {
          email: "Email",
          text: "Text"
        },
        copyEmail: "Copy email",
        openMail: "Open in mail client",
        copyText: "Copy text",
        openSms: "Open in messages",
        downloadQr: "Download QR code",
        copied: "Copied!"
      },
      sheet: {
        title: "Campaign Sheet",
        print: "Print campaign sheet",
        printBrowser: "Print (browser)",
        printing: "Generating PDF\u2026",
        loading: "Loading campaign sheet\u2026",
        error: "Campaign sheet could not be loaded.",
        imagePlaceholder: "Vehicle image",
        qrAlt: "Campaign QR code"
      },
      sections: {
        moveUp: "Move up",
        moveDown: "Move down",
        remove: "Remove section",
        add: "Add {{section}}",
        savings: "Savings",
        incentives: "Incentives",
        battery_charging: "Battery & Charging",
        key_trade_offs: "Key Trade-offs"
      }
    }
  },
  tesla: {
    title: "Tesla",
    tabs: {
      quickLookup: "Quick Lookup",
      fleet: "Tesla Fleet"
    },
    lookup: {
      autonomy: "Autonomy",
      batteryCapacity: "Battery capacity",
      configuration: "Factory configuration",
      dataUnavailable: "Data unavailable",
      disclaimer: "This data is as reported by Tesla and may be inaccurate \u2014 verify it against the vehicle. Intended for vehicles that you own.",
      emptyDescription: "Pulls the factory configuration and battery details straight from Tesla.",
      emptyTitle: "Look up a Tesla by VIN",
      invalidVin: "A VIN is {{length}} characters \u2014 check the one you entered.",
      kwh: "kWh",
      measuredOn: "Measured {{date}}",
      noData: {
        title: "No Tesla data for this VIN",
        notFound: "Tesla has no record for this VIN. It may not be a Tesla, or it may predate their data.",
        invalid: "That is not a Tesla VIN. Quick Lookup only covers Tesla vehicles \u2014 other makes need a Lyteflo scan.",
        timeout: "Tesla did not answer in time. Try the lookup again in a moment.",
        error: "Something went wrong reading this VIN. Try again in a moment.",
        empty: "Tesla has a record for this VIN but returned no details for it."
      },
      notProvided: "Tesla doesn't provide this data for this vehicle.",
      superchargingNotReported: "Tesla didn't report a Supercharging tier for this vehicle.",
      optionsTotal: "{{price}} of the options listed",
      readFromTeslaOn: "Read from Tesla on {{date}}.",
      requestFailed: "We could not reach Tesla. Try again in a moment.",
      scan: "Scan a VIN",
      scanSuccess: "VIN scanned",
      stateOfHealth: "State of health",
      submit: "Look up",
      supercharging: "Supercharging",
      usage: {
        counter_one: "{{used}} of {{limit}} lookup used this month",
        counter_other: "{{used}} of {{limit}} lookups used this month",
        counterLifetime_one: "{{used}} of {{limit}} lookup used",
        counterLifetime_other: "{{used}} of {{limit}} lookups used",
        limitFree_one: "You've reached your {{limit}} lookup limit. <contact>Reach out</contact> to add more lookups.",
        limitFree_other: "You've reached your {{limit}} lookup limit. <contact>Reach out</contact> to add more lookups.",
        limitFreeLifetime_one: "You've reached your {{limit}} lookup limit. This limit doesn't reset. <contact>Reach out</contact> to add more lookups.",
        limitFreeLifetime_other: "You've reached your {{limit}} lookup limit. This limit doesn't reset. <contact>Reach out</contact> to add more lookups.",
        limitPaid_one: "You've used {{used}} of your {{limit}} lookup this month. Lookups are still available.",
        limitPaid_other: "You've used {{used}} of your {{limit}} lookups this month. Lookups are still available.",
        warning_one: "You've used {{used}} of your {{limit}} lookup this month.",
        warning_other: "You've used {{used}} of your {{limit}} lookups this month.",
        warningLifetime_one: "You've used {{used}} of your {{limit}} lookup. This limit doesn't reset.",
        warningLifetime_other: "You've used {{used}} of your {{limit}} lookups. This limit doesn't reset."
      },
      vinLabel: "Vehicle VIN",
      vinPlaceholder: "Enter a 17-character VIN"
    },
    history: {
      clear: "Clear history",
      count: "{{count}} of {{limit}}",
      empty: "VINs you look up appear here, ready to open again. The last {{limit}} are kept.",
      soh: "SOH",
      title: "Recent lookups"
    },
    batch: {
      open: "Batch lookup",
      title: "Batch lookup",
      description: "Add VINs one at a time, or paste a whole column \u2014 we'll split it.",
      inputLabel: "VINs to look up",
      inputPlaceholder: "Enter or paste VINs",
      remove: "Remove VIN",
      tesla: "Tesla",
      notTesla: "Not a Tesla",
      invalidLength: "{{length}} of 17 characters",
      invalidChars: "Invalid VIN",
      unresolvedSummary: "{{found}} of {{requested}} VINs returned data. No Tesla data for {{vins}}.",
      count_one: "{{count}} in this batch",
      count_other: "{{count}} in this batch",
      clearAll: "Clear all",
      empty: "Nothing added yet. Paste a column of VINs, or add them one at a time.",
      submit_one: "Look up {{count}} VIN",
      submit_other: "Look up {{count}} VINs",
      submitEmpty: "Look up",
      duplicatesIgnored_one: "{{count}} duplicate ignored",
      duplicatesIgnored_other: "{{count}} duplicates ignored",
      overLimitDropped_one: "{{count}} VIN dropped \u2014 a batch is capped at {{limit}}",
      overLimitDropped_other: "{{count}} VINs dropped \u2014 a batch is capped at {{limit}}"
    },
    fleet: {
      inventory: "Inventory",
      searchPlaceholder: "Search vehicles, VINs or owners",
      noResults: "No vehicles match this filter.",
      generate: "Generate certificate",
      requestCustomer: "Request from a customer",
      notConnectedNotice: "No Tesla account connected, so none of your own vehicles appear here. <connect>Connect your account</connect> to generate certificates for them \u2014 requests you send to customers work either way.",
      table: {
        date: "Date",
        vehicle: "Vehicle",
        vin: "VIN",
        owner: "Owner",
        odometer: "Odometer",
        charge: "Charge",
        batteryHealth: "Battery health",
        vehicleStatus: "Vehicle status",
        certificateStatus: "Certificate status"
      },
      filters: {
        myFleet: "My Fleet",
        appraisals: "Appraisals",
        appraisalsUnavailable: "Appraisals \u2014 coming soon",
        needsCertificate: "Needs certificate",
        allVehicles: "All vehicles"
      },
      vehicleStatus: {
        ready: "Ready",
        waitingOnOwner: "Waiting on owner",
        needsVirtualKey: "Needs virtual key",
        needsSafetyToggle: "Needs in-car setting",
        needsFirmwareUpdate: "Needs a Tesla update",
        atConfigLimit: "Tesla connection limit reached",
        offline: "Offline",
        emailFailed: "Email failed",
        expired: "Link expired",
        cancelled: "Cancelled",
        unsupported: "Not supported",
        unknown: "Not determined yet"
      },
      certificateStatus: {
        ready: "Generated",
        starting: "Starting"
      },
      actions: {
        certificate: "Certificate",
        generate: "Generate",
        unavailable: {
          notSingleDealership: {
            name: "Generate \u2014 pick a single dealership",
            hint: "Pick a single dealership"
          },
          dealershipConfigUnavailable: {
            name: "Generate \u2014 couldn't load this dealership's configuration",
            hint: "Couldn't load this dealership's configuration. Try again in a moment."
          },
          runStateUnknown: {
            name: "Generate \u2014 checking for certificates already running",
            hint: "Checking whether a certificate is already being generated for this vehicle. Refresh to try again."
          }
        },
        resend: "Resend invite",
        cancel: "Cancel request",
        retry: "Generate again"
      },
      generation: {
        waiting: {
          wakingVehicle: "Waking the vehicle",
          readingBattery: "Reading the battery",
          checkingCells: "Checking cell health",
          buildingCertificate: "Building the certificate"
        },
        requestRefused: "Could not start the certificate \u2014 try again",
        requestRefusedNoDealership: "Select a single dealership before generating a certificate",
        requestRefusedStarting: "A generation is already running for this vehicle. Try again in a moment.",
        forVehicle: "{{vehicle}}: {{condition}}",
        notReady: {
          needsVirtualKey: "The owner needs to add Lyteflo's virtual key in the Tesla app.",
          needsSafetyToggle: "The owner needs to turn on data sharing on the car's touchscreen.",
          needsFirmwareUpdate: "This vehicle needs a software update before a report can run.",
          unsupported: "This vehicle doesn't support battery reports.",
          accountNeedsReconnect: "The Tesla account for this vehicle needs to be reconnected.",
          notConnected: "This vehicle is no longer connected to your dealership.",
          offline: "This vehicle is offline. Wake it from the Tesla app or check its cellular or Wi-Fi coverage, then try again.",
          unknownCondition: "Tesla reports this vehicle isn't ready for a battery report."
        },
        failure: {
          label: "Generation failed",
          help: "Generate again, or <0>contact support</0> if it persists."
        },
        debug: {
          open: "Debug",
          title: "Generation debug",
          sessionId: "Session ID",
          vin: "VIN",
          configurationId: "Dealership ID",
          events: "Events",
          vehicleStatus: "Vehicle status",
          vehicleState: "Connectivity",
          blocker: "Readiness verdict",
          reportId: "Report ID",
          noSession: "No run for this vehicle is held in this browser."
        }
      },
      pairing: {
        virtualKey: {
          title: "Pair Lyteflo's virtual key first",
          body: "This Tesla cannot share its battery data until Lyteflo's virtual key is added to it. Open the link on the phone that has the Tesla app, tap <0>Allow</0>, and pick this vehicle.",
          confirm: "I paired my vehicle"
        },
        safetyToggle: {
          title: "Turn on data sharing in the car",
          body: "This Tesla does not use virtual keys, so there is nothing to add in the Tesla app. On the car's touchscreen, open <0>Controls \u203A Safety</0> and turn on <1>Allow Third-Party App Data Streaming</1>.",
          confirm: "I turned data sharing on"
        },
        notDetermined: {
          title: "We don't know about this Tesla yet",
          body: "Tesla has not told us enough about this vehicle to read its battery. That is not a fault \u2014 try again in a few minutes."
        },
        action: "Pair vehicle",
        qrAlt: "QR code for the Tesla pairing link",
        done: "Check this vehicle again",
        prerequisite: "Pairing only works if the owner has a phone key set up in the Tesla app.",
        prerequisiteLink: "How Tesla phone keys work",
        scanOption: "Scan this with the phone that has the Tesla app",
        linkOption: "Or open this link on that phone",
        checking: "Checking this vehicle\u2026",
        readyTitle: "This Tesla is ready",
        readyBody: "Generate its certificate now, or close and come back to it.",
        generate: "Generate certificate",
        pending: "Tesla has not confirmed the pairing yet. Give it a moment, then check again.",
        checkAgain: "Check again",
        checkFailed: "We could not reach this vehicle. Try again in a moment.",
        blocked: "This Tesla still cannot share its battery data. Its status on the row says why.",
        support: {
          prompt: "Still not working? Send us this vehicle's details at",
          subject: "Tesla pairing did not complete",
          dealershipName: "Dealership name",
          configurationId: "Dealership ID",
          connectivity: "Connectivity",
          virtualKeyPaired: "Virtual key paired",
          dataSharingEnabled: "Data sharing enabled",
          consentMethod: "Consent method",
          consentMethodVirtualKey: "Virtual key",
          consentMethodSafetyToggle: "In-car data sharing setting",
          consentMethodNone: "None",
          consentMethodUnknown: "Not determined yet",
          separator: ": ",
          yes: "Yes",
          no: "No",
          online: "Online"
        }
      },
      error: {
        resendFailed: "We could not resend that invite. Try again in a moment.",
        cancelFailed: "We could not cancel that request. Try again in a moment."
      },
      intro: {
        title: "Battery certificates for Teslas, without the dongle",
        ownInventory: {
          title: "Your own inventory",
          body: "Pick a Tesla from your account and generate. Nobody else has to be involved."
        },
        customerVehicle: {
          title: "A customer's Tesla",
          body: "Email the owner a link. They authorise, choose the car, and the certificate arrives for both of you."
        },
        settingsLink: "Settings \u203A Tesla accounts"
      }
    },
    options: {
      acceleration: "Acceleration",
      autopilot_computer: "Autopilot computer",
      climate: "Climate",
      connectivity: "Connectivity",
      exterior_color: "Exterior color",
      heated_seats: "Heated seats",
      infotainment_processor: "Infotainment processor",
      interior_color: "Interior",
      interior_decor: "Interior decor",
      leather_trim: "Leather trim",
      performance_upgrade: "Performance upgrade",
      seats: "Seats",
      towing: "Towing",
      wheels: "Wheels",
      yoke_steering: "Steering"
    },
    descriptions: {
      acceleration_boost: "An over-the-air software unlock that cuts about half a second from the car's 0-60 time.",
      amd_ryzen_with_grok_ai_support: "Tesla's fastest infotainment generation, with richer 3D graphics, the full Arcade library, and the Grok AI assistant.",
      base_autopilot: "Traffic-Aware Cruise Control with Autosteer lane centring. Driver-supervised.",
      cold_weather_feature: "Heated steering wheel, heated wiper blade de-icers and heated washer nozzles.",
      enhanced_autopilot: "Navigate on Autopilot, Auto Lane Change, Autopark, Summon and Smart Summon. Driver-supervised.",
      extended_nappa_leather: "Nappa leather extended beyond the seats onto the dashboard and cabin surfaces.",
      free_unlimited_supercharging: "Unlimited Supercharging at no cost, and it transfers to you as the next owner.",
      free_unlimited_supercharging_non_transferable: "Unlimited Supercharging at no cost to the current owner. It does not transfer with a sale.",
      full_self_driving: "Autosteer on city streets, Navigate on Autopilot, Autopark, Summon and Traffic Light and Stop Sign Control, included for the life of the vehicle. Driver-supervised.",
      hardware_1: "Mobileye EyeQ3 vision processing. Runs Autopilot only.",
      hardware_2: "NVIDIA DRIVE PX 2, driving eight cameras and forward radar.",
      hardware_2_5: "NVIDIA DRIVE PX 2, driving eight cameras and forward radar.",
      hardware_3: "Tesla's in-house FSD Computer, replacing the NVIDIA platform used before it.",
      hardware_4: "Tesla's latest FSD Computer, with higher-resolution cameras and several times the compute of Hardware 3.",
      heated_rear_seats: "Heated outboard rear seats.",
      intel_atom: "Faster infotainment, adding Tesla Theater video streaming and Arcade games.",
      lifetime_premium_connectivity: "Satellite maps, live traffic, music and video streaming and web browsing, included for the life of the car.",
      ludicrous_mode: "The highest-performance drive mode, unlocking the maximum acceleration this car can deliver.",
      no_access_to_supercharger_network: "This vehicle cannot charge on the Supercharger network.",
      no_autopilot: "No driver-assistance package is active. Autopilot hardware may still be fitted, but the driver is responsible for speed, steering and following distance.",
      no_tow_package: "No factory tow package: no hitch receiver, wiring or Trailer Mode.",
      nvidia_tegra_3: "The original Tesla infotainment computer, built on an NVIDIA Tegra 3 processor.",
      pay_per_use_supercharging: "Supercharging is available at the standard per-session rate; nothing is included with the car.",
      premium_autopilot_firmware: "Tesla's driver-assistance firmware on Cybertruck. Speed and following-distance assistance are included; the vehicle's feature list states what else it carries. Driver-supervised.",
      premium_connectivity: "Satellite maps, live traffic, music and video streaming and web browsing, on a subscription.",
      round_steering_wheel: "The conventional round steering wheel rather than a yoke.",
      standard_connectivity: "Basic navigation and maps over Wi-Fi. No live traffic, streaming or web browsing.",
      subzero_weather_package: "Heated steering wheel, heated rear seats, heated side mirrors, wiper blade de-icers and heated washer nozzles.",
      time_bound_supercharging: "Supercharging was included at no cost until a fixed date. Tesla does not report that date, so treat it as possibly expired.",
      tow_hitch: "Factory tow package: hitch receiver, wiring, and Trailer Mode with sway control.",
      traffic_aware_cruise_control: "Adaptive cruise control that matches the speed of the car ahead and holds a set following distance.",
      yoke_steering: "A yoke in place of the conventional round steering wheel."
    }
  },
  teslaAccount: {
    title: "Tesla accounts",
    selectDealership: "Pick a dealership from the selector above to see its Tesla accounts.",
    notConnected: {
      title: "Connect a Tesla account to your dealership",
      description: "Connect your Tesla account once and Lyteflo generates Battery Certificates over the air. No cables, no bay time.",
      reads: {
        fleet: "Your entire Tesla fleet in one view",
        warranty: "Factory battery and drive-unit warranty status",
        stateOfCharge: "Daily state of charge"
      },
      readOnly: "Read-only. Lyteflo cannot unlock, drive, charge or change anything on these vehicles.",
      connect: "Connect a Tesla account",
      copyLink: "Copy sign-in link",
      copyLinkCopied: "Link copied",
      copyLinkHint: "Whoever holds the Tesla credentials can sign in from their own device. A link is valid for 48 hours.",
      linkShared: "Nothing more to do here \u2014 this page updates when you come back to it.",
      error: "We could not reach Tesla. Try again in a moment.",
      popupBlocked: "Your browser blocked the Tesla sign-in tab. Copy the sign-in link below and open it yourself.",
      readFailed: "We could not check whether any Tesla account is connected. Try again in a moment.",
      consentLocation: "Connecting also shares your vehicles' location with Lyteflo, alongside their battery data."
    },
    waiting: {
      title: "Waiting for Tesla",
      description: "Finish signing in on the Tesla tab. This page updates on its own once the account is connected.",
      timedOutTitle: "Still not connected",
      timedOutDescription: "We stopped checking. If you have finished signing in to Tesla, check again.",
      checkAgain: "Check again",
      pollError: "We could not reach Tesla on the last check.",
      startOver: "Start over"
    },
    connected: {
      title: "Your Teslas live on Tesla Fleet",
      description: "Certificates are generated there, and each vehicle shows whether it still needs one.",
      goToFleet: "Go to Tesla Fleet",
      facts: {
        vehicles: "Vehicles",
        accounts: "Accounts"
      }
    },
    health: {
      status: {
        ok: "Connected",
        needs_reconnect: "Disconnected",
        refresh_failed: "Disconnected"
      },
      reason: {
        refresh_token_invalid: "Tesla no longer accepts this account's sign-in. Reconnect it \u2014 until you do, these vehicles stop updating.",
        tesla_unavailable: "We couldn't reach Tesla for this account, so you're seeing the last data we read. We'll try again on our own \u2014 nothing for you to do.",
        rate_limited: "Tesla is limiting how often we can read this account, so you're seeing the last data we read. We'll catch up on our own \u2014 nothing for you to do.",
        unknown: "This account didn't update and we couldn't tell why, so you're seeing the last data we read. We'll try again on our own \u2014 nothing for you to do."
      },
      connectedBy: "Connected by {{name}}",
      connectedByOn: "Connected by {{name}} on {{date}}",
      teslaId: "Tesla ID: {{id}}",
      addOrReconnect: "Add or reconnect an account",
      addOrReconnectHint: "Whichever Tesla account you sign in with is the one that gets added or reconnected."
    }
  }
};

// src/translations/portal/fr.json
var fr_default2 = {
  common: {
    comingSoon: "Bient\xF4t disponible..."
  },
  formDemo: {
    fields: {
      name: "Nom",
      phone: "T\xE9l\xE9phone",
      mode: "Mode",
      plan: "Forfait",
      domains: "Domaines",
      terms: "Conditions"
    },
    accepted: "Accept\xE9es",
    addedDomains: "Domaines ajout\xE9s",
    add: "Ajouter",
    remove: "Retirer {{item}}",
    leaveViaLink: "Quitter via le lien"
  },
  form: {
    breadcrumbs: "Fil d'Ariane",
    errorSummary: {
      item: "{{label}} : {{message}}",
      title_one: "Corrigez {{count}} champ avant d'enregistrer :",
      title_other: "Corrigez {{count}} champs avant d'enregistrer :"
    },
    stepSummary: "\xC9tape {{current}} sur {{total}} : {{name}}",
    steps: "\xC9tapes du formulaire",
    stepsCompleteSummary_one: "{{count}} \xE9tape sur {{total}} termin\xE9e",
    stepsCompleteSummary_other: "{{count}} \xE9tapes sur {{total}} termin\xE9es"
  },
  table: {
    refresh: "Actualiser",
    filterSort: "Filtre & Tri",
    moreDetails: "Plus de d\xE9tails",
    sortBy: "Trier par",
    missingTrimTooltip: "Le certificat ne sera pas pr\xE9cis sans s\xE9lectionner une finition.",
    publishDisabledTooltip: "La publication est d\xE9sactiv\xE9e car ce certificat est invalide.",
    publicLinkUnavailableTooltip: "Ce certificat n'est pas encore accessible au public.",
    publishDisabledCellIssueTooltip: "La publication est d\xE9sactiv\xE9e car ce certificat pr\xE9sente un probl\xE8me de cellule.",
    openRowMenu: "Ouvrir le menu de la ligne",
    success: {
      refreshed: "Donn\xE9es actualis\xE9es avec succ\xE8s"
    },
    error: {
      refreshFailed: "\xC9chec de l'actualisation des donn\xE9es"
    }
  },
  dataListWithPanel: {
    panelLabel: "D\xE9tails",
    loading: "Chargement...",
    loadFailed: "Impossible de charger les d\xE9tails.",
    retry: "R\xE9essayer",
    sectionLoadFailed: "Impossible de charger cette section."
  },
  dealerConfig: {
    confirm: {
      title: "Confirmer les modifications",
      intro: "Ces modifications affectent ce que le concessionnaire peut utiliser. V\xE9rifiez-les avant d'enregistrer.",
      changedAria: "Modifi\xE9 de {{from}} \xE0 {{to}}",
      keepEditing: "Continuer la modification",
      save: "Enregistrer les modifications",
      row: {
        status: "Statut",
        batteryCertificate: "Abonnement au certificat de batterie",
        teslaAttributes: "Attributs Tesla",
        teslaLookupPlan: "Forfait de recherche Tesla",
        domains: "Domaines du site web",
        provider: "Fournisseur de site web"
      }
    },
    leave: {
      title: "Quitter sans enregistrer ?",
      bodyEdit: "Les modifications apport\xE9es \xE0 {{dealerName}} seront perdues.",
      bodyCreate: "Les donn\xE9es saisies seront perdues.",
      keep: "Continuer la modification",
      discard: "Abandonner les modifications"
    },
    searchPlaceholder: "Rechercher des concessionnaires par nom",
    table: {
      name: "Nom du concessionnaire",
      status: "Statut",
      provider: "Fournisseur de site web",
      oem: "OEM",
      dealerGroup: "Groupe de concessionnaires"
    },
    resultCount_one: "{{count}} concessionnaire",
    resultCount_other: "{{count}} concessionnaires",
    loadingMore: "Chargement d'autres concessionnaires\u2026",
    allLoaded_one: "{{count}} concessionnaire charg\xE9",
    allLoaded_other: "Les {{count}} concessionnaires sont charg\xE9s",
    error: {
      fetchFailed: "Impossible de charger les concessionnaires",
      loadFailedInline: "Impossible de charger les concessionnaires.",
      loadMoreFailed: "Impossible de charger d'autres concessionnaires.",
      createServer: "Impossible de cr\xE9er la configuration en raison d'une erreur du serveur. Vos donn\xE9es sont conserv\xE9es. R\xE9essayez.",
      forbidden: "Modification d'un droit d'acc\xE8s non autoris\xE9e",
      saveServer: "Impossible d'enregistrer les modifications en raison d'une erreur du serveur. Vos donn\xE9es sont conserv\xE9es. R\xE9essayez.",
      styleGeneration: "Impossible de g\xE9n\xE9rer le style \xE0 partir des couleurs saisies, donc rien n'a \xE9t\xE9 enregistr\xE9. V\xE9rifiez les couleurs et r\xE9essayez."
    },
    status: {
      customer: "Client",
      trial: "Essai",
      partner: "Partenaire",
      demo: "D\xE9mo",
      test: "Test",
      cancelled: "Annul\xE9"
    },
    panel: {
      sections: {
        identity: "Identit\xE9",
        website: "Site web",
        location: "Emplacement",
        contacts: "T\xE9l\xE9phones et courriels",
        integrations: "Int\xE9grations",
        entitlements: "Droit d'acc\xE8s",
        widgets: "Widgets"
      },
      fields: {
        dealerId: "ID du concessionnaire",
        crmProvider: "Fournisseur CRM",
        inventoryProvider: "Fournisseur d'inventaire",
        domains: "Noms de domaine",
        ipAddress: "Adresse IP",
        gaId: "ID Google Analytics",
        address: "Adresse",
        measurement: "Syst\xE8me de mesure",
        currency: "Devise",
        salesPhone: "T\xE9l\xE9phone des ventes",
        emails: "Courriels",
        batteryCertificates: "Certificats de batterie",
        teslaAttributes: "Attributs Tesla",
        teslaLookup: "Recherche Tesla",
        teslaLookupLimitMonthly: "Limite mensuelle de recherches Tesla",
        teslaLookupLimitLifetime: "Limite \xE0 vie de recherches Tesla",
        widgetCount: "Nombre de widgets"
      },
      teslaLookupPlan: {
        paid: "Payant",
        free: "Gratuit"
      },
      shopperVisibleSectionsNone: "Aucune",
      lastUpdated: "Derni\xE8re mise \xE0 jour : {{date}}",
      noIdHint: "Impossible de consulter les d\xE9tails de ce concessionnaire. Certaines valeurs peuvent \xEAtre vides.",
      viewOnly: "Lecture seule. Demandez \xE0 un Lyteflo Admin d'apporter des modifications.",
      loading: "Chargement des t\xE9l\xE9phones et des courriels...",
      integrationsError: "Impossible de charger les int\xE9grations.",
      partialToast: "Impossible de charger tous les param\xE8tres de ce concessionnaire"
    },
    measurement: {
      imperial: "Imp\xE9rial",
      metric: "M\xE9trique"
    },
    providers: {
      dealer_inspire: "Dealer Inspire",
      dealer_on: "DealerOn",
      independent: "Ind\xE9pendant",
      sincro: "Sincro",
      dealer_com: "Dealer.com",
      team_velocity: "Team Velocity",
      jazel: "Jazel",
      fox_dealer: "Fox Dealer",
      remora: "Remora",
      edealer: "eDealer",
      d2c_media: "D2C Media",
      performance_auto_group: "Performance Auto Group",
      motive: "Motive",
      sm_360: "SM 360",
      magnetis: "Magnetis",
      leadbox: "Leadbox",
      t_advantage: "TAdvantage",
      dealer_eprocess: "Dealer Eprocess",
      overfuel: "Overfuel",
      dealer_center: "DealerCenter",
      dealer_car_search: "Dealer Car Search",
      get_my_auto: "Get My Auto",
      marketing: "Site marketing",
      outpost_ev: "Outpost EV",
      space_auto: "Space Auto",
      cars_for_sale: "Cars For Sale",
      ebiz_autos: "eBizAutos",
      homenet: "HomeNet",
      vauto: "VAuto",
      maxdigital: "MaxDigital",
      autovision: "Autovision",
      autotrader: "Autotrader",
      vincue: "Vincue",
      xms_360: "XMS 360",
      deskit: "DeskIt",
      elead: "Elead",
      vinsolutions: "VinSolutions",
      dealersocket: "DealerSocket",
      reynolds: "Reynolds",
      drive_centric: "Drive Centric",
      dealer_mine: "DealerMine",
      tekion: "Tekion",
      activix: "Activix",
      affinitiv: "Affinitiv",
      crm_360: "CRM 360",
      pbs_systems: "PBS Systems",
      tms: "TMS",
      asn_software: "ASN Software",
      tecobi: "Tecobi",
      salesforce: "Salesforce",
      shift_digital: "Shift Digital"
    },
    create: {
      add: "Ajouter un concessionnaire",
      title: "Ajouter un concessionnaire",
      submit: "Cr\xE9er la configuration",
      back: "Retour aux concessionnaires",
      summary: "R\xE9sum\xE9",
      sections: {
        basic: "Informations de base",
        address: "Adresse et param\xE8tres r\xE9gionaux",
        contact: "Coordonn\xE9es et site web",
        entitlements: "Droits d'acc\xE8s",
        integrations: "Int\xE9grations",
        tracking: "Suivi et prospects",
        defaults: "Valeurs par d\xE9faut des \xE9conomies et du certificat",
        widgets: "Widgets"
      },
      fields: {
        street: "Adresse",
        city: "Ville",
        state: "\xC9tat",
        province: "Province",
        zipCode: "Code ZIP",
        postalCode: "Code postal",
        country: "Pays",
        salesPhone: "T\xE9l\xE9phone ventes",
        domain: "Domaine",
        batteryReportSubscription: "Abonnement aux certificats de batterie",
        latitude: "Latitude",
        longitude: "Longitude",
        leadRouting: "Routage de prospects",
        leadTracking: "Prospects de test",
        defaultAnnualDistance: "Distance annuelle par d\xE9faut",
        defaultTimelineYears: "Horizon par d\xE9faut (ann\xE9es)",
        autoPublishBatteryReports: "Publication automatique des certificats de batterie",
        teslaAttributes: "Attributs Tesla"
      },
      groupPlaceholder: "Aucun",
      noWebsite: "Ce concessionnaire n'a pas de site web propre",
      noWebsiteHelp: "Les certificats de batterie, les utilisateurs et les appareils fonctionnent quand m\xEAme.",
      noWebsiteSummary: "Aucun site web",
      domainHelp: "Facultatif. Laissez vide pour un concessionnaire sans site web propre.",
      regionalHelp: "D\xE9fini selon le pays. Modifiez-le si ce concessionnaire diff\xE8re.",
      batteryReportSubscriptionHelp: "Permet \xE0 ce concessionnaire de g\xE9n\xE9rer des certificats de batterie.",
      teslaAttributesHelp: "Affiche les attributs propres \xE0 Tesla sur les pages de v\xE9hicules Tesla de ce concessionnaire.",
      validation: {
        name: "Entrez le nom du concessionnaire",
        oem: "Choisissez un OEM",
        street: "Entrez l'adresse",
        city: "Entrez la ville",
        state: "Choisissez un \xC9tat ou une province",
        zipCode: "Entrez un code ZIP ou un code postal",
        salesPhone: "Entrez un num\xE9ro de t\xE9l\xE9phone \xE0 10 chiffres",
        domainProtocol: "Retirez le protocole (comme https://) et entrez seulement le domaine, comme dealer.com",
        domainFormat: "Entrez un domaine comme dealer.com",
        latitudeFormat: "Entrez la latitude sous forme de nombre, comme 45.5",
        latitudeRange: "La latitude doit \xEAtre comprise entre -90 et 90",
        latitudeMissing: "Entrez une latitude, ou effacez aussi la longitude",
        longitudeFormat: "Entrez la longitude sous forme de nombre, comme -73.6",
        longitudeRange: "La longitude doit \xEAtre comprise entre -180 et 180",
        longitudeMissing: "Entrez une longitude, ou effacez aussi la latitude",
        gaTrackingId: "Entrez des ID Google Analytics 4 commen\xE7ant par G-, s\xE9par\xE9s par un point-virgule, sans espace",
        teslaLookupLimit: "Entrez un nombre entier entre 1 et {{max}}, ou laissez vide pour la valeur par d\xE9faut du forfait"
      },
      success: {
        title: "{{name}} a \xE9t\xE9 cr\xE9\xE9",
        testStatus: "Ce concessionnaire est au statut Test. Terminez la configuration pour que le concessionnaire puisse g\xE9n\xE9rer des certificats de batterie.",
        addUser: "Ajouter un utilisateur du portail",
        assignDevice: "Attribuer un appareil"
      },
      coordinates: {
        help: "Facultatif. D\xE9finissez l'emplacement exact du concessionnaire sur la carte. Laissez les deux champs vides pour garder la valeur par d\xE9faut."
      },
      addressSearch: {
        label: "Rechercher une adresse",
        placeholder: "Commencez \xE0 taper l'adresse du concessionnaire",
        failed: "Impossible de charger les suggestions d'adresse. Vous pouvez quand m\xEAme entrer l'adresse et les coordonn\xE9es g\xE9ographiques vous-m\xEAme."
      },
      gaTrackingIdHelp: "S\xE9parez plusieurs ID par un point-virgule, sans espace."
    },
    creating: "Cr\xE9ation...",
    country: {
      US: "\xC9tats-Unis",
      CA: "Canada"
    },
    currency: {
      USD: "USD",
      CAD: "CAD"
    },
    edit: {
      title: "Modifier la configuration",
      submit: "Enregistrer les modifications",
      saved: "{{name}} a \xE9t\xE9 enregistr\xE9",
      removeDomain: "Retirer {{item}}",
      appearance: {
        title: "Apparence",
        accent: "Couleur d'accentuation",
        cta: "Couleur CTA",
        radius: {
          title: "Rayon des coins",
          none: "Aucun",
          medium: "Par d\xE9faut",
          full: "Arrondi complet"
        },
        mode: {
          title: "Mode clair ou sombre",
          LIGHT: "Clair",
          DARK: "Sombre"
        },
        accentContrast: "Couleur de contraste de l'accentuation",
        accentContrastHelp: "D\xE9finie automatiquement \xE0 partir de la couleur d'accentuation.",
        cssStyling: "CSS g\xE9n\xE9r\xE9",
        cssStylingHelp: "R\xE9g\xE9n\xE9r\xE9 \xE0 partir des couleurs d'accentuation et CTA \xE0 l'enregistrement.",
        extensionNote: "Ouvrez {{url}} dans Chrome avec l'extension Lyteflo pour pr\xE9visualiser les couleurs et les styles sur le site du concessionnaire.",
        extensionNoteNoUrl: "Ouvrez le site web du concessionnaire dans Chrome avec l'extension Lyteflo pour pr\xE9visualiser les couleurs et les styles."
      }
    },
    saving: "Enregistrement...",
    load: {
      error: "Impossible de charger cette configuration. V\xE9rifiez votre connexion et r\xE9essayez.",
      retry: "R\xE9essayer",
      back: "Retour aux concessionnaires"
    },
    value: {
      on: "Activ\xE9",
      off: "D\xE9sactiv\xE9"
    },
    group: {
      newOption: "Nouveau groupe\u2026",
      newTitle: "Nouveau groupe",
      editTitle: "Modifier le groupe",
      editOption: "Modifier le groupe",
      name: "Nom du groupe",
      nameError: "Entrez le nom du groupe",
      consentForwarding: "Transfert de consentement",
      cancel: "Annuler",
      save: "Enregistrer le groupe",
      forbidden: "Seul un administrateur LF peut cr\xE9er ou modifier un groupe de concessionnaires.",
      server: "Impossible d'enregistrer le groupe en raison d'une erreur du serveur. R\xE9essayez."
    },
    widgets: {
      title: "Widgets",
      description: "Les widgets affich\xE9s sur le site web du concessionnaire, et leur emplacement.",
      listLabel: "Widgets du concessionnaire",
      empty: "Aucun widget pour le moment.",
      add: "Ajouter un widget",
      choose: "Choisir un widget...",
      enabled: "{{name}} : activ\xE9",
      remove: "Retirer {{name}}",
      removeLabel: "Retirer",
      unsupported: "Non pris en charge pour ce fournisseur",
      type: "Type",
      types: {
        portrait: "Portrait",
        landscape: "Paysage"
      },
      desktopPosition: "Position sur ordinateur",
      mobilePosition: "Position sur mobile",
      positionPlaceholder: "Position par d\xE9faut",
      mobilePositionPlaceholder: "Identique \xE0 l'ordinateur",
      mobilePositionHelp: "Laissez vide pour utiliser la position sur ordinateur.",
      defaultSlotPlaceholder: "Par d\xE9faut : {{slot}}",
      positionHelp: "Saisissez un s\xE9lecteur CSS ou, pour Dealer.com, un nom d'emplacement comme primary-banner. Laissez vide pour la position par d\xE9faut.",
      customPlacementDesktop: "Emplacement personnalis\xE9 (ordinateur)",
      customPlacementMobile: "Emplacement personnalis\xE9 (mobile)",
      dealerComPositionHelp: "Sur Dealer.com, un nom d'emplacement comme primary-banner place le widget par l'entremise de Dealer.com. Toute autre valeur est trait\xE9e comme un s\xE9lecteur CSS.",
      customPlacementHelp: "Dealer.com seulement. Conserv\xE9 pour assurer la compatibilit\xE9 avec l'extension; il ne modifie plus la fa\xE7on dont le widget est plac\xE9.",
      names: {
        vehicleSavings: "\xC9conomies estim\xE9es VE",
        vehicleSavingsV2: "\xC9conomies VE",
        incentivesV2: "Incitations",
        battery: "Batterie et autonomie",
        charging: "Recharge",
        chargeMap: "Carte des bornes de recharge",
        srpSavings: "\xC9conomies SRP",
        batteryReportBadge: "Certificat de batterie",
        srpImageBatteryBadge: "Badge de batterie SRP sur l'image",
        srpIconStackBatteryBadge: "Badge de batterie SRP en pile d'ic\xF4nes",
        standaloneIncentives: "Incitations V\xC9"
      },
      confirm: {
        disable: {
          title: "D\xE9sactiver {{name}} ?",
          body: "Il cesse de s'afficher sur le site web du concessionnaire d\xE8s que vous enregistrez.",
          confirm: "D\xE9sactiver"
        },
        remove: {
          title: "Retirer {{name}} ?",
          body: "Il est retir\xE9 du site web du concessionnaire d\xE8s que vous enregistrez, avec ses param\xE8tres et ses styles.",
          confirm: "Retirer"
        }
      }
    },
    extension: {
      note: "Saisissez une position ici. Choisir l'\xE9l\xE9ment sur la page et placer les widgets par glisser-d\xE9poser n'est possible que dans l'extension Chrome.",
      elementTail: "Ouvrez {{url}} dans Chrome avec l'extension Lyteflo pour choisir l'\xE9l\xE9ment sur la page du concessionnaire.",
      elementTailNoUrl: "Ouvrez le site web du concessionnaire dans Chrome avec l'extension Lyteflo pour choisir l'\xE9l\xE9ment sur la page.",
      placementTail: "Ouvrez {{url}} dans Chrome avec l'extension Lyteflo pour placer les widgets par glisser-d\xE9poser.",
      placementTailNoUrl: "Ouvrez le site web du concessionnaire dans Chrome avec l'extension Lyteflo pour placer les widgets par glisser-d\xE9poser."
    },
    requirements: {
      title: "Exigences",
      intro: "Il manque encore ceci avant que ce concessionnaire puisse \xEAtre mis en service :",
      complete: "Rien ne manque.",
      fields: {
        language: "Langue",
        crmEmail: "Courriel CRM",
        replyEmail: "Courriel de r\xE9ponse",
        batteryReportEmail: "Courriel du rapport de batterie"
      }
    }
  },
  contextSelector: {
    all: "Tous les concessionnaires",
    dealerships: "concessionnaires",
    grouped: "Groupes",
    ungrouped: "Concessionnaires",
    searchPlaceholder: "Rechercher des concessionnaires\u2026",
    noResults: "Aucun concessionnaire trouv\xE9"
  },
  pwa: {
    banner: {
      title: "Installer l'application Lyteflo",
      ios: "Appuyez sur le bouton de partage puis <0>Ajouter sur l'\xE9cran d'accueil</0>",
      android: "Installer l'application Lyteflo pour une meilleure exp\xE9rience",
      install: "Installer",
      dismiss: "Pas maintenant"
    }
  },
  notFound: {
    title: "Page non trouv\xE9e",
    subtitle: "Plus aucune \xE9nergie",
    description: "On dirait que notre batterie est \xE0 plat et nous avons atteint une erreur 404. Pas d'inqui\xE9tude, nous la rechargeons pour vous remettre sur la route. En attendant:",
    cta: "Retourner \xE0 la page d'accueil",
    contact: "Nous contacter:",
    reportNotAvailable: {
      title: "Certificat non disponible",
      description: "Ce certificat n'existe pas ou n'est pas encore accessible au public. V\xE9rifiez que le lien est correct."
    }
  },
  navigation: {
    settings: "Param\xE8tres",
    lyteflo: "Lyteflo",
    home: "Accueil",
    liveScan: "Scan",
    reports: "Certificats",
    unscanned: "Inventaire",
    vehicleProfileBrowser: "Vehicle Profile Browser",
    devices: "Appareils",
    help: "Aide",
    profile: "Profil",
    users: "Utilisateurs",
    dealerConfig: "Configuration concessionnaire",
    wifiConfig: "Configuration Wi-Fi",
    vehicleSupport: "Support v\xE9hicule",
    campaigns: "Campagnes",
    logout: "Se d\xE9connecter",
    tesla: "Tesla",
    teslaAccount: "Comptes Tesla"
  },
  auth: {
    signIn: "Se connecter",
    requestOtp: "Continuer",
    customerLogin: "Aller \xE0 la connexion client",
    lytefloLogin: "Aller \xE0 la connexion Lyteflo",
    logout: "Se d\xE9connecter",
    authenticationFailed: "\xC9chec de l'authentification",
    signInToAccount: "Connectez-vous \xE0 votre compte",
    signInToAccountAdmin: "Cr\xE9ons quelque chose d'exceptionnel !",
    signInWith: "Se connecter avec",
    emailPlaceholder: "email@entreprise.com",
    workEmail: "Email professionnel",
    emailCaseHint: "La connexion distingue les majuscules des minuscules. Saisissez votre courriel exactement comme il a \xE9t\xE9 enregistr\xE9.",
    alreadyHaveCode: "J'ai d\xE9j\xE0 un code",
    otp: {
      title: "Nous vous avons envoy\xE9 un mot de passe \xE0 usage unique",
      subtitleTop: "Nous avons envoy\xE9 un email \xE0 <email>{{email}}</email>.",
      subtitleBottom: "Saisissez le mot de passe ci-dessous pour vous connecter :",
      inputLabel: "Chiffre {{index}} du mot de passe \xE0 usage unique",
      spamHint: "Si vous ne voyez pas l'email, v\xE9rifiez vos courriers ind\xE9sirables.",
      retryQuestion: "Vous ne trouvez pas l'email ?",
      resendAction: "Cliquez ici pour renvoyer le mot de passe.",
      resent: "Un nouveau mot de passe a \xE9t\xE9 envoy\xE9 \xE0 {{email}}.",
      backToLogin: "Retour \xE0 la connexion"
    },
    error: {
      authError: "Erreur d'authentification",
      signOutError: "Erreur lors de la d\xE9connexion",
      invalidPassword: "Mot de passe invalide",
      passwordsDoNotMatch: "Les mots de passe ne correspondent pas",
      userDoesNotExist: "Cet utilisateur n'existe pas",
      invalidOrExpiredOtp: "Le mot de passe \xE0 usage unique est invalide ou a expir\xE9, veuillez r\xE9essayer",
      invalidEmail: "Veuillez saisir une adresse email valide.",
      notFound: "Aucun compte n'a \xE9t\xE9 trouv\xE9 pour cette adresse email.",
      generic: "Impossible de demander un code de connexion.",
      sessionLoadFailed: "Une erreur s'est produite. Veuillez vous reconnecter.",
      missingSession: "Session OTP manquante. Demandez un nouveau code de connexion.",
      invalidCode: "Le code de v\xE9rification est invalide.",
      verifyFailed: "Impossible de v\xE9rifier le code."
    }
  },
  profile: {
    sections: {
      details: {
        title: "D\xE9tails",
        firstName: "Pr\xE9nom",
        lastName: "Nom de famille",
        role: "R\xF4le",
        preferredLanguage: "Langue pr\xE9f\xE9r\xE9e",
        preferredTheme: "Th\xE8me pr\xE9f\xE9r\xE9"
      },
      organization: {
        title: "Organisation",
        group: "Groupe de concessionnaires",
        dealership: "Concessionnaire"
      },
      security: {
        title: "S\xE9curit\xE9",
        email: "Email",
        password: "Mot de passe",
        changePassword: "Changer le mot de passe",
        editPassword: "Modifier le mot de passe",
        oldPassword: "Mot de passe actuel"
      },
      notifications: {
        title: "Notifications",
        receiveBatteryReportEmail: "Recevoir le rapport de batterie par courriel",
        receiveBatteryReportEmailHint: "Recevez le PDF et l'image du rapport de batterie par courriel \xE0 la fin d'une analyse."
      }
    },
    success: {
      updated: "Profil mis \xE0 jour avec succ\xE8s",
      canceled: "Les modifications ont \xE9t\xE9 annul\xE9es"
    },
    error: {
      fetchError: "\xC9chec de la r\xE9cup\xE9ration du profil",
      updateError: "\xC9chec de la mise \xE0 jour du profil"
    }
  },
  users: {
    searchPlaceholder: "Rechercher des utilisateurs",
    email: "Email",
    emailCaseHint: "Cette personne devra se connecter avec exactement ces majuscules et minuscules. Les minuscules sont g\xE9n\xE9ralement plus s\xFBres.",
    firstName: "Pr\xE9nom",
    lastName: "Nom de famille",
    preferredLanguage: "Langue pr\xE9f\xE9r\xE9e",
    dealership: "Concessionnaire",
    dealerGroup: "Groupe concessionnaire",
    roles: "R\xF4les",
    role: "R\xF4le",
    status: "Statut",
    create: "Cr\xE9er un utilisateur",
    editUser: "Modifier l'utilisateur",
    disableUser: "D\xE9sactiver l'utilisateur",
    disableHint: "Connexion r\xE9voqu\xE9e, compte conserv\xE9",
    disableConfirmation: "\xCAtes-vous s\xFBr de vouloir d\xE9sactiver l'utilisateur {{userName}} avec l'email {{userEmail}} ?",
    receiveBatteryReportEmailHint: "Envoie par courriel le PDF et l'image du rapport de batterie \xE0 cet utilisateur \xE0 la fin d'une analyse.",
    sections: {
      identity: "Identit\xE9",
      dealerAssignment: "Affectation au concessionnaire",
      account: "Compte"
    },
    mainFilters: {
      all: "Tous",
      active: "Actifs",
      disabled: "D\xE9sactiv\xE9s",
      invited: "Invit\xE9s"
    },
    sort: {
      title: "Trier les utilisateurs",
      options: {
        email: "Email",
        name: "Nom",
        role: "R\xF4le"
      }
    },
    rolesList: {
      lf_admin: "Lyteflo Admin",
      lfAdminDescription: "Acc\xE8s complet au syst\xE8me et capacit\xE9s de gestion",
      lf_user: "Utilisateur Lyteflo",
      lfUserDescription: "Gestion des groupes et acc\xE8s \xE0 toutes les fonctionnalit\xE9s en lecture seule",
      group_admin: "Admin groupe",
      groupAdminDescription: "G\xE9rer les utilisateurs et les param\xE8tres d'un groupe de concessionnaires",
      group_user: "Utilisateur groupe",
      groupUserDescription: "Acc\xE8s aux fonctionnalit\xE9s au niveau du groupe",
      dealer_admin: "Admin concessionnaire",
      dealerAdminDescription: "G\xE9rer les utilisateurs et les param\xE8tres d'une concession",
      dealer_user: "Utilisateur concessionnaire",
      dealerUserDescription: "Acc\xE8s de base aux fonctionnalit\xE9s de la concession"
    },
    statusValues: {
      active: "Actif",
      forceChangePassword: "Invitation envoy\xE9e",
      disabled: "D\xE9sactiv\xE9"
    },
    table: {
      email: "Email",
      name: "Name",
      status: "Status",
      role: "Role",
      group: "Groupe",
      dealerships: "Concessionnaire(s)",
      actions: {
        addUser: "Ajouter un membre",
        edit: "Modifier",
        disable: "D\xE9sactiver"
      }
    },
    error: {
      userAlreadyExists: "Un utilisateur avec cet email existe d\xE9j\xE0",
      createFailed: "\xC9chec de la cr\xE9ation de l'utilisateur",
      fetchFailed: "\xC9chec de la r\xE9cup\xE9ration des utilisateurs",
      editFailed: "\xC9chec de la modification de l'utilisateur",
      disableFailed: "\xC9chec de la d\xE9sactivation de l'utilisateur"
    },
    success: {
      userCreated: "Utilisateur cr\xE9\xE9 avec succ\xE8s. L'utilisateur recevra un email d'invitation.",
      userEdited: "Utilisateur modifi\xE9 avec succ\xE8s",
      userDisabled: "Utilisateur d\xE9sactiv\xE9 avec succ\xE8s"
    }
  },
  dashboard: {
    todayReports: "Certificats d'aujourd'hui",
    currentMonthReports: "Certificats du mois en cours",
    lastMonthReports: "Certificats du mois pr\xE9c\xE9dent",
    lastThreeMonthReports: "Certificats des 3 derniers mois",
    recentReports: "Derniers certificats",
    awaitingScan: "En attente de scan",
    viewAll: "Voir tout",
    complete: "Complet",
    reporting: "Rapport en cours",
    connected: "Connect\xE9",
    inactive: "Inactif",
    disconnected: "D\xE9connect\xE9",
    disconnectedDescription: "Derni\xE8re connexion",
    report: "Certificat",
    error: {
      fetchFailed: "\xC9chec de la r\xE9cup\xE9ration des m\xE9triques du tableau de bord"
    }
  },
  liveScan: {
    title: "Scans en direct",
    unregisteredDevice: "Appareil non-enregistr\xE9",
    detectedDevices: "Appareils d\xE9tect\xE9s",
    noDeviceTitle: "Aucun appareil d\xE9tect\xE9",
    noDeviceDescription: "Connectez un appareil Lyteflo \xE0 un v\xE9hicule pour commencer.",
    viewDetails: "Voir les scans",
    restartScan: "Red\xE9marrer le scan",
    restarting: "Red\xE9marrage",
    viewReport: "Voir le certificat",
    firmwareUpdate: {
      checking: "V\xE9rification de la mise \xE0 jour",
      inProgress: "Mise \xE0 jour du micrologiciel\u2026 {{progress}} %",
      restarting: "Mise \xE0 jour termin\xE9e, red\xE9marrage de l'appareil\u2026"
    },
    error: {
      trimUpdateFailed: "\xC9chec de la mise \xE0 jour de la finition",
      restartScanFailed: "\xC9chec du red\xE9marrage du scan"
    },
    showRawView: "Afficher la chronologie",
    timelineEventCount_one: "{{count}} \xE9v\xE9nement",
    timelineEventCount_other: "{{count}} \xE9v\xE9nements",
    rawView: {
      deviceInfo: "Informations de l'appareil",
      deviceSerial: "Num\xE9ro de s\xE9rie",
      sessionId: "ID de session",
      firmwareVersion: "Version du firmware",
      lastConnectionStatus: "Statut de l'appareil",
      events: "\xC9v\xE9nements de scan",
      meta: {
        ssid: "SSID : {{value}}",
        vin: "VIN : {{value}}",
        report: "Certificat : {{value}}"
      }
    },
    toast: {
      newSession: "L'appareil {{deviceName}} a d\xE9marr\xE9 une nouvelle session.",
      disconnected: "L'appareil {{deviceName}} a \xE9t\xE9 d\xE9connect\xE9.",
      disconnectedInactivity: "L'appareil {{deviceName}} a \xE9t\xE9 d\xE9connect\xE9 apr\xE8s deux minutes d'inactivit\xE9.",
      vinNotAcquired: "Saisissez le VIN sur le scan #{{scanNumber}} : {{deviceName}} pour continuer",
      awaitingTrimSelection: "L'appareil {{deviceName}} a besoin de la coupe pour g\xE9n\xE9rer un certificat",
      reportGenerated: "L'appareil {{deviceName}} a g\xE9n\xE9r\xE9 un certificat"
    },
    status: {
      unknownStatus: "Statut inconnu",
      identifyingVehicle: "Identification du v\xE9hicule",
      pullingData: {
        pullingBatteryData: "R\xE9cup\xE9ration des donn\xE9es batterie",
        countingElectrons: "Comptage des \xE9lectrons",
        kickingTheTires: "Inspection des pneus"
      },
      crunchingNumbers: {
        crunchingTheNumbers: "Moulinage des chiffres",
        doingBatteryScience: "Diagnostics \xE9lectro-chimique"
      },
      logging: "Enregistrement",
      loggingComplete: "Enregistrement termin\xE9",
      finishingUp: "Finalisation",
      complete: "Certificat g\xE9n\xE9r\xE9",
      inReview: "Certificat en r\xE9vision",
      dev: "Certificat en d\xE9veloppement",
      reportSavedWithoutTrim: "Certificat enregistr\xE9 sans finition",
      reportSavedWithoutTrimHelp: "Le certificat a \xE9t\xE9 enregistr\xE9 mais n\xE9cessite une finition. G\xE9n\xE9rez le certificat en s\xE9lectionnant une finition dans <0>la liste des certificats</0>",
      userAction: {
        vinNotAcquired: "Saisissez le VIN ci-dessous",
        awaitingTrimSelection: "S\xE9lectionnez une finition"
      },
      error: {
        vehicleNotSupported: "V\xE9hicule non support\xE9",
        vehicleNotSupportedLink: "Ce v\xE9hicule n'est pas encore support\xE9 pour les certificats de batterie. <0>Cliquez ici</0> pour voir la liste des v\xE9hicules support\xE9s.",
        vinNotDecoded: "\xC9chec du d\xE9codage du VIN",
        reportGenerationFailed: "\xC9chec de la g\xE9n\xE9ration du certificat",
        reportGenerationFailedHelp: "Une erreur s'est produite. Veuillez r\xE9essayer de scanner le v\xE9hicule. Le probl\xE8me persiste ? <0>Cliquez ici</0> pour nous envoyer un message.",
        loggingSessionFailed: "\xC9chec de la session d'enregistrement",
        vehicleUnresponsive: "V\xE9hicule ne r\xE9pond pas",
        vehicleUnresponsiveHelp: "Le v\xE9hicule ne r\xE9pond pas. Veuillez vous assurer que la voiture est allum\xE9e, puis d\xE9marrez un nouveau scan."
      }
    },
    vinInput: {
      label: "VIN",
      placeholder: "Entrez un VIN de 17 caract\xE8res",
      submit: "Soumettre le VIN",
      submitting: "Soumission...",
      success: "VIN soumis avec succ\xE8s",
      scanButton: "Scanner le VIN depuis une image",
      scanSuccess: "VIN scann\xE9 avec succ\xE8s",
      error: {
        empty: "Veuillez entrer un VIN",
        invalidVin: "VIN invalide. Veuillez saisir manuellement un VIN valide.",
        sendFailed: "\xC9chec de l'envoi du VIN. Veuillez r\xE9essayer."
      },
      scanner: {
        title: "Scanner le VIN",
        aim: "Alignez le VIN avec le cadre",
        aimSub: "Vous pouvez aussi viser un code-barres ou un QR code",
        uploadPrompt: "T\xE9l\xE9versez une photo du VIN, du code-barres ou du QR code",
        uploadButton: "Choisir une photo",
        uploadFailed: "Impossible de lire un VIN sur cette photo. Essayez-en une autre.",
        permissionDenied: "Acc\xE8s \xE0 la cam\xE9ra refus\xE9",
        noCamera: "Cam\xE9ra indisponible",
        cancel: "Annuler"
      }
    },
    trimInput: {
      submit: "Soumettre la finition",
      submitting: "Soumission...",
      success: "Finition soumise avec succ\xE8s",
      error: {
        sendFailed: "\xC9chec de l'envoi de la finition. Veuillez r\xE9essayer."
      }
    }
  },
  reports: {
    title: "Certificats de batterie",
    searchPlaceholder: "Rechercher un certificat",
    mainFilters: {
      all: "Tous les certificats",
      allInventory: "Dans l'inventaire",
      notInventory: "Hors inventaire",
      archived: "Archiv\xE9s"
    },
    table: {
      date: "Date",
      cellHealth: "Sant\xE9 des cellules",
      vehicle: "V\xE9hicule / Statut du certificat",
      trim: "Finition",
      vin: "VIN",
      stockNumber: "N\xB0 de stock",
      country: "Pays",
      reportResult: "Statut du certificat",
      vehicleSupport: "Support v\xE9hicule",
      configurationId: "ID de config.",
      dealership: "Concessionnaire",
      odometer: "Odom\xE8tre",
      score: "Score",
      published: "Publi\xE9",
      tags: {
        new: "Nouveau"
      },
      actions: {
        report: "Certificat",
        debug: "D\xE9bogage",
        copyJson: "Copier JSON",
        copiedJson: "Copi\xE9 !",
        regenerate: "Re-g\xE9n\xE9rer",
        editStatus: "Modifier le statut",
        changeCountry: "Changer le pays",
        archive: "Archiver",
        copyPublicLink: "Copier le lien public",
        selectTrimToGenerate: "S\xE9lectionnez une finition pour g\xE9n\xE9rer le certificat",
        download: {
          label: "T\xE9l\xE9charger",
          pdfCertificate: "Certificat PDF",
          pngShortCertificate: "Certificat court PNG",
          unavailable: "Le PDF n'a pas encore \xE9t\xE9 g\xE9n\xE9r\xE9 pour ce certificat"
        }
      },
      actionRequired: "Action requise: S\xE9lectionner la finition"
    },
    error: {
      fetchFailed: "Erreur lors de la r\xE9cup\xE9ration des certificats de batterie",
      trimUpdateFailed: "Erreur lors de la mise \xE0 jour du trim",
      statusUpdateFailed: "Erreur lors de la mise \xE0 jour du statut du certificat",
      publishUpdateFailed: "Erreur lors de la mise \xE0 jour du statut de publication",
      pictureUploadFailed: "Erreur lors du t\xE9l\xE9chargement de l'image",
      fileTooLarge: "La taille du fichier doit \xEAtre inf\xE9rieure \xE0 4 Mo",
      regenerateReportFailed: "Erreur lors de la r\xE9g\xE9n\xE9ration du certificat",
      archiveReportFailed: "Erreur lors de l'archivage du certificat",
      copyPublicLinkFailed: "Erreur lors de la copie du lien public",
      downloadCertificateFailed: "Erreur lors du t\xE9l\xE9chargement du certificat",
      fetchTrimsFailed: "Erreur lors de la r\xE9cup\xE9ration des finitions",
      countryUpdateFailed: "Erreur lors de la mise \xE0 jour du pays"
    },
    success: {
      trimUpdated: "Trim mis \xE0 jour avec succ\xE8s. G\xE9n\xE9ration d'un nouveau certificat...",
      statusUpdated: "Statut du certificat mis \xE0 jour avec succ\xE8s",
      publishToggled: "Statut de publication modifi\xE9 avec succ\xE8s",
      pictureUploaded: "Image t\xE9l\xE9charg\xE9e avec succ\xE8s",
      regenerateReport: "Certificat r\xE9g\xE9n\xE9r\xE9 avec succ\xE8s",
      archiveReport: "Certificat archiv\xE9 avec succ\xE8s",
      publicLinkCopied: "Lien public copi\xE9 dans le presse-papiers",
      countryUpdated: "Pays mis \xE0 jour avec succ\xE8s. G\xE9n\xE9ration d'un nouveau certificat..."
    },
    changeTrim: {
      title: "Confirmer le changement de finition",
      description: "L'ajustement de la finition g\xE9n\xE9rera un nouveau certificat et invalidera les anciens certificats pour ce VIN. \xCAtes-vous s\xFBr de vouloir continuer ?"
    },
    editStatus: {
      title: "Modifier le statut du certificat",
      statusLabel: "Statut",
      statusPlaceholder: "S\xE9lectionner un statut"
    },
    changeCountry: {
      title: "Changer le pays pour {{country}}",
      description: "Le changement de pays invalidera le certificat actuel et g\xE9n\xE9rera un nouveau certificat pour ce VIN en {{country}}. \xCAtes-vous s\xFBr de vouloir continuer ?",
      noTrimsFound: "Ce v\xE9hicule n'est pas disponible en {{country}}",
      generate: "G\xE9n\xE9rer"
    }
  },
  unscannedInventory: {
    title: "Inventaire",
    searchPlaceholder: "Rechercher par VIN, n\xB0 de stock, marque, mod\xE8le ou concessionnaire",
    mainFilters: {
      supportedUnscanned: "En attente de scan",
      unsupported: "Non support\xE9s",
      all: "Tous les VE/VHR"
    },
    table: {
      vehicle: "V\xE9hicule",
      year: "Ann\xE9e",
      make: "Marque",
      model: "Mod\xE8le",
      trim: "Finition",
      stockNumber: "N\xB0 de stock",
      vin: "VIN",
      supported: "Support\xE9",
      scanStatus: "Statut du scan",
      country: "Pays",
      dealership: "Concessionnaire",
      actions: {
        certificate: "Certificat"
      }
    },
    status: {
      scanned: "Scann\xE9",
      unscanned: "Non scann\xE9"
    },
    supported: {
      yes: "Support\xE9",
      no: "Non support\xE9"
    },
    exportCsv: "Exporter en CSV",
    empty: "Aucun v\xE9hicule ne correspond \xE0 ces filtres.",
    error: {
      fetchFailed: "\xC9chec du chargement de l'inventaire non scann\xE9.",
      exportFailed: "\xC9chec de l'exportation de l'inventaire non scann\xE9."
    }
  },
  help: {
    title: "Aide",
    subtitle: "Besoin d'aide ?",
    description: "Visitez notre centre d'assistance \xE0 <0>https://support.lyteflo.com/</0>"
  },
  devices: {
    searchPlaceholder: "Rechercher un appareil",
    deleteDevice: "Supprimer l'appareil",
    deleteConfirmation: "\xCAtes-vous s\xFBr de vouloir supprimer l'appareil {{deviceName}} avec le num\xE9ro de s\xE9rie {{serialNumber}} ?",
    editDevice: "Modifier l'appareil",
    openWifiSettings: "Ouvrir les param\xE8tres Wi-Fi",
    debugging: "D\xE9bogage",
    diagnostic: "Diagnostic",
    logging: "Journalisation",
    addNote: "Ajouter une note",
    notePlaceholder: "\xC9crivez votre note ici...",
    chipId: "ID de l'appareil non enregistr\xE9",
    emptyIccid: "Aucun ICCID fourni pour cet appareil",
    mainFilters: {
      allDevices: "Tous les appareils",
      active: "Actifs",
      assignedDevices: "Assign\xE9s",
      unassignedDevices: "Non assign\xE9s",
      shipped: "Exp\xE9di\xE9s",
      inactive: "Inactifs"
    },
    status: {
      active: "Actif",
      shipped: "Exp\xE9di\xE9",
      tracking: "Suivre la livraison",
      inactive: "Inactif"
    },
    table: {
      name: "Nom de l'appareil",
      iccid: "ICCID",
      serialNumber: "Num\xE9ro de s\xE9rie",
      configurationId: "ID de config.",
      dealership: "Concessionnaire",
      secondaryDealerships: "Concessionnaires secondaires",
      assignedDate: "Date d'assignation",
      status: "Statut",
      country: "Pays",
      showReports: "Certificats",
      actions: {
        addDevice: "Ajouter un appareil",
        addNote: "Ajouter une note",
        viewNote: "Voir la note de l'appareil",
        edit: "Modifier",
        delete: "Supprimer",
        enableDebugMode: "D\xE9marrer le d\xE9bogage",
        disableDebugMode: "Arr\xEAter le d\xE9bogage",
        enableDiagnosticMode: "D\xE9marrer le diagnostic",
        disableDiagnosticMode: "Arr\xEAter le diagnostic",
        enableLoggingMode: "D\xE9marrer la journalisation",
        disableLoggingMode: "Arr\xEAter la journalisation"
      }
    },
    trackingUrl: "URL de suivi",
    noTrackingUrl: "Aucune URL de suivi",
    tracking: "Suivi",
    error: {
      fetchFailed: "\xC9chec de la r\xE9cup\xE9ration des appareils",
      createFailed: "\xC9chec de la cr\xE9ation de l'appareil",
      deviceUpdateFailed: "\xC9chec de la mise \xE0 jour de l'appareil",
      deviceDeleteFailed: "\xC9chec de la suppression de l'appareil",
      noteUpdateFailed: "\xC9chec de la mise \xE0 jour de la note",
      noteCreateFailed: "\xC9chec de la cr\xE9ation de la note",
      debugModeToggleFailed: "\xC9chec de la mise \xE0 jour du mode d\xE9bogage",
      diagnosticModeToggleFailed: "\xC9chec de la mise \xE0 jour du mode diagnostic",
      loggingModeToggleFailed: "\xC9chec de la mise \xE0 jour du mode journalisation",
      trackingUrlUpdateFailed: "\xC9chec de la mise \xE0 jour de l'URL de suivi",
      fetchUnregisteredDevicesFailed: "\xC9chec de la r\xE9cup\xE9ration des appareils non enregistr\xE9s"
    },
    success: {
      deviceCreated: "Appareil cr\xE9\xE9 avec succ\xE8s",
      noteCreated: "Note cr\xE9\xE9e avec succ\xE8s",
      noteUpdated: "Note mise \xE0 jour avec succ\xE8s",
      deviceUpdated: "Appareil mis \xE0 jour avec succ\xE8s",
      deviceDeleted: "Appareil supprim\xE9 avec succ\xE8s",
      debugModeEnabled: "Mode d\xE9bogage activ\xE9 avec succ\xE8s",
      debugModeDisabled: "Mode d\xE9bogage d\xE9sactiv\xE9 avec succ\xE8s",
      diagnosticModeEnabled: "Mode diagnostic activ\xE9 avec succ\xE8s",
      diagnosticModeDisabled: "Mode diagnostic d\xE9sactiv\xE9 avec succ\xE8s",
      loggingModeEnabled: "Mode journalisation activ\xE9 avec succ\xE8s",
      loggingModeDisabled: "Mode journalisation d\xE9sactiv\xE9 avec succ\xE8s",
      trackingUrlUpdated: "URL de suivi mise \xE0 jour avec succ\xE8s"
    }
  },
  wifis: {
    searchPlaceholder: "Rechercher un Wi-Fi",
    deleteWifi: "Supprimer Wi-Fi",
    deleteConfirmation: "\xCAtes-vous s\xFBr de vouloir supprimer le Wi-Fi {{ssid}} ?",
    editWifi: "Modifier Wi-Fi",
    table: {
      ssid: "SSID",
      password: "Mot de passe",
      configurationId: "ID de config.",
      dealership: "Concession",
      actions: {
        addWifi: "Ajouter Wi-Fi",
        edit: "Modifier le mot de passe",
        delete: "Supprimer"
      }
    },
    error: {
      fetchFailed: "\xC9chec de la r\xE9cup\xE9ration des Wi-Fi",
      createFailed: "\xC9chec de la cr\xE9ation de Wi-Fi",
      wifiUpdateFailed: "\xC9chec de la mise \xE0 jour de Wi-Fi",
      wifiDeleteFailed: "\xC9chec de la suppression de Wi-Fi"
    },
    success: {
      wifiCreated: "Wi-Fi cr\xE9\xE9 avec succ\xE8s",
      wifiUpdated: "Wi-Fi mis \xE0 jour avec succ\xE8s",
      wifiDeleted: "Wi-Fi supprim\xE9 avec succ\xE8s"
    }
  },
  vehicleSupport: {
    title: "V\xE9hicules support\xE9s",
    searchPlaceholder: "Rechercher un v\xE9hicule",
    table: {
      vehicle: "V\xE9hicule",
      year: "Ann\xE9e",
      make: "Marque",
      model: "Mod\xE8le",
      trim: "Finition",
      variant: "Variante",
      status: "Statut",
      newVehicle: "Nouveau v\xE9hicule",
      createdAt: "Cr\xE9\xE9 le",
      updatedAt: "Mis \xE0 jour le",
      actions: {
        addVehicle: "Ajouter un v\xE9hicule",
        edit: "Modifier",
        delete: "Supprimer"
      }
    },
    filters: {
      yearFrom: "Ann\xE9e de d\xE9but",
      yearTo: "Ann\xE9e de fin",
      yearRangeInvalid: "\xAB Ann\xE9e de d\xE9but \xBB doit \xEAtre inf\xE9rieure ou \xE9gale \xE0 \xAB Ann\xE9e de fin \xBB."
    },
    batch: {
      selectAll: "Tout s\xE9lectionner",
      selectedCount_one: "{{count}} s\xE9lectionn\xE9",
      selectedCount_other: "{{count}} s\xE9lectionn\xE9s",
      selectAllMatching: "S\xE9lectionner les {{count}} v\xE9hicules correspondants",
      allMatchingSelected_one: "{{count}} v\xE9hicule correspondant s\xE9lectionn\xE9",
      allMatchingSelected_other: "Les {{count}} v\xE9hicules correspondants sont s\xE9lectionn\xE9s",
      clearSelection: "Effacer la s\xE9lection",
      updateStatus: "Mettre \xE0 jour le statut",
      setStatusTo: "D\xE9finir le statut en",
      confirmTitle: "Mettre \xE0 jour le statut du v\xE9hicule",
      confirmIntro_one: "Vous allez d\xE9finir le statut de support de <strong>{{count}} v\xE9hicule</strong> en :",
      confirmIntro_other: "Vous allez d\xE9finir le statut de support de <strong>{{count}} v\xE9hicules</strong> en :",
      currentStatuses: "Statuts actuels dans la s\xE9lection",
      allMatchingNote: "Inclut les {{count}} v\xE9hicules correspondant au filtre actuel, tous statuts confondus.",
      updateConfirm_one: "Mettre \xE0 jour {{count}} v\xE9hicule",
      updateConfirm_other: "Mettre \xE0 jour {{count}} v\xE9hicules",
      successToStatus_one: "{{count}} v\xE9hicule mis \xE0 jour en {{status}}",
      successToStatus_other: "{{count}} v\xE9hicules mis \xE0 jour en {{status}}",
      error: "\xC9chec de la mise \xE0 jour des statuts"
    },
    deleteVehicle: "Supprimer le v\xE9hicule",
    deleteConfirmation: "\xCAtes-vous s\xFBr de vouloir supprimer {{vehicle}} ?",
    error: {
      fetchFailed: "\xC9chec de la r\xE9cup\xE9ration des v\xE9hicules support\xE9s",
      createFailed: "\xC9chec de la cr\xE9ation du v\xE9hicule support\xE9",
      updateFailed: "\xC9chec de la mise \xE0 jour du v\xE9hicule support\xE9",
      deleteFailed: "\xC9chec de la suppression du v\xE9hicule support\xE9"
    },
    success: {
      vehicleCreated: "V\xE9hicule support\xE9 cr\xE9\xE9 avec succ\xE8s",
      vehicleUpdated: "V\xE9hicule support\xE9 mis \xE0 jour avec succ\xE8s",
      vehicleDeleted: "V\xE9hicule support\xE9 supprim\xE9 avec succ\xE8s"
    },
    features: {
      title: "Diagnostics de batterie",
      labels: {
        featureSoh: "\xC9tat de sant\xE9",
        featureCellHealth: "Sant\xE9 des cellules",
        featureIndividualCells: "Cellules individuelles",
        featureDtcCleared: "DTC effac\xE9s",
        featureRange: "Autonomie",
        featureChargeRatio: "Ratio de charge",
        featureBenchmark: "R\xE9f\xE9rence"
      },
      short: {
        featureSoh: "SdS",
        featureCellHealth: "Cell",
        featureIndividualCells: "Ind",
        featureDtcCleared: "DTC",
        featureRange: "Auto",
        featureChargeRatio: "Ratio",
        featureBenchmark: "R\xE9f"
      },
      status: {
        SUPPORTED: "Pris en charge",
        OPTIONAL: "Optionnel",
        NOT_SUPPORTED: "Non pris en charge",
        UNSET: "Non d\xE9fini"
      }
    }
  },
  ownershipReport: {
    title: "Rapport comparatif avec un v\xE9hicule \xE9lectrique",
    subtitle: "Si vous poss\xE9dez la {{vehicle}} pendant {{years}} ans et parcourez {{distance}} {{distanceUnit}} / an",
    inLocation: "\xE0 {{location}}",
    totalSubtitle: "\xC9conomies totales sur {{years}} ans (ou {{monthly}}/mois)",
    costPerMi: "Co\xFBt par mile",
    costPerKm: "Co\xFBt par km",
    overYears: "Sur {{years}} ans",
    fuelCost: "Co\xFBt du carburant",
    maintenanceCost: "Co\xFBt d'entretien",
    environmentalImpact: "Impact environnemental",
    howItsCalculated: "Comment c'est calcul\xE9",
    fuelEfficiency: "Efficacit\xE9 \xE9nerg\xE9tique (par 100 {{distanceUnit}})",
    costToDrive: "Co\xFBt pour conduire {{distance}} {{distanceUnit}}",
    carbonSavings: "\xC9quivalent \xE0 sauver {{trees}} arbres ({{totalCO2Savings}} {{burnUnit}} de CO2)",
    co2Emitted: "CO2 \xE9mis / {{distanceUnit}}",
    co2EmittedTotal: "CO2 \xE9mis apr\xE8s {{distance}} {{distanceUnit}}",
    treeConsumption: "1 arbre consomme environ {{consumption}} {{unit}} de CO2 / an. {{emissions}} {{unit}} / {{consumption}} {{unit}} = {{trees}} arbres.",
    contactDealership: "Contacter {{name}}",
    inGasSavings: "{{savings}} en \xE9conomies de carburant",
    inMaintenanceSavings: "{{savings}} en \xE9conomies d'entretien",
    sales: "Ventes",
    service: "Service",
    parts: "Pi\xE8ces",
    moreEfficient: "plus efficace",
    lessExpensive: "moins cher \xE0 conduire",
    poweredBy: "Powered by",
    disclaimer: {
      title: "Avertissement",
      header: "Mentions l\xE9gales que nous devons divulguer",
      description: "Les \xE9conomies potentielles sont estim\xE9es sur la base de donn\xE9es publiques, d'informations des concessionnaires et des fabricants, des entr\xE9es des utilisateurs et des tendances historiques. Ces estimations ne sont pas des garanties d'\xE9conomies r\xE9elles. Les \xE9conomies r\xE9elles peuvent varier selon vos circonstances, les conditions du march\xE9 et des facteurs hors de notre contr\xF4le."
    }
  },
  unsubscribe: {
    title: "Se d\xE9sabonner des emails Lyteflo",
    subtitle: "Nous sommes d\xE9sol\xE9s de vous voir partir! Veuillez confirmer ci-dessous pour vous d\xE9sabonner de nos communications.",
    success: "Vous avez \xE9t\xE9 d\xE9sabonn\xE9 avec succ\xE8s des emails Lyteflo!",
    confirm: "Se d\xE9sabonner"
  },
  vehicleProfileBrowser: {
    pageTitle: "Vehicle Profile Browser",
    search: {
      title: "Search for a Vehicle Profile",
      description: "Type to search or use the filters below to select a vehicle profile",
      loadingProfiles: "Loading vehicle profiles...",
      placeholder: "Search by make or model (e.g., 'tesla model 3')",
      clear: "Clear",
      orUseFilters: "or use filters",
      make: "Make",
      model: "Model",
      year: "Year",
      trim: "Trim",
      selectMakeModelYearFirst: "select make, model, year first",
      selectMake: "Select Make",
      selectModel: "Select Model",
      selectYear: "Select Year",
      selectTrimOptional: "Select Trim (optional)",
      loadProfile: "Load Vehicle Profile",
      loadingProfile: "Loading Vehicle Profile...",
      topMatches: "Top Matches",
      availableProfiles: "Available Vehicle Profiles ({{count}})"
    },
    profileViewer: {
      backToSearch: "Back to Search",
      activeLayers: "Active Layers (click to edit)",
      tab: {
        inputs: "Inputs",
        strategies: "Strategies",
        limits: "Limits",
        index: "Index",
        json: "JSON"
      },
      viewInEditor: "View in editor",
      openInLayer: "Open in layer:"
    },
    inputs: {
      scalarsCount: "Scalars ({{filtered}} / {{total}})",
      arraysCount: "Arrays ({{filtered}} / {{total}})",
      searchPlaceholder: "Search inputs..."
    },
    strategies: {
      count: "Strategies ({{filtered}} / {{total}})",
      searchPlaceholder: "Search strategies...",
      directMappings: "Direct Mappings ({{count}})",
      mapsTo: "maps to",
      mapsToLabel: "Maps to",
      otherStrategies: "Other Strategies ({{count}})",
      priority: "Priority",
      formula: "Formula",
      strategy: "Strategy",
      array: "Array",
      statistic: "Statistic",
      bindingsCount: "Bindings ({{count}})",
      parametersCount: "Parameters ({{count}})"
    },
    limits: {
      count: "Limits ({{filtered}} / {{total}})",
      searchPlaceholder: "Search limits...",
      warnRangeLabel: "Warn",
      criticalRangeLabel: "Critical"
    },
    index: {
      noIndexData: "No index data available",
      compositionCriteria: "Composition Criteria",
      notSpecified: "Not specified",
      compositionLayers: "Composition Layers",
      required: "Required",
      active: "Active",
      when: "When",
      files: "Files",
      viewRawIndexJson: "View Raw Index JSON",
      year: "Year",
      trim: "Trim"
    },
    validation: {
      title: "Validation",
      autoValidate: "Auto-validate",
      validating: "Validating...",
      checkProfile: "Check Vehicle Profile",
      validationError: "Validation Error",
      passed: "Passed",
      failed: "Failed",
      metricsAnalyzed: "{{count}} metrics analyzed",
      errorCount: "{{count}} Error(s)",
      warningCount: "{{count}} Warning(s)",
      infoCount: "{{count}} Info",
      errors: "Errors",
      warnings: "Warnings",
      info: "Info",
      noIssuesFound: "No issues found",
      clickCheckProfileToValidate: 'Click "Check Vehicle Profile" to validate'
    },
    componentBrowser: {
      title: "Component Browser",
      description: "Browse and search vehicle profile components.",
      loadingComponentGraph: "Loading component graph...",
      totalComponents: "Total components",
      totalMakes: "Makes",
      totalModels: "Models",
      uniqueToVehicle: "Unique to vehicle",
      sharedByVehicles: "Shared by 10+ vehicles",
      searchPlaceholder: "Search components...",
      filterByMake: "Filter by make",
      allMakes: "All makes",
      filterByModel: "Filter by model",
      allModels: "All models",
      componentsCount: "{{count}} component(s)",
      noComponentsFound: "No components found",
      shared10Plus: "Shared by 10+ vehicles ({{count}})",
      shared6To10: "Shared by 6\u201310 vehicles ({{count}})",
      shared2To5: "Shared by 2\u20135 vehicles ({{count}})",
      uniqueCount: "Unique to 1 vehicle ({{count}})"
    },
    componentEditor: {
      title: "Component Editor",
      close: "Close",
      loadingComponent: "Loading component...",
      jsonContent: "JSON Content",
      validJson: "Valid JSON",
      invalidJson: "Invalid JSON",
      modified: "Modified",
      jumpToError: "Click to jump to error location",
      enableEditing: "Enable Editing",
      savedSuccessfully: "Saved successfully",
      backupCreated: "backup created",
      duplicating: "Duplicating...",
      duplicateComponent: "Duplicate Component",
      saveChanges: "Save Changes",
      saving: "Saving...",
      usedBy: "Used By ({{count}} vehicle configurations)",
      notUsedByAnyVehicles: "This component is not used by any vehicles.",
      years: "Years",
      trims: "Trims",
      duplicatedTo: "Duplicated to {{path}}. Edit and save to create the new file.",
      duplicateError: "Duplicate failed",
      invalidJsonFallback: "Invalid JSON",
      allYears: "All years",
      allTrims: "All trims"
    }
  },
  campaigns: {
    title: "Campagnes",
    createTitle: "Cr\xE9er une nouvelle campagne",
    editTitle: "Modifier la campagne",
    searchPlaceholder: "Rechercher des campagnes",
    addCampaign: "Ajouter une campagne",
    delete: {
      title: "Supprimer la campagne",
      message: "\xCAtes-vous s\xFBr de vouloir supprimer la campagne \xAB {{name}} \xBB ?"
    },
    mainFilters: {
      all: "Tous",
      draft: "Brouillon",
      live: "En direct",
      complete: "Termin\xE9e",
      archived: "Archiv\xE9e"
    },
    status: {
      draft: "Brouillon",
      live: "En direct",
      complete: "Termin\xE9e",
      archived: "Archiv\xE9e"
    },
    table: {
      name: "Nom",
      status: "Statut",
      enabled: "Activ\xE9e",
      source: "Source",
      association: "Association",
      templateKey: "Mod\xE8le",
      startAt: "Date de d\xE9but",
      endAt: "Date de fin",
      priority: "Priorit\xE9",
      actions: {
        edit: "Modifier",
        delete: "Supprimer",
        preview: "Aper\xE7u",
        copyParam: "Copier le param\xE8tre",
        copiedParam: "Copi\xE9 !",
        sendToCustomer: "Envoyer \xE0 un client"
      }
    },
    form: {
      basicInfo: "Informations de base",
      templateContent: "Mod\xE8le et contenu",
      scheduling: "Planification",
      targeting: "Ciblage",
      headline: "Titre",
      subtitle: "Sous-titre",
      body: "Corps",
      ctaLabel: "Libell\xE9 du bouton",
      ctaPiiType: "Action du bouton",
      disclaimer: "Avertissement",
      heroImage: "Image principale",
      heroImageAlt: "Image principale de la campagne",
      heroImageInvalid: "L'image doit \xEAtre au format JPEG, PNG ou WebP et peser moins de 4 Mo.",
      heroImageUploadFailed: "Impossible de t\xE9l\xE9verser l'image. Veuillez r\xE9essayer.",
      removeHeroImage: "Retirer l'image principale",
      source: "Source",
      feedTheme: "Th\xE8me du flux",
      pageTargets: "Pages cibles",
      openTriggers: "D\xE9clencheurs",
      frequencyCap: "Fr\xE9quence maximale",
      allowedOrigins: "URLs autoris\xE9es",
      allowedOriginsPlaceholder: "ex. *.concessionnaire.com",
      allowedOriginsRequired: "Requis lorsque Pages cibles est 'Toutes les pages' : ajoutez au moins une URL, ou restreignez les pages cibles",
      addOrigin: "Ajouter",
      priorityConflict: "Cette priorit\xE9 est d\xE9j\xE0 utilis\xE9e par une autre campagne dans ce contexte",
      templateKeyV2SavingsModal: "Modale d'\xE9conomies v2",
      templateKeyVehicleAd: "Publicit\xE9 v\xE9hicule",
      datePlaceholder: "JJ-MM-AAAA",
      variablesHint: "Tapez {{ pour ins\xE9rer une variable dans les champs de texte ci-dessous.",
      preview: {
        label: "Aper\xE7u",
        empty: "Ajoutez un titre, sous-titre, corps, avertissement ou CTA pour voir l'aper\xE7u.",
        sampleHint: "Les variables sont rendues avec des donn\xE9es de v\xE9hicule fictives ({{vehicleMake}} = Kia, etc.).",
        realDataHint: "Les variables sont rendues avec le v\xE9hicule s\xE9lectionn\xE9 de la campagne.",
        imagePlaceholder: "Image du v\xE9hicule",
        evLabel: "V\xE9hicule \xE9lectrique",
        gasLabel: "V\xE9hicule \xE0 essence",
        savingsModalHint: "Les clients voient le modal d'\xE9conomies VE avec votre message, vos sections et votre bouton.",
        savingsModalSample: "2024 Kia EV6 Wind AWD",
        savingsModalComparison: "Compar\xE9 \xE0 un(e) {{comparison}}",
        savingsModalComparisonSample: "Toyota Camry 2024",
        savingsModalSection: {
          fuel: "\xC9conomies de carburant",
          maintenance: "\xC9conomies d'entretien",
          incentives: "Incitatifs",
          battery: "Batterie et recharge"
        }
      },
      schedulingHint: "Sans date de d\xE9but, la campagne d\xE9marre imm\xE9diatement. Sans date de fin, elle s'ex\xE9cute ind\xE9finiment.",
      removeOrigin: "Supprimer {{origin}}",
      scope: "Port\xE9e",
      scopeHint: "S\xE9lectionnez le groupe ou le concessionnaire auquel cette campagne s'applique.",
      scopePlaceholder: "S\xE9lectionner un groupe ou un concessionnaire",
      tooltip: {
        priority: "Num\xE9ro plus petit = affich\xE9 en premier (1 avant 2). Doit \xEAtre unique parmi toutes les campagnes de ce contexte.",
        enabled: "Lorsque d\xE9coch\xE9, cette campagne est supprim\xE9e et n'appara\xEEtra pas sur le widget, m\xEAme si le statut est En direct.",
        templateKey: "D\xE9termine quel mod\xE8le de widget est utilis\xE9 pour afficher le contenu de cette campagne.",
        source: "Lyteflo : vous contr\xF4lez tout le contenu. Meta AIA Feed / Meta AMA Feed : le contenu est auto-rempli depuis le flux, selon le th\xE8me.",
        feedTheme: "S\xE9lectionne quelle cat\xE9gorie de donn\xE9es du flux alimente le contenu de cette campagne.",
        pageTargets: "Les types de pages o\xF9 cette campagne sera affich\xE9e. 'Tous' couvre \xE0 la fois VDP et SRP.",
        openTriggers: "Comment le widget de campagne s'ouvre. 'Param\xE8tre URL' = un param\xE8tre de requ\xEAte d\xE9clenche le widget; 'Auto' = s'ouvre automatiquement au chargement.",
        frequencyCap: "Contr\xF4le la fr\xE9quence \xE0 laquelle un m\xEAme visiteur voit cette campagne durant une session ou une journ\xE9e.",
        allowedOrigins: "La campagne ne s'affiche que sur les URLs correspondant \xE0 ces motifs (jokers support\xE9s, ex. *.concessionnaire.com). Peut rester vide lorsque les pages cibles sont restreintes, mais 'Toutes les pages' exige au moins une URL.",
        ctaPiiType: "D\xE9termine ce que fait le bouton CTA. 'Aucun' masque le bouton. Les autres options ouvrent le formulaire de contact correspondant.",
        disclaimer: "Texte l\xE9gal ou de divulgation optionnel affich\xE9 sous le contenu principal.",
        heroImage: "Facultatif. Remplace la photo du v\xE9hicule provenant de l'inventaire par votre propre image. Laissez vide pour conserver la photo de l'inventaire."
      },
      variables: {
        hint: "Variables disponibles :",
        invalidWarning: "Variable(s) inconnue(s) : {{variables}}. Elles ne seront pas remplac\xE9es."
      },
      vehicles: {
        title: "V\xE9hicules",
        primaryVehicle: "V\xE9hicule principal",
        comparisonVehicle: "V\xE9hicule de comparaison",
        addComparison: "Ajouter un v\xE9hicule de comparaison",
        removeComparison: "Retirer",
        useVehicleOnPage: "Utiliser le v\xE9hicule de la page",
        vin: "NIV",
        ymmt: "Ann\xE9e / Marque / Mod\xE8le / Version",
        year: "Ann\xE9e",
        make: "Marque",
        model: "Mod\xE8le",
        trim: "Version",
        vinPlaceholder: "Entrez le NIV",
        vinInvalid: "NIV invalide",
        vinValid: "NIV valide",
        selectYear: "S\xE9lectionner l'ann\xE9e",
        selectMake: "S\xE9lectionner la marque",
        selectModel: "S\xE9lectionner le mod\xE8le",
        selectTrim: "S\xE9lectionner la version",
        noVehicleFound: "Aucun v\xE9hicule trouv\xE9 pour cette combinaison",
        unresolvedTrim: "Cette version ne correspond \xE0 aucun v\xE9hicule de notre catalogue. Choisissez une autre version.",
        check: {
          checking: "V\xE9rification des donn\xE9es du v\xE9hicule...",
          failed: "Impossible de v\xE9rifier les donn\xE9es de ce v\xE9hicule. R\xE9essayez plus tard.",
          trimNotFound: "Impossible de trouver la finition enregistr\xE9e pour cette ann\xE9e, cette marque et ce mod\xE8le. S\xE9lectionnez \xE0 nouveau le v\xE9hicule.",
          noFuelEconomy: "Aucune consommation de carburant n'est disponible pour ce v\xE9hicule. Choisissez un autre v\xE9hicule.",
          bevComparison: "Le v\xE9hicule de comparaison ne peut pas \xEAtre enti\xE8rement \xE9lectrique (BEV). Choisissez un v\xE9hicule \xE0 essence ou hybride.",
          noPowertrain: "Aucun groupe motopropulseur n'est disponible pour ce v\xE9hicule. Choisissez un autre v\xE9hicule.",
          notElectrified: "Le v\xE9hicule principal doit \xEAtre \xE9lectrifi\xE9 (\xE9lectrique, hybride rechargeable ou hybride). Choisissez un autre v\xE9hicule.",
          noConsumption: "Aucune consommation d'\xE9nergie n'est disponible pour ce v\xE9hicule. Choisissez un autre v\xE9hicule."
        },
        inventoryOnly: "Afficher uniquement les v\xE9hicules dans l'inventaire de ce concessionnaire",
        powertrain: "Groupe motopropulseur",
        selectPowertrain: "Tous les groupes motopropulseurs",
        powertrain_BEV: "\xC9lectrique pur (BEV)",
        powertrain_PHEV: "Hybride rechargeable (PHEV)",
        powertrain_HEV: "Hybride (HEV)",
        powertrain_ICE: "Essence (ICE)",
        powertrain_MHEV: "Micro-hybride (MHEV)"
      }
    },
    source: {
      manual: "Lyteflo",
      feed: "Flux",
      aia_feed: "Meta AIA Feed",
      ama_feed: "Meta AMA Feed"
    },
    feedTheme: {
      fuel_savings: "\xC9conomies carburant",
      maintenance_savings: "\xC9conomies entretien",
      range: "Autonomie"
    },
    ctaPiiType: {
      none: "Aucun (pas de CTA)",
      eligibility: "Admissibilit\xE9 aux incitatifs",
      report: "Rapport d'\xE9conomies",
      availability: "V\xE9rifier la disponibilit\xE9"
    },
    ctaLabelDefault: {
      eligibility: "V\xE9rifier l'admissibilit\xE9",
      report: "Obtenir le rapport VE",
      availability: "V\xE9rifier la disponibilit\xE9"
    },
    frequencyCap: {
      once_per_session: "Une fois par session",
      once_per_day: "Une fois par jour",
      once_per_week: "Une fois par semaine",
      once_ever: "Une seule fois",
      always: "Toujours"
    },
    pageTarget: {
      vdp: "VDP",
      srp: "SRP",
      all: "Toutes les pages"
    },
    trigger: {
      link: "Param\xE8tre URL",
      auto: "Auto"
    },
    preview: {
      title: "Aper\xE7u de la campagne",
      trigger: "Aper\xE7u d'URL",
      urlLabel: "URL du site",
      urlPlaceholder: "https://www.concessionnaire.com/vehicules-neufs",
      open: "Ouvrir l'aper\xE7u",
      invalidUrl: "URL invalide \u2014 veuillez inclure https://"
    },
    success: {
      enableToggled: "Campagne mise \xE0 jour avec succ\xE8s",
      deleted: "Campagne supprim\xE9e avec succ\xE8s",
      created: "Campagne cr\xE9\xE9e avec succ\xE8s",
      saved: "Campagne enregistr\xE9e avec succ\xE8s"
    },
    error: {
      fetchFailed: "\xC9chec du chargement des campagnes",
      enableToggleFailed: "\xC9chec de la mise \xE0 jour de la campagne",
      deleteFailed: "\xC9chec de la suppression de la campagne",
      createFailed: "\xC9chec de la cr\xE9ation de la campagne",
      saveFailed: "\xC9chec de l'enregistrement de la campagne",
      loadFailed: "\xC9chec du chargement de la campagne"
    },
    warning: {
      heroImageNotSaved: "Campagne enregistr\xE9e, mais l'image principale n'a pas pu \xEAtre enregistr\xE9e pour le moment \u2014 cette fonctionnalit\xE9 arrive bient\xF4t."
    },
    wizard: {
      scopePlaceholder: "S\xE9lectionner un groupe ou un concessionnaire",
      scopeRequired: "Veuillez s\xE9lectionner un groupe ou un concessionnaire avant de continuer.",
      steps: "\xC9tapes de la campagne",
      back: "Retour",
      skip: "Ignorer",
      continue: "Continuer",
      stepLabels: {
        goal: "Objectif",
        vehicle: "V\xE9hicule",
        comparison: "Comparaison",
        message: "Message",
        placement: "Emplacement",
        showWhere: "Pages d'affichage",
        openMode: "Mode d'ouverture",
        feedSource: "Source du flux",
        feedTheme: "Th\xE8me",
        schedule: "Horaire",
        review: "V\xE9rification"
      },
      review: {
        title: "V\xE9rifier votre campagne",
        edit: "Modifier",
        nameLabel: "Nom de la campagne",
        create: "Cr\xE9er la campagne"
      },
      next: {
        title: "Campagne cr\xE9\xE9e !",
        saved: "{{name}} a \xE9t\xE9 enregistr\xE9e.",
        viewCampaigns: "Voir les campagnes",
        emailPlaceholder: "Votre campagne courriel est pr\xEAte. Utilisez l'\xE9cran de r\xE9daction pour l'envoyer \xE0 vos prospects.",
        feed: "Votre campagne de flux est active et alimentera automatiquement votre flux publicitaire Meta.",
        auto: "Votre campagne s'ouvrira automatiquement sur les pages {{targets}} pour les visiteurs de votre site.",
        link: "Partagez ce lien o\xF9 vous voulez \u2014 toute personne qui l'ouvre verra votre campagne.",
        draftReminder: "Cette campagne est un brouillon. Activez-la lorsque vous \xEAtes pr\xEAt \xE0 la mettre en ligne.",
        linkBase: "URL de base",
        linkBasePlaceholder: "https://votresite.com/inventaire",
        linkParamsHint: "Les param\xE8tres de la campagne sont ajout\xE9s automatiquement.",
        linkInvalid: "Entrez une URL valide pour g\xE9n\xE9rer le lien d'aper\xE7u.",
        linkGuidance: "Ajoutez ce lien \xE0 vos courriels, publicit\xE9s ou tout autre mat\xE9riel marketing pour ouvrir la campagne.",
        downloadQr: "T\xE9l\xE9charger le code QR",
        openPreview: "Ouvrir l'aper\xE7u",
        copyLink: "Copier le lien",
        copiedLink: "Copi\xE9 !",
        qrFailed: "Impossible de g\xE9n\xE9rer le code QR. Veuillez r\xE9essayer."
      },
      goal: {
        question: "Quel est l'objectif de votre campagne ?",
        promote: "Promouvoir un V\xC9",
        promoteDescription: "Mettez en valeur un v\xE9hicule \xE9lectrique aupr\xE8s des acheteurs int\xE9ress\xE9s.",
        leads: "G\xE9n\xE9rer des prospects",
        leadsDescription: "Recueillez les coordonn\xE9es des acheteurs potentiels.",
        feed: "Flux Meta",
        feedDescription: "Alimentez automatiquement un flux publicitaire Meta AIA ou AMA.",
        email: "Campagne courriel",
        emailDescription: "Envoyez un courriel personnalis\xE9 \xE0 un prospect.",
        describe: "\u2728 D\xE9crivez votre objectif (bient\xF4t disponible)"
      },
      vehicle: {
        question: "Quel v\xE9hicule souhaitez-vous mettre en avant ?"
      },
      comparison: {
        question: "Ajouter un v\xE9hicule de comparaison ?",
        evLabel: "V\xE9hicule \xE9lectrique",
        gasLabel: "V\xE9hicule \xE0 essence",
        bestMatch: "Meilleure correspondance",
        choosePrompt: "S\xE9lectionner un v\xE9hicule de comparaison",
        changeVehicle: "Changer de v\xE9hicule"
      },
      message: {
        question: "Personnalisez votre message"
      },
      placement: {
        question: "O\xF9 la campagne doit-elle appara\xEEtre ?",
        auto: "Automatique",
        autoDescription: "S'ouvre automatiquement lorsqu'un visiteur arrive sur la page.",
        link: "Param\xE8tre URL",
        linkDescription: "S'ouvre uniquement lorsqu'un param\xE8tre de requ\xEAte est pr\xE9sent dans l'URL."
      },
      showWhere: {
        question: "Sur quelles pages cette campagne doit-elle s'afficher ?",
        vdp: "Page de d\xE9tail du v\xE9hicule",
        vdpDescription: "S'affiche sur les pages de fiche individuelle de chaque v\xE9hicule.",
        srp: "Page de r\xE9sultats de recherche",
        srpDescription: "S'affiche sur les pages de recherche et de r\xE9sultats d'inventaire.",
        specific: "Pages sp\xE9cifiques",
        specificDescription: "Restreindre la campagne aux URLs ou domaines que vous d\xE9finissez.",
        specificHint: "Saisissez les URLs ou domaines o\xF9 cette campagne doit s'afficher. Les jokers sont pris en charge, ex. *.concessionnaire.com."
      },
      openMode: {
        question: "\xC0 quelle fr\xE9quence la campagne doit-elle s'ouvrir ?",
        autoSession: "Une fois par session",
        autoSessionDescription: "S'ouvre automatiquement \u2014 au plus une fois par visite.",
        autoDay: "Une fois par jour",
        autoDayDescription: "S'ouvre automatiquement \u2014 au plus une fois par jour par visiteur.",
        autoWeek: "Une fois par semaine",
        autoWeekDescription: "S'ouvre automatiquement \u2014 au plus une fois par semaine par visiteur.",
        autoOnce: "Une seule fois",
        autoOnceDescription: "S'ouvre automatiquement \u2014 seulement la premi\xE8re fois qu'un visiteur la voit.",
        link: "\xC0 la demande (param\xE8tre URL)",
        linkDescription: "S'ouvre uniquement lorsque d\xE9clench\xE9 par un lien que vous partagez ou int\xE9grez."
      },
      tuneMessage: {
        question: "Affinez votre message"
      },
      feedSource: {
        question: "Quel type de flux Meta ?",
        aia: "Flux Meta AIA",
        aiaDescription: "L'inventaire est automatiquement extrait de votre catalogue Meta Automotive Inventory Ads.",
        ama: "Flux Meta AMA",
        amaDescription: "Les cr\xE9atifs sont g\xE9n\xE9r\xE9s automatiquement depuis votre campagne Meta Automotive Marketing Ads."
      },
      feedTheme: {
        question: "Quel th\xE8me de flux ?",
        fuel_savingsDescription: "Met en avant les \xE9conomies r\xE9alis\xE9es sur le carburant en passant \xE0 un V\xC9.",
        maintenance_savingsDescription: "Met en avant les co\xFBts d'entretien r\xE9duits des v\xE9hicules \xE9lectriques sur le long terme.",
        rangeDescription: "Met en avant l'autonomie et la commodit\xE9 de recharge de vos mod\xE8les \xE9lectriques."
      },
      schedule: {
        question: "D\xE9finir un calendrier (facultatif)",
        now: "D\xE9marrer imm\xE9diatement",
        nowDescription: "La campagne est mise en ligne d\xE8s que vous enregistrez.",
        window: "D\xE9finir une plage de dates",
        windowDescription: "Choisissez une date de d\xE9but et de fin pour la campagne.",
        windowHint: "Les deux dates sont facultatives. D\xE9but seulement \u2192 la campagne d\xE9marre \xE0 cette date et s'ex\xE9cute jusqu'\xE0 ce que vous l'arr\xEAtiez. Fin seulement \u2192 la campagne est active imm\xE9diatement et se termine \xE0 cette date. Les deux \u2192 la campagne s'ex\xE9cute pendant cette plage.",
        endBeforeStart: "La date de fin doit \xEAtre identique ou post\xE9rieure \xE0 la date de d\xE9but."
      },
      emailMessage: {
        question: "R\xE9digez votre courriel",
        subject: "Objet du courriel",
        subjectDefault: "Des \xE9conomies exclusives sur un V\xC9 pour vous"
      },
      emailCompose: {
        title: "Envoyer \xE0 un client",
        channelEmail: "Courriel",
        vehicleLabel: "V\xE9hicule",
        firstName: "Pr\xE9nom du client",
        firstNamePlaceholder: "ex. : Alex",
        greeting: "Bonjour {{name}},",
        greetingGeneric: "Bonjour,",
        tab: {
          email: "Courriel",
          text: "Texte"
        },
        copyEmail: "Copier le courriel",
        openMail: "Ouvrir dans le client courriel",
        copyText: "Copier le texte",
        openSms: "Ouvrir dans les messages",
        downloadQr: "T\xE9l\xE9charger le code QR",
        copied: "Copi\xE9 !"
      },
      sheet: {
        title: "Fiche de campagne",
        print: "Imprimer la fiche de campagne",
        printBrowser: "Imprimer (navigateur)",
        printing: "G\xE9n\xE9ration du PDF\u2026",
        loading: "Chargement de la fiche de campagne\u2026",
        error: "Impossible de charger la fiche de campagne.",
        imagePlaceholder: "Image du v\xE9hicule",
        qrAlt: "Code QR de la campagne"
      },
      sections: {
        moveUp: "D\xE9placer vers le haut",
        moveDown: "D\xE9placer vers le bas",
        remove: "Supprimer la section",
        add: "Ajouter {{section}}",
        savings: "\xC9conomies",
        incentives: "Incitatifs",
        battery_charging: "Batterie et recharge",
        key_trade_offs: "Points de comparaison cl\xE9s"
      }
    }
  },
  tesla: {
    title: "Tesla",
    tabs: {
      quickLookup: "Recherche rapide",
      fleet: "Parc Tesla"
    },
    lookup: {
      autonomy: "Autonomie",
      batteryCapacity: "Capacit\xE9 de la batterie",
      configuration: "Configuration d'usine",
      dataUnavailable: "Donn\xE9es indisponibles",
      disclaimer: "Ces donn\xE9es proviennent de Tesla et peuvent \xEAtre inexactes \u2014 v\xE9rifiez-les sur le v\xE9hicule. Destin\xE9es aux v\xE9hicules que vous poss\xE9dez.",
      emptyDescription: "R\xE9cup\xE8re la configuration d'usine et les donn\xE9es de batterie directement aupr\xE8s de Tesla.",
      emptyTitle: "Rechercher une Tesla par NIV",
      invalidVin: "Un NIV comporte {{length}} caract\xE8res \u2014 v\xE9rifiez celui que vous avez saisi.",
      kwh: "kWh",
      measuredOn: "Mesur\xE9 le {{date}}",
      noData: {
        title: "Aucune donn\xE9e Tesla pour ce NIV",
        notFound: "Tesla n'a aucun enregistrement pour ce NIV. Il ne s'agit peut-\xEAtre pas d'une Tesla, ou le v\xE9hicule est ant\xE9rieur \xE0 leurs donn\xE9es.",
        invalid: "Ce NIV n'est pas celui d'une Tesla. La recherche rapide ne couvre que les v\xE9hicules Tesla \u2014 les autres marques n\xE9cessitent un scan Lyteflo.",
        timeout: "Tesla n'a pas r\xE9pondu \xE0 temps. R\xE9essayez dans un instant.",
        error: "Une erreur s'est produite lors de la lecture de ce NIV. R\xE9essayez dans un instant.",
        empty: "Tesla poss\xE8de un enregistrement pour ce NIV mais n'a renvoy\xE9 aucun d\xE9tail."
      },
      notProvided: "Tesla ne fournit pas cette donn\xE9e pour ce v\xE9hicule.",
      superchargingNotReported: "Tesla n'a pas indiqu\xE9 de formule de Superchargement pour ce v\xE9hicule.",
      optionsTotal: "{{price}} des options list\xE9es",
      readFromTeslaOn: "Relev\xE9 aupr\xE8s de Tesla le {{date}}.",
      requestFailed: "Impossible de joindre Tesla. R\xE9essayez dans un instant.",
      scan: "Scanner un NIV",
      scanSuccess: "NIV scann\xE9",
      stateOfHealth: "\xC9tat de sant\xE9",
      submit: "Rechercher",
      supercharging: "Superchargement",
      usage: {
        counter_one: "{{used}} sur {{limit}} recherche utilis\xE9e ce mois-ci",
        counter_other: "{{used}} sur {{limit}} recherches utilis\xE9es ce mois-ci",
        counterLifetime_one: "{{used}} sur {{limit}} recherche utilis\xE9e",
        counterLifetime_other: "{{used}} sur {{limit}} recherches utilis\xE9es",
        limitFree_one: "Vous avez atteint votre limite de {{limit}} recherche. <contact>Contactez-nous</contact> pour ajouter des recherches suppl\xE9mentaires.",
        limitFree_other: "Vous avez atteint votre limite de {{limit}} recherches. <contact>Contactez-nous</contact> pour ajouter des recherches suppl\xE9mentaires.",
        limitFreeLifetime_one: "Vous avez atteint votre limite de {{limit}} recherche. Cette limite ne se renouvelle pas. <contact>Contactez-nous</contact> pour ajouter des recherches suppl\xE9mentaires.",
        limitFreeLifetime_other: "Vous avez atteint votre limite de {{limit}} recherches. Cette limite ne se renouvelle pas. <contact>Contactez-nous</contact> pour ajouter des recherches suppl\xE9mentaires.",
        limitPaid_one: "Vous avez utilis\xE9 {{used}} de votre {{limit}} recherche ce mois-ci. Les recherches restent disponibles.",
        limitPaid_other: "Vous avez utilis\xE9 {{used}} de vos {{limit}} recherches ce mois-ci. Les recherches restent disponibles.",
        warning_one: "Vous avez utilis\xE9 {{used}} de votre {{limit}} recherche ce mois-ci.",
        warning_other: "Vous avez utilis\xE9 {{used}} de vos {{limit}} recherches ce mois-ci.",
        warningLifetime_one: "Vous avez utilis\xE9 {{used}} de votre {{limit}} recherche. Cette limite ne se renouvelle pas.",
        warningLifetime_other: "Vous avez utilis\xE9 {{used}} de vos {{limit}} recherches. Cette limite ne se renouvelle pas."
      },
      vinLabel: "NIV du v\xE9hicule",
      vinPlaceholder: "Saisissez un NIV de 17 caract\xE8res"
    },
    history: {
      clear: "Effacer l'historique",
      count: "{{count}} sur {{limit}}",
      empty: "Les NIV que vous recherchez apparaissent ici, pr\xEAts \xE0 \xEAtre rouverts. Les {{limit}} derniers sont conserv\xE9s.",
      soh: "SOH",
      title: "Recherches r\xE9centes"
    },
    batch: {
      open: "Recherche par lot",
      title: "Recherche par lot",
      description: "Ajoutez les NIV un par un, ou collez une colonne enti\xE8re \u2014 nous la d\xE9couperons.",
      inputLabel: "NIV \xE0 rechercher",
      inputPlaceholder: "Saisissez ou collez des NIV",
      remove: "Retirer le NIV",
      tesla: "Tesla",
      notTesla: "Pas une Tesla",
      invalidLength: "{{length}} caract\xE8res sur 17",
      invalidChars: "NIV invalide",
      unresolvedSummary: "{{found}} NIV sur {{requested}} ont renvoy\xE9 des donn\xE9es. Aucune donn\xE9e Tesla pour {{vins}}.",
      count_one: "{{count}} dans ce lot",
      count_other: "{{count}} dans ce lot",
      clearAll: "Tout effacer",
      empty: "Rien pour l'instant. Collez une colonne de NIV, ou ajoutez-les un par un.",
      submit_one: "Rechercher {{count}} NIV",
      submit_other: "Rechercher {{count}} NIV",
      submitEmpty: "Rechercher",
      duplicatesIgnored_one: "{{count}} doublon ignor\xE9",
      duplicatesIgnored_other: "{{count}} doublons ignor\xE9s",
      overLimitDropped_one: "{{count}} NIV retir\xE9 \u2014 un lot est limit\xE9 \xE0 {{limit}}",
      overLimitDropped_other: "{{count}} NIV retir\xE9s \u2014 un lot est limit\xE9 \xE0 {{limit}}"
    },
    fleet: {
      inventory: "Inventaire",
      searchPlaceholder: "Rechercher un v\xE9hicule, un NIV ou un propri\xE9taire",
      noResults: "Aucun v\xE9hicule ne correspond \xE0 ce filtre.",
      generate: "G\xE9n\xE9rer un certificat",
      requestCustomer: "Demander \xE0 un client",
      notConnectedNotice: "Aucun compte Tesla connect\xE9 : vos propres v\xE9hicules n'apparaissent donc pas ici. <connect>Connectez votre compte</connect> pour g\xE9n\xE9rer leurs certificats \u2014 les demandes envoy\xE9es aux clients fonctionnent dans tous les cas.",
      table: {
        date: "Date",
        vehicle: "V\xE9hicule",
        vin: "NIV",
        owner: "Propri\xE9taire",
        odometer: "Odom\xE8tre",
        charge: "Charge",
        batteryHealth: "Sant\xE9 de la batterie",
        vehicleStatus: "\xC9tat du v\xE9hicule",
        certificateStatus: "\xC9tat du certificat"
      },
      filters: {
        myFleet: "Mon parc",
        appraisals: "\xC9valuations",
        appraisalsUnavailable: "\xC9valuations \u2014 bient\xF4t disponible",
        needsCertificate: "Certificat \xE0 produire",
        allVehicles: "Tous les v\xE9hicules"
      },
      vehicleStatus: {
        ready: "Pr\xEAt",
        waitingOnOwner: "En attente du propri\xE9taire",
        needsVirtualKey: "Cl\xE9 virtuelle requise",
        needsSafetyToggle: "R\xE9glage \xE0 activer dans le v\xE9hicule",
        needsFirmwareUpdate: "Mise \xE0 jour Tesla requise",
        atConfigLimit: "Limite de connexions Tesla atteinte",
        offline: "Hors ligne",
        emailFailed: "\xC9chec de l'envoi du courriel",
        expired: "Lien expir\xE9",
        cancelled: "Annul\xE9e",
        unsupported: "Non pris en charge",
        unknown: "Non d\xE9termin\xE9"
      },
      certificateStatus: {
        ready: "G\xE9n\xE9r\xE9",
        starting: "D\xE9marrage"
      },
      actions: {
        certificate: "Certificat",
        generate: "G\xE9n\xE9rer",
        unavailable: {
          notSingleDealership: {
            name: "G\xE9n\xE9rer \u2014 s\xE9lectionnez un seul concessionnaire",
            hint: "S\xE9lectionnez un seul concessionnaire"
          },
          dealershipConfigUnavailable: {
            name: "G\xE9n\xE9rer \u2014 impossible de charger la configuration de ce concessionnaire",
            hint: "Impossible de charger la configuration de ce concessionnaire. R\xE9essayez dans un instant."
          },
          runStateUnknown: {
            name: "G\xE9n\xE9rer \u2014 v\xE9rification des certificats d\xE9j\xE0 en cours",
            hint: "V\xE9rification en cours pour savoir si un certificat est d\xE9j\xE0 en cours de g\xE9n\xE9ration pour ce v\xE9hicule. Actualisez pour r\xE9essayer."
          }
        },
        resend: "Renvoyer l'invitation",
        cancel: "Annuler la demande",
        retry: "G\xE9n\xE9rer de nouveau"
      },
      generation: {
        waiting: {
          wakingVehicle: "R\xE9veil du v\xE9hicule",
          readingBattery: "Lecture de la batterie",
          checkingCells: "V\xE9rification des cellules",
          buildingCertificate: "Cr\xE9ation du certificat"
        },
        requestRefused: "Impossible de d\xE9marrer le certificat \u2014 r\xE9essayez",
        requestRefusedNoDealership: "S\xE9lectionnez un seul concessionnaire avant de g\xE9n\xE9rer un certificat",
        requestRefusedStarting: "Une g\xE9n\xE9ration est d\xE9j\xE0 en cours pour ce v\xE9hicule. R\xE9essayez dans un instant.",
        forVehicle: "{{vehicle}} : {{condition}}",
        notReady: {
          needsVirtualKey: "Le propri\xE9taire doit ajouter la cl\xE9 virtuelle de Lyteflo dans l'application Tesla.",
          needsSafetyToggle: "Le propri\xE9taire doit activer le partage de donn\xE9es sur l'\xE9cran tactile du v\xE9hicule.",
          needsFirmwareUpdate: "Ce v\xE9hicule doit recevoir une mise \xE0 jour logicielle avant qu'un rapport puisse \xEAtre g\xE9n\xE9r\xE9.",
          unsupported: "Ce v\xE9hicule ne prend pas en charge les rapports de batterie.",
          accountNeedsReconnect: "Le compte Tesla de ce v\xE9hicule doit \xEAtre reconnect\xE9.",
          notConnected: "Ce v\xE9hicule n'est plus connect\xE9 \xE0 votre concessionnaire.",
          offline: "Ce v\xE9hicule est hors ligne. R\xE9veillez-le depuis l'application Tesla ou v\xE9rifiez qu'il capte le r\xE9seau cellulaire ou le Wi-Fi, puis r\xE9essayez.",
          unknownCondition: "Tesla indique que ce v\xE9hicule n'est pas pr\xEAt pour un rapport de batterie."
        },
        failure: {
          label: "\xC9chec de la g\xE9n\xE9ration",
          help: "R\xE9essayez, ou <0>contactez le support</0> si cela persiste."
        },
        debug: {
          open: "D\xE9bogage",
          title: "D\xE9bogage de la g\xE9n\xE9ration",
          sessionId: "ID de session",
          vin: "VIN",
          configurationId: "ID du concessionnaire",
          events: "\xC9v\xE9nements",
          vehicleStatus: "\xC9tat du v\xE9hicule",
          vehicleState: "Connectivit\xE9",
          blocker: "Verdict de disponibilit\xE9",
          reportId: "ID du rapport",
          noSession: "Aucune ex\xE9cution pour ce v\xE9hicule n'est conserv\xE9e dans ce navigateur."
        }
      },
      pairing: {
        virtualKey: {
          title: "Ajoutez d'abord la cl\xE9 virtuelle de Lyteflo",
          body: "Cette Tesla ne peut pas transmettre les donn\xE9es de sa batterie tant que la cl\xE9 virtuelle de Lyteflo n'y est pas ajout\xE9e. Ouvrez le lien sur le t\xE9l\xE9phone o\xF9 se trouve l'application Tesla, touchez <0>Autoriser</0>, puis choisissez ce v\xE9hicule.",
          confirm: "J'ai appair\xE9 mon v\xE9hicule"
        },
        safetyToggle: {
          title: "Activez le partage de donn\xE9es dans le v\xE9hicule",
          body: "Cette Tesla n'utilise pas de cl\xE9 virtuelle : il n'y a rien \xE0 ajouter dans l'application Tesla. Sur l'\xE9cran tactile du v\xE9hicule, ouvrez <0>Commandes \u203A S\xE9curit\xE9</0> et activez <1>Autoriser la diffusion de donn\xE9es aux applications tierces</1>.",
          confirm: "J'ai activ\xE9 le partage de donn\xE9es"
        },
        notDetermined: {
          title: "Nous ne connaissons pas encore cette Tesla",
          body: "Tesla ne nous en a pas assez dit sur ce v\xE9hicule pour lire sa batterie. Ce n'est pas une anomalie \u2014 r\xE9essayez dans quelques minutes."
        },
        action: "Appairer le v\xE9hicule",
        qrAlt: "Code QR du lien d'appairage Tesla",
        done: "V\xE9rifier de nouveau ce v\xE9hicule",
        prerequisite: "L'appairage ne fonctionne que si le propri\xE9taire a configur\xE9 une cl\xE9 de t\xE9l\xE9phone dans l'application Tesla.",
        prerequisiteLink: "Fonctionnement des cl\xE9s de t\xE9l\xE9phone Tesla",
        scanOption: "Scannez ce code avec le t\xE9l\xE9phone o\xF9 se trouve l'application Tesla",
        linkOption: "Ou ouvrez ce lien sur ce t\xE9l\xE9phone",
        checking: "V\xE9rification du v\xE9hicule\u2026",
        readyTitle: "Cette Tesla est pr\xEAte",
        readyBody: "G\xE9n\xE9rez son certificat maintenant, ou fermez et revenez-y plus tard.",
        generate: "G\xE9n\xE9rer le certificat",
        pending: "Tesla n'a pas encore confirm\xE9 l'appairage. Patientez un instant, puis v\xE9rifiez de nouveau.",
        checkAgain: "V\xE9rifier de nouveau",
        checkFailed: "Nous n'avons pas pu joindre ce v\xE9hicule. R\xE9essayez dans un instant.",
        blocked: "Cette Tesla ne peut toujours pas transmettre les donn\xE9es de sa batterie. Son \xE9tat sur la ligne en donne la raison.",
        support: {
          prompt: "Toujours bloqu\xE9 ? Envoyez-nous les d\xE9tails de ce v\xE9hicule \xE0",
          subject: "L'appairage Tesla n'a pas abouti",
          dealershipName: "Nom du concessionnaire",
          configurationId: "ID du concessionnaire",
          connectivity: "Connectivit\xE9",
          virtualKeyPaired: "Cl\xE9 virtuelle appair\xE9e",
          dataSharingEnabled: "Partage de donn\xE9es activ\xE9",
          consentMethod: "M\xE9thode de consentement",
          consentMethodVirtualKey: "Cl\xE9 virtuelle",
          consentMethodSafetyToggle: "R\xE9glage de partage de donn\xE9es du v\xE9hicule",
          consentMethodNone: "Aucune",
          consentMethodUnknown: "Pas encore d\xE9termin\xE9",
          separator: " : ",
          yes: "Oui",
          no: "Non",
          online: "En ligne"
        }
      },
      error: {
        resendFailed: "Impossible de renvoyer cette invitation. R\xE9essayez dans un instant.",
        cancelFailed: "Impossible d'annuler cette demande. R\xE9essayez dans un instant."
      },
      intro: {
        title: "Des certificats de batterie pour les Tesla, sans bo\xEEtier \xE0 brancher",
        ownInventory: {
          title: "Votre propre inventaire",
          body: "Choisissez une Tesla de votre compte et g\xE9n\xE9rez le certificat. Personne d'autre n'a besoin d'intervenir."
        },
        customerVehicle: {
          title: "La Tesla d'un client",
          body: "Envoyez un lien au propri\xE9taire. Il autorise l'acc\xE8s, choisit le v\xE9hicule, et le certificat vous parvient \xE0 vous deux."
        },
        settingsLink: "Param\xE8tres \u203A Comptes Tesla"
      }
    },
    options: {
      acceleration: "Acc\xE9l\xE9ration",
      autopilot_computer: "Ordinateur de Conduite automatique",
      climate: "Climatisation",
      connectivity: "Connectivit\xE9",
      exterior_color: "Couleur ext\xE9rieure",
      heated_seats: "Si\xE8ges chauffants",
      infotainment_processor: "Processeur d'infodivertissement",
      interior_color: "Int\xE9rieur",
      interior_decor: "D\xE9cor int\xE9rieur",
      leather_trim: "Finition cuir",
      performance_upgrade: "Am\xE9lioration Performance",
      seats: "Si\xE8ges",
      towing: "Attelage",
      wheels: "Roues",
      yoke_steering: "Direction"
    },
    descriptions: {
      acceleration_boost: "Un d\xE9blocage logiciel \xE0 distance qui retire environ une demi-seconde au 0 \xE0 100 km/h.",
      amd_ryzen_with_grok_ai_support: "La g\xE9n\xE9ration d'infodivertissement la plus rapide de Tesla, avec des graphismes 3D plus riches, toute la biblioth\xE8que Arcade et l'assistant Grok AI.",
      base_autopilot: "R\xE9gulateur de vitesse dynamique avec Assistance au maintien de cap. Sous supervision du conducteur.",
      cold_weather_feature: "Volant chauffant, d\xE9givrage des balais d'essuie-glace et gicleurs de lave-glace chauffants.",
      enhanced_autopilot: "Navigation avec Assistance au maintien de cap, changement de voie automatique, stationnement automatique, Sortie automatique passive et Sortie automatique intelligente am\xE9lior\xE9e. Sous supervision du conducteur.",
      extended_nappa_leather: "Cuir Nappa \xE9tendu au-del\xE0 des si\xE8ges, sur la planche de bord et les surfaces de l'habitacle.",
      free_unlimited_supercharging: "Superchargement gratuit et illimit\xE9, transf\xE9r\xE9 au prochain propri\xE9taire.",
      free_unlimited_supercharging_non_transferable: "Superchargement gratuit et illimit\xE9 pour le propri\xE9taire actuel. Il n'est pas transf\xE9r\xE9 \xE0 la vente.",
      full_self_driving: "Assistance au maintien de cap en ville, Navigation avec Assistance au maintien de cap, stationnement automatique, Sortie automatique et contr\xF4le des feux de circulation et des panneaux d'arr\xEAt, inclus pour toute la dur\xE9e de vie du v\xE9hicule. Sous supervision du conducteur.",
      hardware_1: "Traitement d'image Mobileye EyeQ3. Prend en charge uniquement la Conduite automatique.",
      hardware_2: "NVIDIA DRIVE PX 2, pilotant huit cam\xE9ras et un radar avant.",
      hardware_2_5: "NVIDIA DRIVE PX 2, pilotant huit cam\xE9ras et un radar avant.",
      hardware_3: "L'ordinateur de Conduite automatique con\xE7u par Tesla, qui remplace la plateforme NVIDIA utilis\xE9e auparavant.",
      hardware_4: "Le dernier ordinateur de Conduite automatique de Tesla, avec des cam\xE9ras haute r\xE9solution et plusieurs fois la puissance de calcul du Mat\xE9riel 3.0.",
      heated_rear_seats: "Si\xE8ges arri\xE8re lat\xE9raux chauffants.",
      intel_atom: "Infodivertissement plus rapide, avec la diffusion vid\xE9o Th\xE9\xE2tre et les jeux Arcade.",
      lifetime_premium_connectivity: "Cartes satellite, trafic en direct, diffusion de musique et de vid\xE9o et navigation web, inclus pour toute la dur\xE9e de vie du v\xE9hicule.",
      ludicrous_mode: "Le mode de conduite le plus performant, qui lib\xE8re l'acc\xE9l\xE9ration maximale du v\xE9hicule.",
      no_access_to_supercharger_network: "Ce v\xE9hicule ne peut pas se recharger sur le r\xE9seau de Superchargement.",
      no_autopilot: "Aucun pack d'aide \xE0 la conduite n'est actif. Le mat\xE9riel de Conduite automatique peut \xEAtre install\xE9, mais le conducteur reste responsable de la vitesse, de la direction et de la distance de suivi.",
      no_tow_package: "Aucun pack remorquage d'usine : ni boule d'attelage, ni faisceau, ni mode Remorque.",
      nvidia_tegra_3: "L'ordinateur d'infodivertissement Tesla d'origine, bas\xE9 sur un processeur NVIDIA Tegra 3.",
      pay_per_use_supercharging: "Le Superchargement est factur\xE9 au tarif standard par session ; rien n'est inclus avec le v\xE9hicule.",
      premium_autopilot_firmware: "Le micrologiciel d'aide \xE0 la conduite de Tesla sur le Cybertruck. L'assistance \xE0 la vitesse et \xE0 la distance de suivi est incluse ; la liste d'\xE9quipements du v\xE9hicule indique le reste. Sous supervision du conducteur.",
      premium_connectivity: "Cartes satellite, trafic en direct, diffusion de musique et de vid\xE9o et navigation web, sur abonnement.",
      round_steering_wheel: "Le volant rond conventionnel plut\xF4t qu\u2019un yoke.",
      standard_connectivity: "Navigation et cartes de base en Wi-Fi. Ni trafic en direct, ni diffusion, ni navigation web.",
      subzero_weather_package: "Volant chauffant, si\xE8ges arri\xE8re chauffants, r\xE9troviseurs ext\xE9rieurs chauffants, d\xE9givrage des balais d'essuie-glace et gicleurs de lave-glace chauffants.",
      time_bound_supercharging: "Le Superchargement \xE9tait inclus sans frais jusqu'\xE0 une date fixe. Tesla ne communique pas cette date : consid\xE9rez-le comme peut-\xEAtre expir\xE9.",
      tow_hitch: "Attelage d'usine : boule d'attelage, faisceau \xE9lectrique et mode Remorque avec contr\xF4le du louvoiement.",
      traffic_aware_cruise_control: "R\xE9gulateur de vitesse dynamique qui s'aligne sur la vitesse du v\xE9hicule devant et maintient une distance de suivi d\xE9finie.",
      yoke_steering: "Un yoke \xE0 la place du volant rond conventionnel."
    }
  },
  teslaAccount: {
    title: "Comptes Tesla",
    selectDealership: "Choisissez une concession dans le s\xE9lecteur ci-dessus pour voir ses comptes Tesla.",
    notConnected: {
      title: "Connectez un compte Tesla \xE0 votre concession",
      description: "Connectez votre compte Tesla une seule fois et Lyteflo g\xE9n\xE8re des certificats de batterie \xE0 distance. Aucun c\xE2ble, aucune immobilisation en atelier.",
      reads: {
        fleet: "Tout votre parc Tesla en un coup d'\u0153il",
        warranty: "Statut de la garantie d'usine de la batterie et du groupe motopropulseur",
        stateOfCharge: "\xC9tat de charge quotidien"
      },
      readOnly: "Lecture seule. Lyteflo ne peut ni d\xE9verrouiller, ni conduire, ni recharger, ni modifier quoi que ce soit sur ces v\xE9hicules.",
      connect: "Connecter un compte Tesla",
      copyLink: "Copier le lien de connexion",
      copyLinkCopied: "Lien copi\xE9",
      copyLinkHint: "La personne qui d\xE9tient les identifiants Tesla peut se connecter depuis son propre appareil. Un lien est valide 48 heures.",
      linkShared: "Rien d'autre \xE0 faire ici \u2014 cette page se met \xE0 jour \xE0 votre retour.",
      error: "Nous n'avons pas pu joindre Tesla. R\xE9essayez dans un instant.",
      popupBlocked: "Votre navigateur a bloqu\xE9 l'onglet de connexion Tesla. Copiez le lien de connexion ci-dessous et ouvrez-le vous-m\xEAme.",
      readFailed: "Nous n'avons pas pu v\xE9rifier si un compte Tesla est connect\xE9. R\xE9essayez dans un instant.",
      consentLocation: "La connexion partage aussi la position de vos v\xE9hicules avec Lyteflo, en plus des donn\xE9es de batterie."
    },
    waiting: {
      title: "En attente de Tesla",
      description: "Terminez la connexion dans l'onglet Tesla. Cette page se met \xE0 jour d'elle-m\xEAme une fois le compte connect\xE9.",
      timedOutTitle: "Toujours pas connect\xE9",
      timedOutDescription: "Nous avons cess\xE9 de v\xE9rifier. Si vous avez termin\xE9 la connexion \xE0 Tesla, v\xE9rifiez de nouveau.",
      checkAgain: "V\xE9rifier de nouveau",
      pollError: "Nous n'avons pas pu joindre Tesla lors de la derni\xE8re v\xE9rification.",
      startOver: "Recommencer"
    },
    connected: {
      title: "Vos Tesla sont sur Tesla Fleet",
      description: "Les certificats y sont g\xE9n\xE9r\xE9s, et chaque v\xE9hicule indique s'il en a encore besoin.",
      goToFleet: "Aller au Parc Tesla",
      facts: {
        vehicles: "V\xE9hicules",
        accounts: "Comptes"
      }
    },
    health: {
      status: {
        ok: "Connect\xE9",
        needs_reconnect: "D\xE9connect\xE9",
        refresh_failed: "D\xE9connect\xE9"
      },
      reason: {
        refresh_token_invalid: "Tesla n'accepte plus la connexion de ce compte. Reconnectez-le \u2014 sans cela, ces v\xE9hicules ne seront plus mis \xE0 jour.",
        tesla_unavailable: "Nous n'avons pas pu joindre Tesla pour ce compte : vous voyez donc les derni\xE8res donn\xE9es lues. Nous r\xE9essayons automatiquement \u2014 vous n'avez rien \xE0 faire.",
        rate_limited: "Tesla limite la fr\xE9quence de nos lectures sur ce compte : vous voyez donc les derni\xE8res donn\xE9es lues. Nous rattraperons le retard \u2014 vous n'avez rien \xE0 faire.",
        unknown: "Ce compte ne s'est pas mis \xE0 jour, sans raison identifi\xE9e : vous voyez donc les derni\xE8res donn\xE9es lues. Nous r\xE9essayons \u2014 vous n'avez rien \xE0 faire."
      },
      connectedBy: "Connect\xE9 par {{name}}",
      connectedByOn: "Connect\xE9 par {{name}} le {{date}}",
      teslaId: "ID Tesla : {{id}}",
      addOrReconnect: "Ajouter ou reconnecter un compte",
      addOrReconnectHint: "Le compte Tesla avec lequel vous vous connectez est celui qui sera ajout\xE9 ou reconnect\xE9."
    }
  }
};

// src/translations/index.ts
var sharedTranslations = {
  en: en_default,
  fr: fr_default
};
var portalTranslations = {
  en: en_default2,
  fr: fr_default2
};
var translations_default = sharedTranslations;
export {
  portalTranslations,
  translations_default as sharedTranslations
};
//# sourceMappingURL=index.mjs.map